'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var t = require('prop-types');
var React$1 = require('react');
var Utils = require('arm-common');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var _ = require('lodash');
var Datetime = require('react-datetime');
var moment = require('moment');
require('lodash/debounce');
var update = require('immutability-helper');
var update$1 = require('react-addons-update');
var jquery = require('jquery');
var reactVirtualized = require('react-virtualized');
var Select2 = require('react-select');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var t__default = /*#__PURE__*/_interopDefaultLegacy(t);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React$1);
var Utils__default = /*#__PURE__*/_interopDefaultLegacy(Utils);
var PureRenderMixin__default = /*#__PURE__*/_interopDefaultLegacy(PureRenderMixin);
var ___default = /*#__PURE__*/_interopDefaultLegacy(_);
var Datetime__default = /*#__PURE__*/_interopDefaultLegacy(Datetime);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var update__default = /*#__PURE__*/_interopDefaultLegacy(update);
var update__default$1 = /*#__PURE__*/_interopDefaultLegacy(update$1);
var jquery__default = /*#__PURE__*/_interopDefaultLegacy(jquery);
var Select2__default = /*#__PURE__*/_interopDefaultLegacy(Select2);

var name = "arm-gui";
var version = "3.0.10";
var author = "Armundia Group";
var homepage = "http://www.armundia.com";
var main = "./dist/controls/index.js";
var license = "Armundia";
var files = [
	"dist"
];
var devDependencies = {
	"arm-core-layouts": "^0.1.1",
	"arm-gulp-builders": "^1.1.0",
	"arm-themes": "^1.1.1",
	"eslint-plugin-import": "^2.22.0",
	"eslint-plugin-react": "^7.20.3",
	react: "^16.13.1",
	"react-dom": "^16.13.1",
	"react-redux": "^7.2.0",
	redux: "^4.0.5",
	"arm-visual-component": "^2.1.0",
	"redux-thunk": "^2.3.0"
};
var dependencies = {
	"arm-common": "^1.0.3",
	"decimal.js": "^10.2.0",
	"immutability-helper": "^3.0.1",
	jquery: "^3.5.1",
	lodash: "^4.17.11",
	moment: "^2.24.0",
	"prop-types": "^15.7.2",
	"react-addons-pure-render-mixin": "^15.6.2",
	"react-addons-update": "^15.6.2",
	"react-datetime": "^2.11.1",
	"react-json-view": "^1.19.1",
	"react-select": "^1.3.0",
	"react-virtualized": "^9.21.0"
};
var scripts = {
	beta: "npm version prerelease --preid=beta && gulp npm && npm publish",
	patch: "npm version patch && gulp npm && npm publish",
	minor: "npm version minor && gulp npm && npm publish",
	major: "npm version major && gulp npm && npm publish"
};
var publishConfig = {
	registry: "http://nexus.armundia.com:8081/repository/npm-releases"
};
var pckg = {
	name: name,
	version: version,
	author: author,
	homepage: homepage,
	main: main,
	license: license,
	files: files,
	devDependencies: devDependencies,
	dependencies: dependencies,
	scripts: scripts,
	publishConfig: publishConfig
};

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/** loading button component
 * proprerties supported:
 * type: "button", "submit" or "reset"<br>
 * icon: optional, font icon name (example "fa fa-trash-o")
 * bstype: "default", "success", "primary", "info", "warning", "danger"
 * inline: true o false
*/

var aTextInput = function aTextInput(props) {
  // static propTypes = {
  //   id: t.string,
  //   disabled: t.bool,
  //   label: t.string,
  //   loading: t.bool,
  //   type: t.string,
  //   bs: t.string,
  //   icon: t.string,
  //   suffixIcon: t.string,
  //   inline: t.bool,
  //   placeholder: t.string,
  //   required: t.bool,
  //   title: t.string,
  //   help: t.string,
  //   extraClass: t.string,
  //   validation: t.objectOf(t.string),
  //   groupClass: t.string,
  //   groupProps: t.object
  // }
  // static defaultProps = {
  //   disabled: false,
  //   loading: false,
  //   label: null,
  //   type: 'text',
  //   bs: "default",
  //   icon: null,
  //   suffixIcon: null,
  //   inline: false,
  //   placeholder: null,
  //   required: false,
  //   title: null,
  //   help: null,
  //   extraClass: null,
  //   validation: null,
  //   groupClass: null,
  //   groupProps: null
  // }
  // constructor(props) {
  //   super(props);
  //   shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  // }
  var _props = props,
      id = _props.id,
      children = _props.children,
      label = _props.label;
      _props.title;
      var disabled = _props.disabled,
      icon = _props.icon,
      help = _props.help,
      extraClass = _props.extraClass,
      groupClass = _props.groupClass,
      groupProps = _props.groupProps,
      prefix = _props.prefix,
      suffix = _props.suffix,
      validation = _props.validation,
      suffixIcon = _props.suffixIcon,
      required = _props.required,
      inline = _props.inline,
      errMessage = _props.errMessage,
      placeholder = _props.placeholder,
      loading = _props.loading,
      type = _props.type,
      value = _props.value;
  props = ___default['default'].omit(props, 'id', 'label', 'title', 'help', 'extraClass', 'validation', 'required', 'prefix', 'suffix', 'groupClass', 'groupProps', 'children', 'placeholder', 'disabled', 'errMessage', 'bs', 'icon', 'suffixIcon', 'inline', 'loading', 'type', 'value');
  if (!id) id = Utils.Utils.uuid("at");
  var textarea = false;
  var fieldValue = value ? value : '';

  if (loading) {
    disabled = true;
  }

  if (!type) {
    type = "text";
  } else {
    // throw error on checkbox and radio
    if (type === "checkbox" || type === "radio") throw new Error("aTextInput cannot be used with 'checkbox' or 'radio' type");

    if (type === "textarea") {
      textarea = true;
    }
  }

  var ticon = "";
  var tsuffixIcon = "";
  var licon = "";
  var lsuffixIcon = "";
  var cicon = "input-group-addon";
  if (textarea) cicon = ""; // attivo su textarea le icone sulla label

  if (icon || prefix) {
    ticon = /*#__PURE__*/React__default['default'].createElement("span", {
      className: cicon
    }, icon && /*#__PURE__*/React__default['default'].createElement("i", {
      className: icon,
      "aria-hidden": "true"
    }), prefix && ' ' + prefix);
  }

  if (suffixIcon || suffix) {
    tsuffixIcon = /*#__PURE__*/React__default['default'].createElement("span", {
      className: cicon
    }, suffix && ' ' + suffix, suffixIcon && /*#__PURE__*/React__default['default'].createElement("i", {
      className: suffixIcon,
      "aria-hidden": "true"
    }));
  }

  if (textarea) {
    licon = ticon;
    lsuffixIcon = tsuffixIcon;
    ticon = "";
    tsuffixIcon = "";
  }

  var blockcls = "form-group";
  var inputcls = "form-control";

  if (inline) {
    inputcls += " ";
    blockcls = "form-group-inline mb-2 mr-2 mr-xs-0";

    if (!placeholder) {
      placeholder = label;
      if (required) placeholder += "*";
    }
  }

  if (extraClass) {
    inputcls += " " + extraClass;
  }
  var reqMark = "";

  if (required) {
    reqMark = /*#__PURE__*/React__default['default'].createElement("span", {
      className: "text-danger required",
      title: "campo richiesto",
      "aria-label": "campo richiesto"
    }, " *");
  }

  var labelCmp;

  if (props.label !== null) {
    if (inline) labelCmp = /*#__PURE__*/React__default['default'].createElement("label", {
      className: "sr-only",
      htmlFor: id,
      id: id + '__label'
    }, label);else labelCmp = /*#__PURE__*/React__default['default'].createElement("label", {
      className: "form-control-label",
      htmlFor: id,
      id: id + '__label'
    }, " ", licon, " ", label, " ", reqMark, " ", lsuffixIcon);
  }

  var thelp = "";
  var idHelp = null;

  if (help !== null) {
    idHelp = id + "__help";
    var helpClass = "text-mute"; // block level

    helpClass += " form-text"; // FUTURE - support for inline help 

    thelp = /*#__PURE__*/React__default['default'].createElement("span", {
      id: idHelp,
      className: helpClass
    }, help);
  }

  var errorMessage = "";

  if (validation !== null) {
    //console.log('ID = x' + id +"X");
    //for (var [key, value] of validation) {
    // console.log(key + ' = ' + value);
    //}
    //cerco un eventuale messaggio di errore per il mio componente
    var errore = validation.get ? validation.get(id) : validation[id]; //console.log('Errore: ' + errore);

    if (errore !== undefined) {
      blockcls += ' has-danger'; //	spanClass = 'glyphicon glyphicon-remove form-control-feedback';

      var spanErr = /*#__PURE__*/React__default['default'].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: errore
        }
      });
      errorMessage = /*#__PURE__*/React__default['default'].createElement("small", {
        className: "form-control-feedback"
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        "aria-hidden": "true",
        className: "fa fa-times"
      }), " ", ' ', spanErr, " ", errMessage);
    }
  } else if (errMessage) {
    errorMessage = /*#__PURE__*/React__default['default'].createElement("small", {
      className: "form-control-feedback"
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      "aria-hidden": "true",
      className: "fa fa-times"
    }), " ", ' ', errMessage);
  }

  var mustGroup = false;

  if (ticon || tsuffixIcon) {
    mustGroup = true;
    if (!groupProps) groupProps = {};
  }

  var input;

  if (textarea) {
    input = /*#__PURE__*/React__default['default'].createElement("textarea", _extends({
      className: inputcls,
      placeholder: placeholder,
      required: required,
      disabled: disabled,
      type: type,
      id: id
    }, props, {
      "aria-describedby": idHelp,
      value: fieldValue
    }));
  } else {
    input = /*#__PURE__*/React__default['default'].createElement("input", _extends({
      className: inputcls,
      placeholder: placeholder,
      required: required,
      disabled: disabled,
      type: type,
      id: id
    }, props, {
      "aria-describedby": idHelp,
      value: fieldValue
    }));
  }

  var inputBox;

  if (mustGroup) {
    inputBox = /*#__PURE__*/React__default['default'].createElement("div", _extends({
      id: id + '__grp'
    }, groupProps, {
      className: Utils.Utils.union('input-group', ' ', groupClass)
    }), ticon, input, tsuffixIcon);
  } else {
    inputBox = input;
  }

  console.log("[aTextInput] render: " + id);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: blockcls
  }, labelCmp, inputBox, children, thelp, errorMessage);
};

var aDateInput = function aDateInput(props) {
  var onInputChange = props.onInputChange,
      dateFormat = props.dateFormat,
      locale = props.locale,
      value = props.value,
      className = props.className,
      onBlur = props.onBlur,
      readOnly = props.readOnly,
      disabled = props.disabled,
      onFocus = props.onFocus,
      inputClassName = props.inputClassName,
      viewMode = props.viewMode,
      placeholder = props.placeholder,
      isValidDate = props.isValidDate,
      timeFormat = props.timeFormat;

  var onChange = function onChange(moment) {
    console.debug("[aDateInput.jsx]: onInputChange", moment);

    if (moment instanceof moment__default['default'] && onInputChange) {
      onInputChange(moment.toDate(), moment.valueOf());
    }
  };

  var formatDate = dateFormat;
  if (!dateFormat) formatDate = 'DD/MM/YYYY';
  var local = locale;
  if (!locale) local = Utils.getLocale();
  return /*#__PURE__*/React__default['default'].createElement(Datetime__default['default'], {
    className: className,
    dateFormat: formatDate,
    inputProps: {
      placeholder: placeholder,
      disabled: readOnly || disabled,
      className: inputClassName
    },
    onChange: onChange,
    timeFormat: timeFormat ? timeFormat : false,
    closeOnTab: true,
    locale: local,
    value: value,
    viewMode: viewMode,
    onFocus: onFocus,
    onBlur: onBlur,
    closeOnSelect: true,
    isValidDate: isValidDate
  });
};

var POINT_CODE = 46;
var COMMA_CODE = 44; //const re = /[0-9\-\.\,]+/g;

var VALID_KEY_CODE = [46, // . 
44, // ,
45, // -
48, // 0
49, // 1
50, // 2
51, // 3
52, // 4
53, // 5
54, // 6
55, // 7
56, // 8
57, // 9
//
// 96, // 0 su numpad
// 97, // 1 su numpad
// 98, // 2 su numpad
// 99, // 3 su numpad
// 100, // 4 su numpad
// 101, // 5 su numpad
// 102, // 6 su numpad
// 103, // 7 su numpad
// 104, // 8 su numpad
// 105 , // 9 su numpad
//
110, // ./canc su numpad
109 // - su numpad
]; // class NumberInput extends React.Component {

var NumberInput = function NumberInput(props) {
  var id = props.id,
      formatter = props.formatter,
      onChange = props.onChange,
      className = props.className;
      props.value;
      var zeroValue = props.zeroValue,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      title = props.title,
      placeholder = props.placeholder,
      autoComplete = props.autoComplete;

  var tryFloat = function tryFloat(val, defval) {
    if (defval === undefined) defval = null;

    try {
      if (val === null || val === undefined) return defval;
      val = ("" + val).trim().replace(',', '.');
      if (val === "") return defval;
      return parseFloat(val);
    } catch (e) {
      return defval;
    }
  };

  var val = tryFloat(props.value);
  var empty = false;

  if (val === null) {
    empty = true;
  }

  var refInputs = {};

  var _React$useState = React$1.useState({
    id: id || Utils.Utils.uuid("ni"),
    value: val,
    strValue: empty ? "" : formatter ? formatter(val) : Utils.UiUtils.number(val),
    inError: false,
    focus: false,
    empty: empty
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setstate = _React$useState2[1]; // pass in the Redux action dispatcher and the

  React$1.useEffect(function () {
    internInit(props);
  }, []);

  var internInit = function internInit(props, callback) {
    var val = props.value;
    var n = val; //this.tryFloat(val);

    var inError = false;
    var empty = false;
    var num = 0;

    if (n === null) {
      num = null;
      empty = true; // inError = true;
    } else {
      num = n;
    }

    var newState = update__default['default'](state, {
      value: {
        $set: num
      },
      inError: {
        $set: inError
      },
      empty: {
        $set: empty
      }
    });
    Promise.resolve().then(function () {
      setstate(newState);
    }).then(function () {
      view();
    });
  };

  var handleChange = function handleChange(e, noCall) {
    var val = e.target.value;
    var empty = false;
    var n;
    var inError = false;
    var num = 0;

    if (Utils.Utils.isNil(val)) {
      val = "";
      num = null;
      empty = true;
    } else {
      n = tryFloat(val);

      if (val === '-') {
        num = val;
      } else if (n === null || isNaN(n)) {
        num = null;
        inError = true;
      } else {
        num = n;
      }
    }

    var newState = update__default['default'](state, {
      value: {
        $set: num
      },
      strValue: {
        $set: val
      },
      inError: {
        $set: inError
      },
      empty: {
        $set: empty
      }
    });
    Promise.resolve().then(function () {
      setstate(newState);
    }).then(function () {
      onChange(num, val);
    });
    return true;
  };

  var buildViewValues = function buildViewValues(val) {
    // let self = this;
    var cc = _commaCfg();

    var defVal;

    if (val === null || val === undefined) {
      defVal = zeroValue || "";
    } else {
      defVal = "" + val;
    }

    defVal = defVal.replace(/[^0-9\.\,\-]/g, "").replace(cc.oldchar, cc.newchar);
    var empty = false;

    if (defVal === "") {
      empty = true;
    }

    var dv = tryFloat(defVal);
    var inError = false;

    if (dv === null || isNaN(dv)) {
      inError = true;
      dv = null;
    }

    var strVal = inError || empty ? defVal : formatter ? formatter(dv) : Utils.UiUtils.number(dv);
    return {
      val: dv,
      strValue: strVal,
      inError: inError,
      empty: empty
    };
  };

  var view = function view() {
    var vv = buildViewValues(state.value);
    var newState = update__default['default'](state, {
      value: {
        $set: vv.val
      },
      strValue: {
        $set: vv.strValue
      },
      inError: {
        $set: vv.inError
      },
      empty: {
        $set: vv.empty
      },
      focus: {
        $set: false
      }
    });
    setstate(newState);
  };

  var buildEditStrValue = function buildEditStrValue(val) {
    // let self = this;
    var cc = _commaCfg();

    var strVal;
    if (val === null || val === undefined) strVal = "";else strVal = "" + val;
    strVal = strVal.replace(cc.oldchar, cc.newchar);
    return strVal;
  };

  var edit = function edit() {
    var val = state.value;
    var strVal = buildEditStrValue(val);
    var newState = update__default['default'](state, {
      strValue: {
        $set: strVal
      },
      focus: {
        $set: true
      }
    });
    Promise.resolve().then(function () {
      setstate(newState);
    }).then(function () {
      var elem = document.getElementById(state.id);
      var pos = state.prevPos;
      setTimeout(function () {
        Utils.UiUtils.setCursorPosition(elem, pos);
      }, 120);
    });
  };

  var handleOnBlur = function handleOnBlur(e) {
    var newState = update__default['default'](state, {
      prevPos: {
        $set: null
      }
    });
    Promise.resolve().then(function () {
      setstate(newState);
    }).then(function () {
      view();
      if (onBlur) onBlur();
    });
  };

  var handleOnFocus = function handleOnFocus(e) {
    var prevPos = e && e.target ? Utils.UiUtils.getCursorPosition(e.target) : null;

    if (prevPos !== null) {
      // toglie la differenza se deve
      var strValView = buildViewValues(state.value).strValue || ""; // let strValEdit = this.buildEditStrValue(this.state.value) || "";

      strValView = strValView.substring(0, prevPos);
      var se = strValView.replace(/\./g, "");
      var diff = strValView.length - se.length;
      console.log("prevPos:", prevPos, " - strValView:", strValView, " - se:", se, " - diff:", diff);

      if (se.length < strValView.length) {
        prevPos -= diff;
      }
    }

    var newState = update__default['default'](state, {
      prevPos: {
        $set: prevPos
      }
    });
    Promise.resolve().then(function () {
      setstate(newState);
    }).then(function () {
      edit();

      if (onFocus) {
        onFocus();
      }
    });
  };

  var _commaCfg = function _commaCfg() {
    // TODO usa locale
    var oldcode = POINT_CODE;
    var oldcodealt = 110;
    var newcode = COMMA_CODE;
    var oldchar = String.fromCharCode(oldcode);
    var newchar = String.fromCharCode(newcode);
    return {
      oldcode: oldcode,
      oldcodealt: oldcodealt,
      oldchar: oldchar,
      newcode: newcode,
      newchar: newchar
    };
  };
  /**
   * 
   */


  var _onKeyPress = function onKeyPress(e) {
    // let self = this;
    var key = e.which || e.keyCode;
    var ok = false;
    VALID_KEY_CODE.forEach(function (okcc) {
      if (key === okcc) ok = true;
    }); //if (!re.test(e.key)) { //&& e.key !== "Delete" /* ie11 */) {

    if (!ok) {
      e.preventDefault(); // window.alert("char not good:{" + e.key + "} - key:" + key);

      return;
    }

    console.debug("numberinput keypress ACCEPTED", key, e);

    var cc = _commaCfg();

    if (key === cc.oldcode || key === cc.oldcodealt) {
      // let target = e.target;
      // e.target = null;
      // let newe = _.cloneDeep(e);
      // e.preventDefault();
      // e.stopPropagation();
      // newe.which = newcode;
      // newe.keyCode = newcode;
      // newe.key = newchar;
      // newe.charCode = newcode;
      // newe.target = target;
      // setTimeout(function () {
      //     $("#" + self.state.id).trigger("keypress", newe);
      // }, 5);
      setTimeout(function () {
        var val = state.strValue;
        var pos = e && e.target ? Utils.UiUtils.getCursorPosition(e.target) : null;
        var strVal = buildEditStrValue(val);
        var newState = update__default['default'](state, {
          strValue: {
            $set: strVal
          }
        });
        Promise.resolve().then(function () {
          setstate(newState);
        }).then(function () {
          setTimeout(function () {
            var elem = document.getElementById(self.state.id);
            Utils.UiUtils.setCursorPosition(elem, pos);
          }, 10);
        });
      }, 10);
    } // otherwise none

  }; // render() {


  var compProps = ___default['default'].omit(props, 'value', 'zeroValue', 'formatter', 'onChange', 'onBlur', 'onFocus', 'type', 'className');

  var clsName = className;
  if (!clsName) clsName = "number-input";else clsName += " number-input";

  if (state.inError) {
    clsName += " error ci-error";
  }

  if (state.focus) {
    clsName += " ci-focus";
  }

  if (!Utils.Utils.isNil(state.strValue)) {
    clsName += " ci-has-content";
  } //console.log("NUMBERINPUT:::: ", this.state.value, this.state.strValue);


  var ref = function ref(input) {
    return refInputs[state.id] = input;
  };

  return /*#__PURE__*/React$1.createElement("input", _extends({
    id: state.id,
    title: title,
    placeholder: placeholder,
    autoComplete: autoComplete,
    ref: ref,
    type: "text",
    onKeyPress: function onKeyPress(e) {
      return _onKeyPress(e);
    },
    className: clsName,
    onChange: handleChange,
    onBlur: handleOnBlur,
    onFocus: handleOnFocus,
    value: state.strValue
  }, compProps)); // }
};

var PopupDialog = function PopupDialog(props) {
  var show = props.show,
      className = props.className,
      onClose = props.onClose,
      title = props.title,
      children = props.children;

  if (!show) {
    return null;
  }

  console.log("PopupDialog render " + show);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "popup-dialog-container " + (className ? className : "")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "popup-dialog view"
    /*+ (props.show ? ' view' : '')*/

  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "popup-deco-bar"
  }), onClose && /*#__PURE__*/React__default['default'].createElement("a", {
    className: "popup-close-btn btn btn-secondary btn-close",
    onClick: onClose
  }, "\xD7"), title && /*#__PURE__*/React__default['default'].createElement("h4", null, title), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "popup-content"
  }, children)));
};
//     if (props.show !== nextProps.show)
//         return true;
//     return (!!props.show);
// });

var AskConfirm = function AskConfirm(props) {
  var show = props.show,
      children = props.children,
      options = props.options,
      onCancel = props.onCancel,
      onConfirm = props.onConfirm;
  if (!show) return children || null;
  var opts = {};

  if (options) {
    if (typeof options === "string") {
      opts.message = options;
    } else {
      opts = options;
    }
  }

  var bsOk = "primary";
  var bigIcon = "fa fa-info-circle text-info";

  if (opts.warning) {
    bsOk = "danger";
    bigIcon = "fa fa-exclamation-triangle text-danger";
  }

  return /*#__PURE__*/React__default['default'].createElement(PopupDialog, {
    className: "ask-confirm",
    show: true,
    title: opts.title || "Richiesta conferma",
    onClose: onCancel
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "big-icon " + bigIcon
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ac-message"
  }, opts.message || "Sicuro di voler continuare?"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "cmds"
  }, /*#__PURE__*/React__default['default'].createElement(aButton, {
    bs: bsOk,
    onClick: onConfirm,
    large: true,
    icon: opts.yesIcon
  }, opts.yes || "Ok"), /*#__PURE__*/React__default['default'].createElement(aButton, {
    bs: "secondary",
    onClick: onCancel,
    large: true,
    icon: opts.noIcon
  }, opts.no || "Annulla")));
};

/** loading button component
 * proprerties supported:
 * type: "button", "submit" or "reset"<br>
 * icon: optional, font icon name (example "fa fa-trash-o")
 * bstype: "default", "success", "primary", "info", "warning", "danger"
 * inline: true o false,
 * eventParam
*/
// static propTypes = {
//   disabled: t.bool,
//   loading: t.bool,
//   type: t.string,
//   bs: t.string,
//   icon: t.string,
//   inline: t.bool,
//   outline: t.bool,
//   large: t.bool,
//   small: t.bool,
//   block: t.bool,
//   size: t.string,
//   href: t.string,
//   visible: t.bool,
//   askConfirm: t.any,
//   eventParam: t.any
// }
// static defaultProps = {
//   disabled: false,
//   loading: false,
//   type: 'button',
//   bs: "default",
//   icon: null,
//   inline: true,
//   outline: false,
//   large: false,
//   small: false,
//   block: false,
//   size: 'default',
//   href: null,
//   visible: true,
//   askConfirm: null,
// }

var aButton = function aButton(props) {
  //   super(props);
  //   state = {
  //     showConfirm: false
  //   };
  //   componentName = "[aButton]";
  //   onShowConfirm = onShowConfirm.bind(this);
  //   onConfirm = onConfirm.bind(this);
  //   onCancelConfirm = onCancelConfirm.bind(this);
  // }

  var _useState = React$1.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showConfirm = _useState2[0],
      setShowConfirm = _useState2[1];

  var onShowConfirm = function onShowConfirm() {
    setShowConfirm(false);
  };

  var _onConfirm = function onConfirm(onOk) {
    setShowConfirm(false);

    if (onOk) {
      onOk();
    }
  };

  var onCancelConfirm = function onCancelConfirm() {
    setShowConfirm(false);
  };

  var visible = true;

  if (props.visible !== undefined && props.visible !== null) {
    visible = props.visible;
  }

  if (!visible) return null;
  var _props = props,
      children = _props.children,
      disabled = _props.disabled,
      bs = _props.bs,
      icon = _props.icon,
      size = _props.size,
      inline = _props.inline,
      loading = _props.loading,
      large = _props.large,
      small = _props.small,
      block = _props.block,
      outline = _props.outline,
      type = _props.type,
      className = _props.className,
      href = _props.href,
      onClick = _props.onClick,
      eventParam = _props.eventParam,
      askConfirm = _props.askConfirm;
  props = ___default['default'].omit(props, 'block', 'children', 'className', 'disabled', 'bs', 'icon', 'size', 'large', 'small', 'inline', "askConfirm", 'outline', 'loading', 'type', 'href', 'onClick', 'visible', 'eventParam');
  loading = !!loading;

  if (!type) {
    type = "button";
  }

  var ticon = "";

  if (icon || loading) {
    var ic = icon;

    if (loading) {
      ic = "fa fa-spinner fa-pulse";
    }

    ticon = /*#__PURE__*/React__default['default'].createElement("i", {
      className: ic
    });
  }

  var clbtn = "btn ";

  if (disabled) {
    clbtn += "btn-disabled ";
  }

  if (loading) {
    clbtn += "btn-loading ";
  }

  var pre = " btn-";
  if (outline) pre += "outline-";

  if (bs) {
    if (bs === "default") // bs3+
      bs = "secondary";
    clbtn += pre + bs;
  } else {
    clbtn += " btn-secondary";
  }

  if (inline === false || block) clbtn += " btn-block";
  if (large || "large" === size) clbtn += " btn-lg";else if (small || "small" === size) clbtn += " btn-sm";

  if (className) {
    clbtn = Utils.Utils.union(clbtn, ' ', className);
  }

  if (eventParam && onClick) {
    var _onc = onClick;

    onClick = function onClick(e) {
      _onc(e, eventParam);
    };
  }

  if (!onClick && href) {
    onClick = function onClick() {
      document.location.href = "" + href;
    };
  }

  if (disabled || loading) onClick = null;
  var tAskConfirm = null;

  if (onClick !== null && askConfirm) {
    var origOnClick = onClick;
    tAskConfirm = /*#__PURE__*/React__default['default'].createElement(AskConfirm, {
      show: showConfirm,
      options: askConfirm,
      onConfirm: function onConfirm() {
        return _onConfirm(origOnClick);
      },
      onCancel: onCancelConfirm
    });
    onClick = onShowConfirm;
  }

  var button = /*#__PURE__*/React__default['default'].createElement("button", _extends({
    className: clbtn,
    disabled: disabled,
    type: type
  }, props, {
    onClick: onClick
  }), ticon, " ", children);
  if (!tAskConfirm) return button;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      display: "inline"
    }
  }, button, tAskConfirm);
};

var aBreadCrumbs = function aBreadCrumbs(props) {
  var _useState = React$1.useState({}),
      _useState2 = _slicedToArray(_useState, 2);
      _useState2[0];
      _useState2[1]; // constructor(props) {
  //     super(props);
  //     state = {
  //     }
  // }


  var sep = props.separator;
  var id = Utils.Utils.uuid("bc"); // if (sep) {
  //     sepDef = (<style>{' \n' +
  //         ' \n' +
  //         '#' + id + ' > .breadcrumb-item+.breadcrumb-item::before {\n' +
  //         '   content: \'' + sep + '\';\n' +
  //         '}\n' +
  //         '\n'}
  //     </style>);
  // }

  var breadCrumbList = [];
  var listCrumbs = props.items || props.listCrumbs;

  for (var i = 0; i < listCrumbs.length; i++) {
    if (i === listCrumbs.length - 1) {
      breadCrumbList.push( /*#__PURE__*/React__default['default'].createElement("span", {
        className: "breadcrumb-item active",
        key: 'item' + i
      }, listCrumbs[i].label));
    } else {
      breadCrumbList.push( /*#__PURE__*/React__default['default'].createElement("a", {
        className: "breadcrumb-item",
        key: 'item' + i,
        href: listCrumbs[i].path
      }, listCrumbs[i].label));
      breadCrumbList.push( /*#__PURE__*/React__default['default'].createElement("span", {
        className: "breadcrumb-separator",
        key: 'item_sep_' + i
      }, sep));
    }
  }

  var clz = Utils.Utils.union('breadcrumb', ' ', props.className);
  return /*#__PURE__*/React__default['default'].createElement("nav", {
    id: id,
    className: clz
  }, breadCrumbList, props.children);
};

var aSelect = function aSelect() {
  // constructor(props) {
  //     super(props);
  //     state = {
  //     }
  // }
  props.value;
      var className = props.className;
      props.onChange;

  var props = ___default['default'].omit(props, 'children', 'className', 'onChange');

  var clsel = "custom-select";
  var val = props.value;
  if (val === undefined || val === null) val = "";

  if (className) {
    clsel = Utils.Utils.union(clsel, ' ', className);
  }

  return /*#__PURE__*/React__default['default'].createElement("select", {
    className: clsel,
    value: val,
    onChange: props.onChange,
    id: props.id
  }, props.options === null ? null : props.options.map(function (item, index) {
    return /*#__PURE__*/React__default['default'].createElement("option", {
      key: index,
      value: item.value
    }, " ", item.label, " ");
  }));
};

var aSelectV2 = function aSelectV2(props) {
  // constructor(props) {
  //     super(props);
  //     selectOnChange = selectOnChange.bind(this);
  //     componentName = "[aSelectV2.jsx]"
  // }
  componentName = "[aSelectV2.jsx]";

  var selectOnChange = function selectOnChange(item) {
    console.log(componentName + "selectOnChange item= " + item);
    props.valueKey || "value";

    if (props.onChange) {
      props.onChange(item);
    } // onInputChange(Utils.getVal(valKey, item));

  };

  var classname = "form-control " + (props.className === undefined ? "" : props.className);
  var formClass = 'form-group ';

  if (props.componentClass === null || props.componentClass === undefined) ; else {
    formClass = formClass + props.componentClass;
  }

  props.value;

  var items = props.items || [];
  var valueKey = props.valueKey || "value";
  var labelKey = props.labelKey || "label";
  var label = props.label;

  if (props.required !== undefined && props.required) {
    console.log(componentName + "required is true");

    if (label.indexOf('*') === -1) {
      label = label + '*';
    }
  }

  if (props.addEmptyOption === undefined || props.addEmptyOption) {
    console.log(componentName + "addEmptyOption is true");
    var it = {};
    it[valueKey] = "";
    it[labelKey] = " ";
    it.id = {};
    items = update__default$1['default'](items, {
      $unshift: [it]
    }); // items.unshift(it);
  }

  console.log(componentName + 'render [classname]' + classname);
  console.log(componentName + 'render [id] ' + props.id, items); //console.log("option key [" + item[valueKey] + "] - label [" + item[labelKey] + "]");

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: formClass
  }, /*#__PURE__*/React__default['default'].createElement("label", {
    htmlFor: props.id
  }, label), /*#__PURE__*/React__default['default'].createElement("select", {
    className: classname,
    onChange: selectOnChange,
    id: props.id
  }, items === null ? null : items.map(function (item, index) {
    return /*#__PURE__*/React__default['default'].createElement("option", {
      selected: props.value === item[valueKey],
      key: index,
      value: item[valueKey]
    }, item[labelKey]);
  })));
};

/** 
 * panel component
 * proprerties supported:
 * 
*/

var aToolbar = function aToolbar(props) {
  // static propTypes = {
  //     id: t.string,
  //     children: t.node
  // }
  // static defaultProps = {
  // }

  /*
     static Left = function (props) {
  
         return (<span />);
     }
     static Right = function (props) {
  
         return (<span />);
     }
  
     static Brand = function (props) {
  
         return (<span />);
     }
  
     static Search = function (props) {
  
         return (<span />);
     } */
  console.log("[aToolbar] render");
  var id = props.id,
      className = props.className,
      children = props.children,
      sub = props.sub;

  var _props = ___default['default'].omit(props, 'id', 'className', "children", "sub");

  id = id || Utils.Utils.uuid("tb");
  var toLeft = [];
  var toRight = [];
  var toBrand = null;
  var toSearch = null;
  var others = [];
  React__default['default'].Children.forEach(children, function (child) {
    if (!child || child.props.visible === false) {
      console.log(" child.props.visible === false");
      return;
    }

    if (child.type === aToolbar.Left) {
      var l = {};
      l.key = "left_" + (toLeft.length + 1);
      l.onClick = child.props.onClick;
      l.noLink = !child.props.onClick || child.props.noLink;
      l.className = child.props.className;
      l.disabled = child.props.disabled;
      l.children = child.props.children;
      toLeft.push(l);
    } else if (child.type === aToolbar.Right) {
      var r = {};
      r.key = "right_" + (toRight.length + 1);
      r.onClick = child.props.onClick;
      r.noLink = !child.props.onClick || child.props.noLink;
      r.className = child.props.className;
      r.disabled = child.props.disabled;
      r.children = child.props.children;
      toRight.push(r);
    } else if (child.type === aToolbar.Brand) {
      var b = {};
      b.onClick = child.props.onClick;
      b.noLink = !child.props.onClick || child.props.noLink;
      b.className = child.props.className;
      b.children = child.props.children;
      toBrand = b;
    } else if (child.type === aToolbar.Search) {
      var s = {};
      s.className = child.props.className;
      s.children = child.props.children;
      toSearch = s;
    } else {
      child.key = "ot_" + (others.length + 1);
      others.push(child);
    }
  });

  if (toLeft.length === 0) {
    toLeft = null;
  }

  if (toRight.length === 0) {
    toRight = null;
  }

  if (others.length === 0) {
    others = null;
  }

  var hasNb = toLeft || toRight || toSearch || others;
  var idnb = '' + id + '__nb'; // TODO label in i18n

  var subelements = [];

  if (hasNb) {
    subelements.push( /*#__PURE__*/React__default['default'].createElement("button", {
      key: subelements.length,
      className: "navbar-toggler navbar-toggler-right",
      type: "button",
      "data-toggle": "collapse",
      "data-target": '#' + idnb,
      "aria-controls": idnb,
      "aria-expanded": "false",
      "aria-label": "Apri/chiudi elementi navigazione"
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      className: "navbar-toggler-icon"
    })));
  }

  if (toBrand) {
    subelements.push( /*#__PURE__*/React__default['default'].createElement("a", {
      key: subelements.length,
      className: Utils.Utils.union('navbar-brand', ' ', toBrand.className),
      onClick: toBrand.onClick,
      href: "javascript:;"
    }, toBrand.children));
  }

  if (hasNb) {
    subelements.push( /*#__PURE__*/React__default['default'].createElement("div", {
      key: subelements.length,
      className: "collapse navbar-collapse",
      id: idnb
    }, toLeft && /*#__PURE__*/React__default['default'].createElement("ul", {
      className: "navbar-nav mr-auto lefts"
    }, toLeft.map(function (item, index) {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: index,
        className: "nav-item"
      }, item.noLink && /*#__PURE__*/React__default['default'].createElement("span", {
        className: Utils.Utils.union('nav-no-link', ' ', item.className)
      }, item.children), !item.noLink && /*#__PURE__*/React__default['default'].createElement("a", {
        "data-text": item.children,
        className: Utils.Utils.union('nav-link', ' ', item.className),
        onClick: item.onClick,
        disabled: item.disabled,
        href: item.path ? item.path : 'javascript:;'
      }, item.children));
    })), others && others.map(function (child) {
      return {
        child: child
      };
    }), (toSearch || toRight) && /*#__PURE__*/React__default['default'].createElement("form", {
      className: "form-inline my-2 my-lg-0",
      autoComplete: "off",
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }, /*#__PURE__*/React__default['default'].createElement("ul", {
      className: "navbar-nav mr-auto"
    }, toRight && toRight.map(function (item) {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: item.key,
        className: "nav-item"
      }, item.noLink && /*#__PURE__*/React__default['default'].createElement("span", {
        className: Utils.Utils.union('nav-no-link', ' ', item.className)
      }, item.children), !item.noLink && /*#__PURE__*/React__default['default'].createElement("a", {
        className: Utils.Utils.union('nav-link', ' ', item.className),
        onClick: item.onClick,
        disabled: item.disabled,
        href: "javascript:;"
      }, item.children));
    }), toSearch && /*#__PURE__*/React__default['default'].createElement("li", {
      className: "nav-item search-form"
    }, toSearch.children)))));
  }

  var ss;

  if (sub) {
    ss = /*#__PURE__*/React__default['default'].createElement("div", {
      className: sub
    }, subelements);
  } else {
    ss = subelements;
  }

  var navbar;
  navbar = /*#__PURE__*/React__default['default'].createElement("nav", _extends({
    id: id,
    className: Utils.Utils.union("aToolbar navbar navbar-toggleable-sm navbar-light bg-faded", " ", className)
  }, _props), ss);
  return navbar;
}; // end class


var Left = function Left() {
  return;
};

var Right = function Right() {
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("span", null));
};

var Brand = function Brand() {
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("span", null));
};

var Search = function Search() {
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("span", null));
};

aToolbar.Left = Left;
aToolbar.Right = Right;
aToolbar.Brand = Brand;
aToolbar.Search = Search;

/** 
 * panel component
 * proprerties supported:
 * 
*/

var aFooter = function aFooter(props) {
  var className = props.className;

  var _props = ___default['default'].omit(props, 'className');

  var cl = Utils.Utils.union("footer", " ", className);
  return /*#__PURE__*/React__default['default'].createElement("footer", _extends({
    className: cl
  }, _props), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "text-muted footer-item"
  }, props.children));
};

var aStoreInfo = function aStoreInfo() {
  // static contextTypes = {
  //     store: PropTypes.object
  // };
  var _useState = React$1.useState({
    show: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1]; // state = { show: false };


  useEffect(function () {
    console.log('[StoreInfo]: componentWillMount');
    var unsubscribe = context.store.subscribe(storeOnChange);
    setState({
      unsubscribe: unsubscribe
    });
  }, [unsubscribe]); // componentWillMount() {
  //     console.log('[StoreInfo]: componentWillMount');
  //     //Returns a function that unsubscribes the change listener.
  //     let unsubscribe = context.store.subscribe(storeOnChange);
  //     setState({ unsubscribe: unsubscribe });
  // }
  // componentWillUnmount() {
  //     console.log('[StoreInfo]: componentWillUnmount');
  //     //state.unsubscribe();
  //     //setState({ unsubscribe: null });
  //     //context.store.unsubscribe();
  // }
  //shouldComponentUpdate: function () {
  //  return state.show;
  //  return true;
  //},

  var storeOnChange = function storeOnChange() {//console.log('[StoreInfo]: storeOnChange');
    // if (state.show && state.unsubscribe) {
    //     setState({ storeState:  context.store.getState()});
    // }
    //  console.log('\t' + JSON.stringify(state.storeState, null, '\t'));
  };

  var showHide = function showHide() {
    //console.log('[StoreInfo]: showHide ' + state.show);
    setState({
      show: !state.show
    });
  }; //console.debug('[StoreInfo]: render  show=' + state.show);
  // {/* UiUtils.renderJson(state.storeState)*/}
  //  <pre>{JSON.stringify(state.storeState, null, 3)}</pre> 


  var storeState = context.store.getState();
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "agui-storeinfo"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    className: "btn btn-outline-info btn-sm",
    type: "button",
    onClick: showHide
  }, "Vedi Store (Redux)"), state.show ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "agui-storeinfo-container"
  }, Utils.UiUtils.renderJson(storeState)) : null);
};

var aIcon = function aIcon() {
  var _useState = React$1.useState({
    enabled: isEnabled
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0];
      _useState2[1]; // constructor(props) {
  //     super(props);
  //     let isEnabled = props.enabled;
  //     state = {
  //         enabled: isEnabled
  //     }
  // }
  // componentDidMount() {
  //     console.log('Inital state Enabled: ' + state.enabled);
  // }


  React$1.useEffect(function () {
    console.log('Inital state Enabled: ' + state.enabled);
  });
  var icon = props.icon,
      disabledIcon = props.disabledIcon;
      props.onClick;
      props.label;
      props.enabled;
  var cli = '';
  var iconLabel = '';

  var props = ___default['default'].omit(props, 'icon', 'label', 'onClick');

  if (icon && disabledIcon) {
    if (props.enabled === true) {
      cli = "highlighted " + icon;
      iconLabel = props.label;
    } else {
      cli = disabledIcon;
      iconLabel = "";
    }
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "form-inline",
    onClick: props.onClick
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: cli
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "highlighted h-italic"
  }, "\xA0", iconLabel));
};

var aDiv = function aDiv(props) {
  if (props.visible === false) {
    return null;
  } else {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: props.className
    }, props.children);
  }
};

/**
 * @augments {Component<{show: boolean, width:string, marginRight: string, marginLeft:string, marginBottom: string, marginTop: string}, State>}
 */

var PopupResponsive = function PopupResponsive(props) {
  // constructor(props) {
  //     super(props);
  // }
  if (!props.show) return null;
  var modalStyle = {};

  if (props.marginTop) {
    modalStyle["marginTop"] = props.marginTop;
  }

  if (props.marginRight) {
    modalStyle["marginRight"] = props.marginRight;
  }

  if (props.marginBottom) {
    modalStyle["marginBottom"] = props.marginBottom;
  }

  if (props.marginLeft) {
    modalStyle["marginLeft"] = props.marginLeft;
  }

  if (props.width) {
    modalStyle["width"] = props.width;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "modal",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "responsive-modal-dialog " + (props.className ? " " + props.className : ""),
    style: modalStyle
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "modal-content"
  }, props.children))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "modal-backdrop show"
  }));
};
/**
 * @augments {Component<{onClose: function}, State>}
 */


var Header = function Header(props) {
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "w-100 " + (props.className ? props.className : "")
  }, props.children), /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    className: "close",
    onClick: props.onClose
  }, /*#__PURE__*/React__default['default'].createElement("span", null, "\xD7")));
};
/**
 * @augments {Component<{maxHeight: string}, State>}
 */


var Body = function Body(props) {
  var bodyStyle = {};

  if (props.maxHeight) {
    bodyStyle["maxHeight"] = props.maxHeight;
  }

  if (props.overflow !== false) {
    bodyStyle.overflow = "auto";
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "modal-body mt-3" + (props.className ? " " + props.className : ""),
    style: bodyStyle
  }, props.children);
};
/**
 * @augments {Component<{}, State>}
 */


var Footer = function Footer(props) {
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "modal-footer" + (props.className ? " " + props.className : "")
  }, props.children);
};

PopupResponsive.Header = Header;
PopupResponsive.Body = Body;
PopupResponsive.Footer = Footer;

function unitsToFloat(val, defVal) {
  if (val === undefined || val === null) return defVal || null; //Se fosse una stringa, vuol dire che possiede un unità

  if (typeof val === "string") {
    val = setUnit(val);
    return parseFloat(val.substring(0, val.length - unit.length));
  }

  if (!isNaN(val)) return val;
  return defVal || null;
}

var unit = null;
/**
 * Setta la variabile globale con l'unità css trovata nella stringa
 * @param {*} numberWithUnit 
 */

function setUnit(numberWithUnit) {
  if (numberWithUnit.endsWith("px")) {
    unit = "px";
  } else if (numberWithUnit.endsWith("%")) {
    unit = "%";
  } else if (numberWithUnit.endsWith("em")) {
    unit = "em";
  } else if (numberWithUnit.endsWith("rem")) {
    unit = "rem";
  } else if (numberWithUnit.endsWith("vw")) {
    unit = "vw";
  } else if (numberWithUnit.endsWith("vh")) {
    unit = "vh";
  } else {
    unit = "px";
    numberWithUnit += unit;
  }

  return numberWithUnit;
}

var SCROLLBAR_WIDTH = null;

function _getScrollbarWidth() {
  if (SCROLLBAR_WIDTH) return SCROLLBAR_WIDTH;
  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.height = "100px";
  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth; // force scrollbars

  outer.style.overflow = "scroll"; // add innerdiv

  var inner = document.createElement("div");
  inner.style.height = "200px";
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth; // remove divs

  outer.parentNode.removeChild(outer);
  SCROLLBAR_WIDTH = widthNoScroll - widthWithScroll;
  return SCROLLBAR_WIDTH;
}
/**
 * aTable
 * 
*/


var aTable = /*#__PURE__*/function (_Component) {
  _inherits(aTable, _Component);

  var _super = _createSuper(aTable);

  function aTable(props) {
    var _this;

    _classCallCheck(this, aTable);

    _this = _super.call(this, props);
    _this.sortIcon = _this.sortIcon.bind(_assertThisInitialized(_this));
    _this.sortClass = _this.sortClass.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(aTable, [{
    key: "sortClass",
    value: function sortClass(col) {
      if (!col || !col.sortable) return "";
      if (this.props === null) return "text-danger";
      if (this.props.sort === null || this.props.sort.activeSort === null) return "";
      if (this.props.sort.activeSort.name !== col.name) return "";
      return "active";
    }
  }, {
    key: "sortIcon",
    value: function sortIcon(col) {
      if (!col || !col.sortable) return "";
      if (this.props === null) return "fa fa-exclamation-triangle";
      if (this.props.sort === null || this.props.sort.activeSort === null) return "fa fa-sort text-default";
      if (this.props.sort.activeSort.name !== col.name) return "fa fa-sort text-default"; // equals

      if (this.props.sort.activeSort.asc) return "fa fa-sort-asc";else return "fa fa-sort-desc";
    }
  }, {
    key: "rowClickHandler",
    value: function rowClickHandler(row, event) {
      if (this.props.onRowClick) this.props.onRowClick(row);
    }
  }, {
    key: "_calcWidth",
    value: function _calcWidth(col, index, firstIndex, lastIndex) {
      if (!col.width) return;
      unitsToFloat(col.width) || 100; // TODO error?

      _getScrollbarWidth();
    }
  }, {
    key: "_calcStyle",
    value: function _calcStyle(col, isTh) {
      var style = {};
      if (!col.width) return style;
      var pl = col._leftSpace || 0;
      var pr = 0;

      if (isTh) {
        pr = col._thRightSpace || 0;
      } else {
        pr = col._rightSpace || 0;
      }

      if (col.padding === undefined) {
        style.paddingLeft = "" + pl + "px";
        style.paddingRight = "" + pr + "px";
      } else {
        style.paddingLeft = col.padding;
        style.paddingRight = col.padding;
      }

      if (col._left !== undefined) {
        style.left = "" + col._left + "px";
      }

      if (col._right !== undefined) {
        style.right = "" + col._right + "px";
      }

      if (col._borderLeft !== undefined) {
        style.borderLeft = "1px solid #ddd";
      }

      if (col._borderRight !== undefined) {
        style.borderRight = "1px solid #ddd";
      }

      if (col.width) {
        var w = unitsToFloat(col.width);
        if (pl) w += pl;
        if (pr && !_typeof(col.width) === "string") w += pr; //Setto come default px

        style.minWidth = w + "px";
        style.width = w + "px";
        style.maxWidth = w + "px"; // maxWidth: col.width 
        //Se la grandezza è di tipo stringa, affianco al numero la stringa unit (settata in precedenza)

        if (typeof col.width === "string") {
          style.minWidth = w + unit;
          style.width = w + unit;
          style.maxWidth = w + unit;
        }
      }

      return style;
    }
  }, {
    key: "_prepareColumns",
    value: function _prepareColumns(def) {
      var SCROLLBAR_WIDTH = _getScrollbarWidth();

      var W_SPACE = 8;
      var fixedCols = this.props.fixedCols; // preleva l'indice della l'ultima colonna
      // visibile e non fissa

      def.length - 1 - (fixedCols ? fixedCols.last : 0);
      fixedCols ? fixedCols.first : 0;
      var f = 0;
      var l = 0;

      if (fixedCols) {
        // prepare on fixedCols options
        var inErr = false;
        f = fixedCols.first || 0;
        l = fixedCols.last || 0;

        if (f && f >= def.length) {
          f = null;
          inErr = true;
        }

        if (l && l >= def.length) {
          l = null;
          inErr = true;
        }

        if (!inErr && f && l) {
          if (f + l >= def.length) {
            inErr = true;
          }
        }

        if (f < 0 || l < 0) inErr = true;

        if (inErr) {
          console.error("fixeCols skipped by definition errors. Please fix -- fixedCols: ", fixedCols); // throw new Error("fixeCols skipped by definition errors. Please fix");

          return;
        }

        if (f > 0) {
          var w = 0;

          for (var i = 0; i < f; i++) {
            var c = def[i];

            if (!c.width) {
              break;
            }

            c._fixed = true;
            c._fixedLeft = true;
            c._left = w;
            w += unitsToFloat(c.width) || 1;
          }

          def[f - 1]._borderRight = true;
          def[f]._leftSpace = w + 2; // fixed = true;
        }

        if (l > 0) {
          var _w = 0;

          for (var _i = def.length - 1; _i >= def.length - l; _i--) {
            var _c = def[_i];

            if (!_c.width) {
              // console.error("fixed column without width", c);
              break;
            }

            _c._fixed = true;
            _c._fixedRight = true;
            _c._right = _w;
            _w += unitsToFloat(_c.width) || 1;
          }

          def[def.length - l]._borderLeft = true;
          def[def.length - l - 1]._rightSpace = _w + SCROLLBAR_WIDTH;
          def[def.length - l - 1]._thRightSpace = _w + W_SPACE + SCROLLBAR_WIDTH;
          def[def.length - 1]._thRightSpace = SCROLLBAR_WIDTH;
        } else {
          def[def.length - 1]._rightSpace = l + SCROLLBAR_WIDTH;
          def[def.length - 1]._thRightSpace = W_SPACE + SCROLLBAR_WIDTH + SCROLLBAR_WIDTH;
        }
      } else {
        def[def.length - 1]._rightSpace = W_SPACE + SCROLLBAR_WIDTH;
        def[def.length - 1]._thRightSpace = W_SPACE + SCROLLBAR_WIDTH + SCROLLBAR_WIDTH;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // console.log("[aTable] render");
      var self = this;
      var data = this.props.data;

      if (!data) {
        // console.warn("no data?!?!?");
        data = [];
      }

      if (!this.props.def) {
        throw new Error("[aDataGrid/aTable] NO DEFINITION COLUMNS");
      }

      var def = [];
      this.props.def.map(function (col, index) {
        if (col.visible === false) return;
        col._index = index;
        def.push(col);
      });
      var fixed = !!this.props.fixed;
      var compact = this.props.compact;
      var clz;
      clz = " " + Utils.Utils.union('aTable table', ' ', this.props.className) + " ";
      clz += fixed ? " fixedTable " : "";
      clz += compact ? " compact " : "";
      if (clz.indexOf(" fixedTable ") > 0) fixed = true;
      var fixedCols = this.props.fixedCols;
      def.length - 1 - (fixedCols ? fixedCols.last : 0);
      fixedCols ? fixedCols.first : 0;
      var validColNum = def.length;

      this._prepareColumns(def, fixed);

      var tbAddClz = this.props.onRowClick ? ' clickable-row table-hover' : '';
      clz += tbAddClz;
      var tbodyStyle = null;

      if (this.props.tbodyHeight) {
        tbodyStyle = {
          height: this.props.tbodyHeight
        };
      }

      var sbw = _getScrollbarWidth();

      var isIE = Utils.UiUtils.detectIE() > 0;
      return /*#__PURE__*/React__default['default'].createElement("table", {
        id: this.props.id,
        className: clz
      }, /*#__PURE__*/React__default['default'].createElement("thead", null, /*#__PURE__*/React__default['default'].createElement("tr", null, def.map(function (col, colIndex) {
        var thStyle = _this2._calcStyle(col, true);

        var thClz = col.thClassName ? col.thClassName : col.className ? col.className : '';

        if (col._fixed) {
          thClz += " col-fixed";

          if (col._fixedLeft) {
            thClz += " col-fixed-left";
          }

          if (col._fixedRight) {
            thClz += " col-fixed-right";
          }
        }

        return /*#__PURE__*/React__default['default'].createElement("th", {
          key: "th_" + col.name,
          className: thClz,
          style: thStyle,
          "data-left": thStyle.left,
          "data-is-header": true
        }, col.sortable && /*#__PURE__*/React__default['default'].createElement("a", {
          href: "javascript:;",
          className: _this2.sortClass(col),
          onClick: function onClick(e) {
            _this2.props.onChangeSort(col.name);
          }
        }, col.label, ' ', /*#__PURE__*/React__default['default'].createElement("i", {
          className: _this2.sortIcon(col)
        })), !col.sortable && col.label);
      }, this))), /*#__PURE__*/React__default['default'].createElement("tbody", {
        style: tbodyStyle
      }, data.map(function (item, index) {
        if (self.props.rowVisibleOn) {
          if (!self.props.rowVisibleOn(item, index)) {
            // console.debug("row hidden by rowVisibleOn", item, index);
            return null;
          }
        }

        var rowCssClass = index % 2 === 0 ? "even e1" : "odd o1";
        if (_this2.props.rowCssClass) rowCssClass += " " + _this2.props.rowCssClass;

        if (_this2.props.rowCssClassCalculate) {
          var calcRowCssClass = _this2.props.rowCssClassCalculate(item, index); // console.debug("row css calc", calcRowCssClass);


          if (calcRowCssClass) rowCssClass += " " + calcRowCssClass;
        }

        var baseRow = def.map(function (col, colIndex) {
          var tabIndex = undefined;

          if (self.props.useTabIndex) {
            var zeroFill = isIE ? 3 : 6;
            tabIndex = "" + (colIndex + 1) + Utils.UiUtils.zeroFill(index, zeroFill);
          }

          var tdClz = col.className ? col.className : '';

          if (col._fixed) {
            tdClz += " col-fixed";

            if (col._fixedLeft) {
              tdClz += " col-fixed-left";
            }

            if (col._fixedRight) {
              tdClz += " col-fixed-right";
            }
          }

          var tdStyle = _this2._calcStyle(col, false);

          return /*#__PURE__*/React__default['default'].createElement("td", {
            key: "td_" + col.name,
            className: tdClz,
            "data-left": tdStyle.left,
            "data-offset": sbw,
            "data-toggle": col.openDetails ? 'collapse' : null,
            "data-target": col.openDetails ? '#' + self.props.id + '_detail_' + index : '',
            style: tdStyle
          }, _this2.renderVal(col, item, index, tabIndex));
        }, _this2);

        var detRender = _this2.renderDetail(_this2.props.detailsRenderer, item, index);

        if (detRender) {
          return [/*#__PURE__*/React__default['default'].createElement("tr", {
            key: index,
            onClick: _this2.rowClickHandler.bind(_this2, item),
            className: "accordion-toggle " + rowCssClass
          }, baseRow), /*#__PURE__*/React__default['default'].createElement("tr", {
            className: "detailsRow"
          }, /*#__PURE__*/React__default['default'].createElement("td", {
            colSpan: validColNum,
            className: "hiddentablerow"
          }, /*#__PURE__*/React__default['default'].createElement("div", {
            id: self.props.id + '_detail_' + index,
            className: "accordian-body collapse"
          }, detRender)))];
        } else {
          return /*#__PURE__*/React__default['default'].createElement("tr", {
            key: index,
            onClick: _this2.rowClickHandler.bind(_this2, item),
            className: rowCssClass
          }, baseRow);
        }
      }, this)));
    }
  }, {
    key: "renderDetail",
    value: function renderDetail(detailsRenderer, item, index) {
      if (detailsRenderer) {
        return detailsRenderer(item, index);
      } else {
        return null;
      }
    }
  }, {
    key: "renderVal",
    value: function renderVal(col, item, index, tabIndex) {
      try {
        var val = aTable.getVal(col, item);

        if (col.formatter) {
          var newval = col.formatter(val, col, item, index);
          val = newval;
        }

        if (col.renderer) {
          var rd = col.renderer(val, col, item, index, tabIndex);
          if (rd === null) return "";
          return rd;
        }

        if (val === null || val === undefined) val = "";
        return val.toString();
      } catch (error) {
        console.error(error);
        return " error ";
      }
    }
  }], [{
    key: "getVal",
    value: function getVal(col, item) {
      if (item === null || item === undefined) return null;
      if (!col || !col.fieldPath) return null;
      return Utils.Utils.getVal(col.fieldPath, item);
    }
  }]);

  return aTable;
}(React$1.Component);

_defineProperty(aTable, "propTypes", {
  id: t__default['default'].string,
  def: t__default['default'].arrayOf(t__default['default'].object),
  data: t__default['default'].arrayOf(t__default['default'].object),
  detailsRenderer: t__default['default'].func,
  onChangeSort: t__default['default'].func,
  onRowClick: t__default['default'].func,
  itemComponent: t__default['default'].node,
  // not used for table
  rowCssClassCalculate: t__default['default'].func
});

var MAX_VIEWED_PAGE = 8;
/**
 * aTable
 * 
*/

var aPaginator = /*#__PURE__*/function (_Component) {
  _inherits(aPaginator, _Component);

  var _super = _createSuper(aPaginator);

  function aPaginator(props) {
    var _this;

    _classCallCheck(this, aPaginator);

    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.state = {
      id: props.id | Utils.Utils.uuid('APG')
    };
    return _this;
  }

  _createClass(aPaginator, [{
    key: "handleClick",
    value: function handleClick(e, page) {
      e.preventDefault();
      var event = Object.assign({}, e);
      event.target = this;
      event.page = page; // console.log("[aPaginator] selected page", page);

      if (this.props.onPageChange) this.props.onPageChange(event);
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {}
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      console.debug("aPaginator", this.props);
      var pid = this.state.id;
      var usePage = this.props.pageSize > 0 && this.props.pageCount > 1; // generate pages based on props

      var pages = [];
      var pageCount = this.props.pageCount;
      var page = this.props.page;
      var startPage = 1;
      var endPage = this.props.pageCount;
      var prevPage = null;
      var nextPage = null;
      var prevMore = null;
      var nextMore = null;

      if (usePage) {
        var maxPage = MAX_VIEWED_PAGE; // calc based on resolution width?

        if (pageCount > maxPage) {
          var half = Math.round(maxPage / 2);
          startPage = Math.max(1, page - half);
          endPage = Math.min(pageCount, page + half);

          if (endPage - startPage < maxPage) {
            if (startPage === 1) {
              endPage = maxPage + 1;
            } else if (endPage === pageCount) {
              startPage = endPage - maxPage - 1;
            }
          }

          prevMore = startPage - maxPage - half;
          if (prevMore < 1) prevMore = 1;
          nextMore = startPage + maxPage + half;
          if (nextMore > pageCount) nextMore = pageCount;
        }

        for (var p = startPage; p <= endPage; p++) {
          var pg = {};
          pg.num = p;
          pg.isCurrent = p === page;
          if (p === page - 1) prevPage = pg;
          if (p === page + 1) nextPage = pg;
          pages.push(pg);
        }
      }

      var prevMorePage = prevMore ? {
        num: prevMore
      } : null;
      var nextMorePage = nextMore ? {
        num: nextMore
      } : null; // console.warn("prev/next more page", pages, prevMorePage, nextMorePage);

      var itemName = this.props.count === 1 ? this.props.itemName : this.props.itemsName;
      return /*#__PURE__*/React__default['default'].createElement("nav", {
        className: "aPaginator clearfix",
        "aria-label": "Page navigation"
      }, /*#__PURE__*/React__default['default'].createElement("p", {
        className: "description"
      }, usePage && /*#__PURE__*/React__default['default'].createElement("span", {
        className: "descr-pages"
      }, "pagina ", page, " di ", pageCount), usePage && /*#__PURE__*/React__default['default'].createElement("span", {
        className: "descr-sep"
      }, " - "), /*#__PURE__*/React__default['default'].createElement("span", {
        className: "descr-counts"
      }, this.props.count, " ", itemName)), usePage && /*#__PURE__*/React__default['default'].createElement("ul", {
        className: Utils.Utils.union("pagination", " ", this.props.className)
      }, this.buildPage(pid, prevMorePage, /*#__PURE__*/React__default['default'].createElement("span", null, "<<"), "page-more", "prevmore"), this.buildPage(pid, prevPage, /*#__PURE__*/React__default['default'].createElement("span", null, "<"), "page-more", "prev"), pages.map(function (page) {
        return _this2.buildPage(pid, page);
      }), this.buildPage(pid, nextPage, /*#__PURE__*/React__default['default'].createElement("span", null, ">"), "page-more", "next"), this.buildPage(pid, nextMorePage, /*#__PURE__*/React__default['default'].createElement("span", null, ">>"), "page-more", "nextmore")));
    }
  }, {
    key: "buildPage",
    value: function buildPage(pid, page, symbol, cssClass, postid) {
      var _this3 = this;

      if (!page) page = {
        num: Utils.Utils.uuid(),
        isDisabled: true
      };
      var className = "page-item";

      if (page.isCurrent) {
        className = "page-item active";
      } else if (page.isDisabled) {
        className = "page-item disabled";
      }

      if (cssClass) className += " " + cssClass;
      var id = pid + "__" + page.num + "__" + postid;
      var sym = symbol || page.num;
      var title = page.isDisabled ? null : "Pagina #" + page.num;
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: id,
        "data-page-num": page.num,
        className: className
      }, page.isDisabled ? /*#__PURE__*/React__default['default'].createElement("span", {
        className: "page-link",
        title: title
      }, sym) : /*#__PURE__*/React__default['default'].createElement("a", {
        href: "javascript:;",
        className: "page-link",
        title: title,
        onClick: function onClick(e) {
          return _this3.handleClick(e, page.num);
        }
      }, sym));
    }
  }]);

  return aPaginator;
}(React$1.Component);

_defineProperty(aPaginator, "propTypes", {
  itemName: t__default['default'].string,
  itemsName: t__default['default'].string,
  count: t__default['default'].number,
  pageSize: t__default['default'].number,
  pageCount: t__default['default'].number,
  page: t__default['default'].number,
  onPageChange: t__default['default'].func
});

var DEFAULT_PAGE_SIZE = 10;
var DEFS = {
  NO_ELEMS: null
};

function pixelToInt(val, defVal) {
  if (val === undefined || val === null) return defVal || null;

  if (typeof val === "string") {
    if (val.endsWith("px")) val = val.substring(0, val.length - 2);
    return parseInt(val);
  }

  if (!isNaN(val)) return val;
  return defVal || null;
}
/*
class GridDef {
    static propTypes = {
        name: t.string, // es. city
        label: t.string, // es. città
        fieldPath: t.string // es. address.city
    }
}
*/

/**
 * aDataGrid - handle loading, view and pageing of an array of object data.
 * 
 * @author G. Annunziata
*/


var aDataGrid = /*#__PURE__*/function (_Component) {
  _inherits(aDataGrid, _Component);

  var _super = _createSuper(aDataGrid);

  function aDataGrid(props) {
    var _this;

    _classCallCheck(this, aDataGrid);

    _this = _super.call(this, props);
    _this.state = _this.initialState(props);
    _this.pageHandler = _this.pageHandler.bind(_assertThisInitialized(_this));
    _this.onChangeSort = _this.onChangeSort.bind(_assertThisInitialized(_this));
    _this.rowClickHandler = _this.rowClickHandler.bind(_assertThisInitialized(_this));
    _this.shouldComponentUpdate = PureRenderMixin__default['default'].shouldComponentUpdate.bind(_assertThisInitialized(_this));
    _this.treePrepare = _this.treePrepare.bind(_assertThisInitialized(_this));
    _this.treeRowVisible = _this.treeRowVisible.bind(_assertThisInitialized(_this));
    _this.treeChangeOpen = _this.treeChangeOpen.bind(_assertThisInitialized(_this));
    _this._patchScrollBar = _this._patchScrollBar.bind(_assertThisInitialized(_this));
    _this._applyScrollWidth = _this._applyScrollWidth.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(aDataGrid, [{
    key: "initialState",
    value: function initialState(props) {
      return {
        id: this.props.id || Utils.Utils.uuid("adg"),
        data: [],
        pageSize: DEFAULT_PAGE_SIZE,
        page: 1,
        count: 0,
        pageCount: 1,
        currentPage: null,
        selTree: props.useTree ? {} : null
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {

      var state = Object.assign({}, this.state); // state.id = this.props.id || Utils.uuid("DG");

      state.data = this.props.data || [];
      state.count = this.props.data ? this.props.data.length : 0;
      state.pageSize = this.props.pageSize;
      state.page = this.props.page;
      state.sort = this.buildSort(this.props.def);
      state.rowId = this.props.rowId;
      this.internUpdateOnState(state, true);
      this.setState(state, function () {// after set state
        // if (self.props.useTree)
        //      self.treePrepare(seòf.state.data);
      });
    }
  }, {
    key: "buildSort",
    value: function buildSort(def) {
      var res = {
        activeSort: null,
        availSort: []
      };
      if (this.props.useTree) return res;

      for (var i = 0; i < def.length; i++) {
        var d = def[i];
        if (!d.sortable) continue;
        var sortdef = {};
        sortdef.name = d.name;
        sortdef.field = d;
        sortdef.comparator = d.comparator || aDataGrid.builtinComparator;
        res.availSort.push(sortdef);

        if (d.activeSort) {
          res.activeSort = sortdef;
          res.activeSort.asc = d.activeSort === 'asc' ? true : false;
        }
      }

      return res;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var self = this;

      self._patchScrollBar(); //console.warn("adatagrid didmount");

    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._patchScrollBar();
    }
  }, {
    key: "_patchScrollBar",
    value: function _patchScrollBar() {
      var self = this; // setTimeout(function () {

      self._applyScrollWidth(self); // $("#" + self.state.id + "__grid").on('scroll', _.debounce(function () {
      //     self._applyScrollWidth(self);
      // }, 1));


      jquery__default['default']("#" + self.state.id + "__grid").scroll(function () {
        self._applyScrollWidth(self);
      }); // }, 3);
    }
  }, {
    key: "_applyScrollWidth",
    value: function _applyScrollWidth(self) {
      var sl = jquery__default['default']("#" + self.state.id + "__grid").scrollLeft();
      var w = jquery__default['default']("#" + self.state.id + "__grid").width();
      var ts = w / 10;

      var newWidth = w + sl;
      jquery__default['default']("#" + self.state.id + "__grid > *").width(newWidth);
      jquery__default['default']("#" + self.state.id + "__grid .col-fixed-left").each(function () {
        var row = jquery__default['default'](this);
        var l = row.attr("data-left");
        if (l === undefined) return;
        l = pixelToInt(l);

        if (l !== null) {
          if (sl > ts) {
            var _sbw = 6; // parseInt(row.attr("data-offset"));

            l -= _sbw; //parseInt(sbw);
          }

          row.css("left", l + sl + "px");
        }
      }); //console.debug("aDataGrid _applyScrollWidth", newWidth, sl);
    }
    /**
     * private.
     * assume if not null, a and b are the same type.
     * @param {*} a 
     * @param {*} b 
     */

  }, {
    key: "treePrepare",
    // TREE HANDLING =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    value: function treePrepare(data, state) {
      var self = this;
      if (!self.props.useTree) return null;
      if (!data) data = state.data || this.state.data; //console.warn("treePrepare()", data);

      var selTree = {}; // _.clone(this.state.selTree) || {};

      var treeIds = {};
      data.map(function (row, index) {
        var tt = row._tree;
        if (!tt) return null;
        treeIds[tt.id] = tt.parentId || null;
        if (!tt.hasknot) return null;

        if (self.props.treeOpened === undefined) {
          selTree[tt.id] = true;
        } else {
          if (self.props.treeOpened) {
            selTree[tt.id] = true;
          } else {
            if (tt.level === 0) {
              /* il livello zero non lo impostiamo come chiuso altrimenti l albero sarebbe formato da una sola riga
                  TODO: inserire una opzione in caso di necessita */
              selTree[tt.id] = true;
            } else {
              selTree[tt.id] = false;
            }
          }
        }
      }, this);
      var doSet = true;

      if (!state) {
        state = this.state;
      } else {
        doSet = false;
      }

      state.selTree = selTree;
      state.treeIds = treeIds;
      if (doSet) this.setState(state);
      return selTree;
    }
  }, {
    key: "treeRowVisible",
    value: function treeRowVisible(row) {
      var tt = row._tree;
      if (!tt) return true;
      if (!tt.parentId) return true;

      var res = this._treeRowVisible(tt.parentId, row); // if (!res) {
      //     console.warn("row non visibile",
      //         row,
      //         tt,
      //         this.state.selTree,
      //         this.state.treeIds);
      // }


      return res;
    }
  }, {
    key: "_treeRowVisible",
    value: function _treeRowVisible(parentId, row) {
      if (this.state.selTree[parentId] === undefined) {
        // console.warn("row non preparata", row);
        return false;
      }

      var val = this.state.selTree[parentId];

      if (!val) {
        return false;
      }

      parentId = this.state.treeIds[parentId];
      if (parentId === null || parentId === undefined) return true;
      return this._treeRowVisible(parentId, row);
    }
  }, {
    key: "treeOpened",
    value: function treeOpened(row) {
      var tt = row._tree;
      if (!tt) return true;
      return !!this.state.selTree[tt.id];
    }
  }, {
    key: "treeChangeOpen",
    value: function treeChangeOpen(col, row, index) {
      var tt = row._tree;
      if (!tt) return;
      var val = !this.treeOpened(row);
      this.setState(update__default$1['default'](this.state, {
        selTree: _defineProperty({}, tt.id, {
          $set: val
        })
      }));
    } // =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

  }, {
    key: "onChangeSort",
    value: function onChangeSort(name) {
      //console.log("[aDataGrid] sort by name:", name);
      var sort = this.state.sort;

      if (this.changeSort(name, sort)) {
        //NUOVO CODICE: INSERISCO UN FORCE UPDATE PER FAR CHIAMARE NUOVAMENTE LA RENDER AL CAMBIO STATO
        //console.log("[aDataGrid] makeSort end. Change state.");
        var state = Object.assign({}, this.state, {
          sort: sort
        });
        this.internUpdateOnState(state, true);
        this.setState(state);
        this.forceUpdate(); //VECCHIO CODICE CHE NON CHIAMAVA LA RENDER!
        // console.log("[aDataGrid] changeSort...");
        // let newdata = this.makeSort(this.state.data, sort);
        // if (newdata) {
        //     console.log("[aDataGrid] makeSort end. Change state.");
        //     let state = Object.assign({}, this.state, { data: newdata, sort: sort });
        //     this.internUpdateOnState(state, true);
        //     this.setState(state);
        // }
      }
    }
  }, {
    key: "changeSort",
    value: function changeSort(name, sort) {
      if (!name) {
        //console.log("name null");
        return false;
      } // tree cannot handle sort


      if (this.props.useTree) return false; //console.log("change sort:", sort, " - name:", name);

      var newSort = null;

      for (var i = 0; i < sort.availSort.length; i++) {
        var asrt = sort.availSort[i];

        if (asrt.name === name) {
          // found
          newSort = asrt;
          break;
        }
      }

      if (newSort === null) {
        //console.log("change sort - not found on avail sort");
        return false;
      }

      if (sort.activeSort !== null && sort.activeSort.name === newSort.name) {
        sort.activeSort.asc = !sort.activeSort.asc;
      } else {
        sort.activeSort = Object.assign({
          asc: true
        }, newSort); //console.log("change activeSort", sort.activeSort);
      }

      return true;
    }
  }, {
    key: "makeSort",
    value: function makeSort(data, sort) {
      var _this2 = this;

      if (sort === null || sort.activeSort === null) return null;

      if (sort.activeSort.comparator === null) {
        throw new Error("active sort without comparator function");
      }

      var newdata = data.sort(function (itemA, itemB) {
        var a, b;
        a = aDataGrid.getVal(sort.activeSort.field, itemA);
        b = aDataGrid.getVal(sort.activeSort.field, itemB);

        if (sort.activeSort.asc) {
          return sort.activeSort.comparator(a, b, itemA, itemB, _this2.props.retrieveRowId);
        } else {
          return sort.activeSort.comparator(b, a, itemB, itemA, _this2.props.retrieveRowId);
        }
      });
      return newdata;
    }
  }, {
    key: "rowClickHandler",
    value: function rowClickHandler(row) {
      // console.log("row clicked");
      if (this.props.onRowClick) {
        this.props.onRowClick(row);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      var self = this; // copy from current (initial) state

      if (self.state.data === props.data) ; else {
        //console.debug("adatagrid - change props with CHANGE data", self.state.data, props.data);
        var state = update__default$1['default'](this.state, {
          data: {
            $set: props.data || []
          },
          count: {
            $set: props.data ? props.data.length : 0
          }
        });
        this.internUpdateOnState(state, true);
        this.setState(state);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var self = this;
      var tbodyHeight = this.props.tbodyHeight;
      var AGrid = this.props.gridComponent || aTable;
      var AItem = this.props.itemComponent || null;
      var APaginator = aPaginator; //console.log("[aDataGrid] render", this.state, this.props);

      var noElems = this.props.noItemsLabel || DEFS.NO_ELEMS;
      var noDataComp = null;

      if (this.props.children) {
        noDataComp = /*#__PURE__*/React__default['default'].createElement("div", null, this.props.children);
      } else {
        noDataComp = noElems ? /*#__PURE__*/React__default['default'].createElement("p", null, noElems) : /*#__PURE__*/React__default['default'].createElement("p", null, Utils.i18n("V2.AGUI.ADATAGRID.NO_ELEM.NO", "Nessun"), ' ', this.props.itemName, ' ', Utils.i18n("V2.AGUI.ADATAGRID.NO_ELEM.AVAIL", "presente"), ".");
      }

      var loading = !!this.props.loading; // 

      var rch = null;
      if (this.props.onRowClick) rch = this.rowClickHandler;
      var noPaginator = this.props.noPaginator;
      var useTree = this.props.useTree;
      var rowVisibleOn = this.props.rowVisibleOn || null;

      if (useTree) {
        rowVisibleOn = this.treeRowVisible; // override
      }

      var def = this.props.def;

      if (useTree) {
        if (this.state.count > 0) {
          var ln = Object.keys(this.state.selTree).length;

          if (ln === 0) {
            console.log("TABELLA CON useTree MA non PREPARATA", this.state, this.props); // return null;
          }
        } //def = _.cloneDeep(def);lastColNotFixedIndex


        def = def.map(function (col, index) {
          // disattivo le colonne sortable per i tree
          col.sortable = false;
          col._index = index;

          if (col.treeNode) {
            // if (col.treeNodeDone)
            //     return col;
            // col.treeNodeDone = true;
            if (!col._oldRenderer) col._oldRenderer = col.renderer || function (val) {
              return val;
            };

            col.renderer = function (val, col, item, index) {
              var origRender = col._oldRenderer(val, col, item, index);

              var ident = [];

              for (var i = 0; i < item._tree.level; i++) {
                ident.push( /*#__PURE__*/React__default['default'].createElement("div", {
                  className: "ident",
                  key: item._tree.id + "_" + i
                }));
              }

              var knot = /*#__PURE__*/React__default['default'].createElement("i", {
                className: "fa fa-square-o noArrow"
              });
              var onClick = null;

              if (item._tree.hasknot) {
                onClick = function onClick(e) {
                  //console.log("CHANGE knot", col, item, index, self.state.selTree);
                  self.treeChangeOpen(col, item, index);
                };

                var icon = " fa fa-caret-down ";

                if (self.props.knotIcon) {
                  icon = self.props.knotIcon;
                }

                knot = /*#__PURE__*/React__default['default'].createElement("i", {
                  className: " arrow " + icon + (self.treeOpened(item) ? " open " : " "),
                  onClick: onClick
                });
              }

              return /*#__PURE__*/React__default['default'].createElement("div", {
                className: "tree-knot"
              }, /*#__PURE__*/React__default['default'].createElement("div", {
                className: "pre-space"
              }, ident, knot), /*#__PURE__*/React__default['default'].createElement("div", {
                className: "tree-view-elem"
              }, origRender));
            };
          }

          return col;
        }, this);
      }

      var gridProps = {
        id: this.state.id + "__grid",
        def: def,
        data: this.state.count > 0 ? this.state.currentPage : [],
        className: this.props.className,
        sort: this.state.sort,
        detailsRenderer: this.props.detailsRenderer,
        onRowClick: rch,
        onChangeSort: this.onChangeSort,
        tbodyHeight: tbodyHeight,
        rowVisibleOn: rowVisibleOn,
        rowCssClassCalculate: this.props.rowCssClassCalculate,
        itemComponent: AItem,
        fixed: this.props.fixed || false,
        fixedCols: this.props.fixedCols,
        // = {first: 2, last: 1}
        compact: this.props.compact || false,
        useTabIndex: this.props.useTabIndex,
        rowId: this.state.rowId
      };
      var pagrProps = {
        id: this.state.id + "__pg",
        itemName: this.props.itemName,
        itemsName: this.props.itemsName,
        count: this.state.count,
        pageSize: this.state.pageSize,
        pageCount: this.state.pageCount,
        page: this.state.page,
        className: this.props.pageClassName,
        onPageChange: function onPageChange(e) {
          return _this3.pageHandler(e);
        }
      };
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: Utils.Utils.union("aDataGrid", " ", this.props.gridClassName)
      }, this.props.loadingBg === true && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "loading-bg"
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        className: "fa fa-spinner fa-pulse text-primary"
      })), loading && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "loading-box"
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        className: "fa fa-spinner fa-pulse"
      }), " ", Utils.i18n("V2.AGUI-adatagrid.LOADING", "Caricamento"), "..."), this.state.count > 0 ? /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "aTableContainer"
      }, /*#__PURE__*/React__default['default'].createElement(AGrid, gridProps)), !noPaginator && /*#__PURE__*/React__default['default'].createElement(APaginator, pagrProps)) : !loading && (this.props.showColumns === true ? /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "aTableContainer has-no-data"
      }, /*#__PURE__*/React__default['default'].createElement(AGrid, gridProps)), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "no-data"
      }, noDataComp)) : /*#__PURE__*/React__default['default'].createElement("div", {
        className: "no-data"
      }, noDataComp)));
    }
  }, {
    key: "pageHandler",
    value: function pageHandler(event) {
      //console.log("[aDataGrid] pageHandler event:", event);
      var page = event.page; //console.log("[aDataGrid] change to page", page);

      var oldPage = this.state.page;

      if (page !== oldPage) {
        //console.log("page changed.... create new state");
        var state = Object.assign({}, this.state);
        state.page = page; // check page!?!

        if (this.internUpdateOnState(state, true)) this.setState(state);
      }
    } // private 

  }, {
    key: "internUpdateOnState",
    value: function internUpdateOnState(state, toRecreate) {
      var someChanges = false;
      state.page;

      if (isNaN(state.pageSize) || this.props.pageSize < 0) {
        this.props.pageSize = DEFAULT_PAGE_SIZE;
        someChanges = true;
      }

      if (state.data === undefined || state.data === null) {
        state.data = [];
        state.count = 0;
        someChanges = true;
      }

      state.count = state.data.length;
      var usePage = this.props.pageSize > 0;
      state.usePage = usePage;

      if (usePage) {
        state.pageCount = Math.ceil(state.count / state.pageSize);

        if (state.pageCount < 1) {
          state.pageCount = 1;
          someChanges = true;
        }
      } else {
        state.pageCount = 1;
      }

      if (toRecreate) {
        var newdata = this.makeSort(state.data, state.sort);

        if (newdata !== null) {
          state.data = newdata;
          someChanges = true;
        }
      }

      var pageToRecreate = toRecreate;

      if (isNaN(state.page) || state.page < 1) {
        state.page = 1;
        pageToRecreate = true;
      }

      if (state.page > state.pageCount) {
        state.page = state.pageCount;
        pageToRecreate = true;
      }

      if (pageToRecreate || state.currentPage === null) {
        if (usePage) {
          var start = (state.page - 1) * this.props.pageSize;
          var end = Math.min(state.page * this.props.pageSize, state.count);
          var cp = [];

          for (var i = start; i < end; i++) {
            var elem = state.data[i];
            cp.push(elem);
          }

          state.currentPage = cp;
        } else {
          state.currentPage = state.data;
        }

        someChanges = true;
      }

      if (this.treePrepare(state.data, state)) {
        someChanges = true;
      } //console.debug("aDataGrid._updateOnState: something changes?", someChanges);


      return someChanges;
    }
  }], [{
    key: "builtinComparator",
    value: function builtinComparator(a, b, itemA, itemB, retrieveRowId) {
      if (a === undefined) a = null;
      if (b === undefined) b = null;
      if (a === null && b === null) return 0;
      if (a === null) return 1;
      if (b === null) return -1; // check on type date

      if (a instanceof Date) {
        var dateA = a.getTime();
        var dateB = b.getTime();
        return dateA < dateB ? -1 : dateA === dateB ? 0 : -1;
      } // any not number


      if (isNaN(a)) {
        var aa = a.toString().toLowerCase();
        var bb = b.toString().toLowerCase();
        return aa.localeCompare(bb);
      }

      if (a < b) return -1;

      if (a === b) {
        if (!retrieveRowId) return 0;else {
          var idA = retrieveRowId(itemA);
          var idB = retrieveRowId(itemB);
          return idA.localeCompare(idB);
        }
      }

      return 1;
    }
  }, {
    key: "getVal",
    value: function getVal(col, item) {
      return aTable.getVal(col, item);
    }
  }]);

  return aDataGrid;
}(React$1.Component);

_defineProperty(aDataGrid, "propTypes", {
  id: t__default['default'].string,
  gridComponent: t__default['default'].node,
  itemComponent: t__default['default'].node,
  itemName: t__default['default'].string,
  itemsName: t__default['default'].string,
  def: t__default['default'].arrayOf(t__default['default'].object),
  data: t__default['default'].arrayOf(t__default['default'].object),
  noPaginator: t__default['default'].bool,
  pageSize: t__default['default'].number,
  page: t__default['default'].number,
  onRowClick: t__default['default'].func,
  pageClassName: t__default['default'].string,
  showColumns: t__default['default'].bool,
  detailsRenderer: t__default['default'].func,
  rowCssClassCalculate: t__default['default'].func,
  loading: t__default['default'].bool,
  // se true visualizza un overlay di loading dati
  loadingBg: t__default['default'].bool // se true visualizza un loading dati in alto a destra

});

_defineProperty(aDataGrid, "defaultProps", {
  gridComponent: null,
  itemComponent: null,
  itemName: Utils.i18n("V2.AGUI.ADATAGRID.ELEMENT", "elemento"),
  itemsName: Utils.i18n("V2.AGUI.ADATAGRID.ELEMENTS", "elementi"),
  pageSize: DEFAULT_PAGE_SIZE,
  onRowClick: null,
  pageClassName: null,
  showColumns: false,
  loading: false,
  loadingBg: false
});

/**
 * aTable
 * 
*/

var aTable$1 = /*#__PURE__*/function (_Component) {
  _inherits(aTable, _Component);

  var _super = _createSuper(aTable);

  function aTable(props) {
    var _this;

    _classCallCheck(this, aTable);

    _this = _super.call(this, props);
    _this.sortIcon = _this.sortIcon.bind(_assertThisInitialized(_this));
    _this.sortClass = _this.sortClass.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(aTable, [{
    key: "sortClass",
    value: function sortClass(col) {
      if (!col || !col.sortable) return "";
      if (this.props === null) return "text-danger";
      if (this.props.sort === null || this.props.sort.activeSort === null) return "";
      if (this.props.sort.activeSort.name !== col.name) return "";
      return "active";
    }
  }, {
    key: "sortIcon",
    value: function sortIcon(col) {
      if (!col || !col.sortable) return "";
      if (this.props === null) return "fa fa-exclamation-triangle";
      if (this.props.sort === null || this.props.sort.activeSort === null) return "";
      if (this.props.sort.activeSort.name !== col.name) return ""; // equals

      if (this.props.sort.activeSort.asc) return "fa fa-sort-asc";else return "fa fa-sort-desc";
    }
  }, {
    key: "rowClickHandler",
    value: function rowClickHandler(row) {
      if (this.props.onRowClick) this.props.onRowClick(row);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      console.log("[aTable] render");
      var data = this.props.data;

      if (!data) {
        console.warn("no data?!?!?");
        data = [];
      }

      var def = this.props.def;

      if (!def) {
        console.error("[aTable] NO DEFINITION COLUMNS");
        throw new Error("[aTable] NO DEFINITION COLUMNS");
      }

      var tbAddClz = this.props.onRowClick ? ' clickable-row table-hover' : '';
      var clz;
      clz = Utils.Utils.union('aTable table ' + tbAddClz, ' ', this.props.className); // FUTURE da vedere se aggiungere classe table-responsive dopo che union() funziona con -table-responsive

      return /*#__PURE__*/React__default['default'].createElement("table", {
        id: this.props.id,
        className: clz
      }, /*#__PURE__*/React__default['default'].createElement("thead", null, /*#__PURE__*/React__default['default'].createElement("tr", null, def.map(function (col) {
        if (!col || col.visible === false) return null;
        return /*#__PURE__*/React__default['default'].createElement("th", {
          key: col.name,
          className: col.thClassName ? col.thClassName : col.className ? col.className : ''
        }, col.sortable && /*#__PURE__*/React__default['default'].createElement("a", {
          href: "javascript:;",
          className: _this2.sortClass(col),
          onClick: function onClick(e) {
            _this2.props.onChangeSort(col.name);
          }
        }, col.label, ' ', /*#__PURE__*/React__default['default'].createElement("i", {
          className: _this2.sortIcon(col)
        })), !col.sortable && col.label);
      }))), /*#__PURE__*/React__default['default'].createElement("tbody", null, data.map(function (item, index) {
        var baseRow = _this2.props.def.map(function (col) {
          if (col.visible === false) return null;
          return /*#__PURE__*/React__default['default'].createElement("td", {
            key: col.name,
            className: col.className ? col.className : '',
            "data-toggle": col.openDetails ? 'collapse' : null,
            "data-target": col.openDetails ? '#detail_' + index : ''
          }, _this2.renderVal(col, item, index));
        });

        if (_this2.props.detailsRenderer) {
          return [/*#__PURE__*/React__default['default'].createElement("tr", {
            key: index,
            onClick: _this2.rowClickHandler.bind(_this2, item),
            className: "accordion-toggle"
          }, baseRow), /*#__PURE__*/React__default['default'].createElement("tr", null, /*#__PURE__*/React__default['default'].createElement("td", {
            colSpan: _this2.props.def.length,
            className: "hiddentablerow"
          }, /*#__PURE__*/React__default['default'].createElement("div", {
            id: 'detail_' + index,
            className: "accordian-body collapse"
          }, " ", _this2.renderDetail(_this2.props.detailsRenderer, item, index))))];
        } else {
          return /*#__PURE__*/React__default['default'].createElement("tr", {
            key: index,
            onClick: _this2.rowClickHandler.bind(_this2, item)
          }, baseRow);
        }
      })));
    }
  }, {
    key: "renderDetail",
    value: function renderDetail(detailsRenderer, item, index) {
      if (detailsRenderer) {
        return detailsRenderer(item, index);
      } else {
        return null;
      }
    }
  }, {
    key: "renderVal",
    value: function renderVal(col, item, index) {
      var val = aTable.getVal(col, item);

      if (col.formatter) {
        var newval = col.formatter(val, col, item, index);
        val = newval;
      }

      if (col.renderer) {
        var rd = col.renderer(val, col, item, index);
        if (rd === null) return "";
        return rd;
      }

      if (val === null) return "";
      return val.toString();
    }
  }], [{
    key: "getVal",
    value: function getVal(col, item) {
      if (item === null || item === undefined) return null;
      if (!col || !col.fieldPath) return null; // use path to get value

      var idx = ("" + col.fieldPath).indexOf('.');
      if (idx === -1) return item[col.fieldPath];else {
        var pp = col.fieldPath.split('.');
        var o = item;

        for (var i = 0; i < pp.length; i++) {
          o = o[pp[i]];

          if (o === null || o === undefined) {
            o = null;
            break;
          }
        }

        return o;
      }
    }
  }]);

  return aTable;
}(React$1.Component);

_defineProperty(aTable$1, "propTypes", {
  id: t__default['default'].string,
  def: t__default['default'].arrayOf(t__default['default'].object),
  data: t__default['default'].arrayOf(t__default['default'].object),
  detailsRenderer: t__default['default'].func,
  onChangeSort: t__default['default'].func,
  onRowClick: t__default['default'].func,
  itemComponent: t__default['default'].node // not used for table

});

var MAX_VIEWED_PAGE$1 = 8;
/**
 * aTable
 * 
*/

var aPaginator$1 = /*#__PURE__*/function (_Component) {
  _inherits(aPaginator, _Component);

  var _super = _createSuper(aPaginator);

  function aPaginator(props) {
    var _this;

    _classCallCheck(this, aPaginator);

    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(aPaginator, [{
    key: "handleClick",
    value: function handleClick(e, page) {
      e.preventDefault();
      var event = Object.assign({}, e);
      event.target = this;
      event.page = page; // console.log("[aPaginator] selected page", page);

      if (this.props.onPageChange) this.props.onPageChange(event);
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.pid = this.props.id | Utils.Utils.uuid('APG');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var pid = this.pid;
      var usePage = this.props.pageSize > 0 && this.props.pageCount > 1; // generate pages based on props

      var pages = [];

      if (usePage) {
        var sp = 1;
        var ep = this.props.pageCount;
        var maxPage = MAX_VIEWED_PAGE$1; // calc based on resolution width?

        var half = Math.round(maxPage / 2);

        if (this.props.pageCount > maxPage) {
          sp = Math.max(1, this.props.page - half);
          ep = Math.min(this.props.pageCount, this.props.page + half);

          if (ep - sp < maxPage) {
            if (sp === 1) {
              ep = maxPage + 1;
            } else if (ep === this.props.pageCount) {
              sp = ep - maxPage - 1;
            }
          }
        }

        for (var p = sp; p <= ep; p++) {
          var pg = {};
          pg.num = p;
          pg.isCurrent = p === this.props.page;
          pages.push(pg);
        }
      }

      var prev = null;
      var next = null;
      var itemName = this.props.count === 1 ? this.props.itemName : this.props.itemsName;
      return /*#__PURE__*/React__default['default'].createElement("nav", {
        className: "aPaginator clearfix",
        "aria-label": "Page navigation"
      }, /*#__PURE__*/React__default['default'].createElement("p", {
        className: "description"
      }, usePage && /*#__PURE__*/React__default['default'].createElement("span", {
        className: "descr-pages"
      }, "pagina ", this.props.page, " di ", this.props.pageCount), usePage && /*#__PURE__*/React__default['default'].createElement("span", {
        className: "descr-sep"
      }, " - "), /*#__PURE__*/React__default['default'].createElement("span", {
        className: "descr-counts"
      }, this.props.count, " ", itemName)), usePage && /*#__PURE__*/React__default['default'].createElement("ul", {
        className: Utils.Utils.union("pagination", " ", this.props.className)
      }, prev , pages.map(function (page) {
        return _this2.buildPage(pid, page);
      }), next ));
    }
  }, {
    key: "buildPage",
    value: function buildPage(pid, page) {
      var _this3 = this;

      if (!page) return "";
      var className = "page-item";

      if (page.isCurrent) {
        className = "page-item active";
      } else if (page.isDisabled) {
        className = "page-item disabled";
      }

      var id = pid + "__" + page.num;
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: id,
        "data-page-num": page.num,
        className: className
      }, page.isDisabled ? /*#__PURE__*/React__default['default'].createElement("span", {
        className: "page-link"
      }, page.num) : /*#__PURE__*/React__default['default'].createElement("a", {
        href: "javascript:;",
        className: "page-link",
        onClick: function onClick(e) {
          return _this3.handleClick(e, page.num);
        }
      }, page.num));
    }
  }]);

  return aPaginator;
}(React$1.Component);

_defineProperty(aPaginator$1, "propTypes", {
  itemName: t__default['default'].string,
  itemsName: t__default['default'].string,
  count: t__default['default'].number,
  pageSize: t__default['default'].number,
  pageCount: t__default['default'].number,
  page: t__default['default'].number,
  onPageChange: t__default['default'].func
});

/**
 * INTERFACCIA di un loader.
 * MUST implements (override) all this methods.
 * 
 */
var ILoader = /*#__PURE__*/function () {
  function ILoader() {
    _classCallCheck(this, ILoader);
  }

  _createClass(ILoader, [{
    key: "init",

    /**
     * init (lazy) of query
     * @param {*} sortBy 
     * @param {*} sortAsc 
     * @param {*} sortComparator 
     * @param {*} initialData 
     * @return {Object} result with count value (by now) and evetually error message
     */
    value: function init(sortBy, sortAsc, sortComparator, initialData) {
      throw Error("NOT IMPLEMENTED METHOD init(...)");
    }
    /**
     * load data based on from/to and sort parameters;
     * eventually async.
     * 
     * @param {*} from 
     * @param {*} to 
     * @param {*} sortBy 
     * @param {*} sortAsc true if must be ascedent, false otherwise
     * @param {*} sortComparator 
     * @param {*} callOk 
     * @param {*} callErr 
     */

  }, {
    key: "load",
    value: function load(from, to, sortBy, sortAsc, sortComparator, callOk, callErr) {
      throw Error("NOT IMPLEMENTED METHOD load(...)"); // EXAMPLE...
    }
  }, {
    key: "getStatus",
    value: function getStatus() {
      return {
        name: "no loader status"
      };
    }
    /**
     * set external data.
     * 
     * @param {Array[]} data 
     */

  }, {
    key: "setData",
    value: function setData(data) {// default do nothing
    }
  }]);

  return ILoader;
}();

var LocalDataLoader = /*#__PURE__*/function (_ILoader) {
  _inherits(LocalDataLoader, _ILoader);

  var _super = _createSuper(LocalDataLoader);

  function LocalDataLoader() {
    var _this;

    _classCallCheck(this, LocalDataLoader);

    _this = _super.call(this);
    _this.localData = [];
    _this.count = 0;
    _this.sortBy = null;
    _this.sortAsc = null;
    _this.sortComparator = null;
    _this.lastOperation = "none";
    return _this;
  }

  _createClass(LocalDataLoader, [{
    key: "getStatus",
    value: function getStatus() {
      return {
        name: "LocalDataLoader",
        localCount: this.localData.length,
        count: this.count,
        sortBy: this.sortBy,
        sortAsc: this.sortAsc,
        lastOperation: this.lastOperation
      };
    } // extra

  }, {
    key: "setData",
    value: function setData(data) {
      console.log("DEBUG - LOCALDATA.loader: setData", data);
      this.localData = data || [];
    }
  }, {
    key: "init",
    value: function init(sortBy, sortAsc, sortComparator, initialData, callok, callerr) {
      console.log("DEBUG - LOCALDATA.loader: initializing...", initialData);
      this.sortBy = sortBy;
      this.sortAsc = sortAsc;
      this.sortComparator = sortComparator || null;
      this.localData = initialData || [];
      this.count = this.localData.length;

      if (sortBy !== null && sortBy !== undefined && sortBy !== this.sortBy || sortAsc !== this.sortAsc) {
        var newdata = LocalDataLoader._makeSort(this.localData, sortBy, sortAsc, sortComparator);

        this.localData = newdata || [];
      }

      this.lastOperation = "LOCALDATA loader: nitialized.";

      if (callok) {
        callok({
          count: this.count
        });
      }
    }
  }, {
    key: "load",
    value: function load(from, to, sortBy, sortAsc, sortComparator, callok, callerr) {
      console.log("DEBUG - LOCALDATA.loader - load", from, to);
      this.lastOperation = "LOCALDATA loader: loading";

      if (sortBy !== null && sortBy !== undefined && sortBy !== this.sortBy || sortAsc !== this.sortAsc) {
        var newdata = LocalDataLoader._makeSort(this.localData, sortBy, sortAsc, sortComparator);

        this.sortBy = sortBy;
        this.sortAsc = sortAsc;
        this.sortComparator = sortComparator || null;
        this.localData = newdata || [];
      }

      if (!this.localData) {
        console.error("DEBUG - LOCALDATA.loader -no local data", this);
        this.lastOperation = "LOCALDATA loader: load error - non local data";

        if (callerr) {
          callerr({
            error: "no data"
          });
        }

        return;
      }

      if (from < 0) from = 0;
      if (to > this.localData.length) to = this.localData.length;
      var page = [];

      for (var i = from; i < to; i++) {
        var item = this.localData[i];
        page.push(item);
      }

      console.warn("DEBUG - LOCALDATA loader loaded num:" + page.length);
      this.lastOperation = "LOCALDATA loader: load ok for " + page.length + " record(s)";

      if (callok) {
        var res = {
          data: page
        };
        console.warn("DEBUG - LOCALDATA loader callok with res:", res);
        callok(res);
      }

      return;
    }
  }], [{
    key: "_makeSort",
    value: function _makeSort(data, sortby, sortAsc, sortComparator) {
      if (sortby === null || sortAsc === null) return data;
      var comparator = sortComparator || LocalDataLoader._builtinComparator;

      if (comparator === null || comparator === undefined) {
        throw new Error("comparator required");
      }

      var newdata = data.sort(function (itemA, itemB) {
        var a, b;
        a = Utils.Utils.getVal(sortby, itemA);
        b = Utils.Utils.getVal(sortby, itemB);

        if (sortAsc) {
          return comparator(a, b, itemA, itemB);
        } else {
          return comparator(b, a, itemB, itemA);
        }
      });
      return newdata;
    }
    /**
     * private.
     * assume if not null, a and b are the same type.
     * @param {*} a 
     * @param {*} b 
     */

  }, {
    key: "_builtinComparator",
    value: function _builtinComparator(a, b) {
      if (a === undefined) a = null;
      if (b === undefined) b = null;
      if (a === null && b === null) return 0;
      if (a === null) return 1;
      if (b === null) return -1; // check on type date

      if (a instanceof Date) {
        var dateA = a.getTime();
        var dateB = b.getTime();
        return dateA < dateB ? -1 : dateA === dateB ? 0 : -1;
      } // any not number


      if (isNaN(a)) {
        var aa = a.toString().toLowerCase();
        var bb = b.toString().toLowerCase();
        return aa.localeCompare(bb);
      }

      if (a < b) return -1;
      if (a === b) return 0;
      return 1;
    }
  }]);

  return LocalDataLoader;
}(ILoader);

var BdDefaultOptions = {
  extLoader: null,
  initialData: null,
  sortBy: null,
  sortAsc: true,
  sortComparator: null,
  loadingRow: {},
  bufferPageSize: 1000,
  bufferOffset: 500,
  expirePages: 20,
  minPageDistance: 5,
  pageSize: 0,
  usePage: false,
  count: 0
};
/**
 * DataBuffer
 * handle data, with a buffer, and partial loading, from loader.
 * 
 * 
 * @author G. Annunziata
 */

var DataBuffer = /*#__PURE__*/function () {
  function DataBuffer(datagrid, options) {
    _classCallCheck(this, DataBuffer);

    console.log("[DataBuffer] - BUILD databuffer - constructor");

    var opts = ___default['default'].extend({}, BdDefaultOptions, options);

    this.opts = opts; // checkout param bounds

    if (opts.bufferPageSize < 50) opts.bufferPageSize = 50; // fixed to half of buffer page size

    opts.bufferOffset = opts.bufferPageSize / 2;
    this.datagrid = datagrid; // recupera da opts e ne azzera i valori per:
    // count, initialData, loader

    this.initialData = opts.initialData || null;
    opts.initialData = null;
    this.loader = opts.loader || new LocalDataLoader();
    opts.loader = null;
    this.loadError = null;
    this.lastCall = null;
    this.dataView = [];
    this.buffer = {};
    this.pageState = {};
    this.sortBy = opts.sortBy;
    this.sortAsc = opts.sortAsc;

    if (opts.expirePages) {
      this.readPages = [];
      this.expirePages = opts.expirePages;
    }

    this.initialized = false;
    this.numRawLoad = 0;
    this.loading = 0;
    this.lastError = null;
    this.lastMessage = null;
  }

  _createClass(DataBuffer, [{
    key: "init",
    value: function init() {
      var self = this;
      return this._init().then(function (count) {
        self.count = count;
        if (count > 0) self.assurePage(0);
        return count;
      });
    }
  }, {
    key: "reinit",
    value: function reinit() {
      this.initialized = false;

      this._removeAllData();

      return this.init();
    }
  }, {
    key: "_startLoad",
    value: function _startLoad() {
      this.loading++;
      this.datagrid.reloadGrid();
    }
  }, {
    key: "_endLoad",
    value: function _endLoad() {
      this.loading--;
      if (this.loading < 0) this.loading = 0;
      this.datagrid.reloadGrid();
    }
  }, {
    key: "changeSort",
    value: function changeSort(newSortBy, newSortAsc, newSortCompare) {
      console.log("[DataBuffer] changeSort", newSortBy, newSortAsc);

      this._removeAllData();

      this.sortBy = newSortBy;
      this.sortAsc = newSortAsc;
      if (newSortCompare) this.opts.sortComparator = newSortCompare;
      return true;
    }
  }, {
    key: "changeCount",
    value: function changeCount(newcount) {
      console.log("[DataBuffer] changeCount", newcount);

      if (!this.initialData) {
        this._removeAllData();

        this.count = newcount;
        this.numBufferPages = Math.round(newcount / this.opts.bufferPageSize) || 0;
        if (this.numBufferPages < 1) this.numBufferPages = 1;
        this.loader.setCount(newcount);
      }
    }
  }, {
    key: "getCount",
    value: function getCount() {
      if (!this.isInitialized()) return 0;
      return this.count;
    }
  }, {
    key: "changeInitialData",
    value: function changeInitialData(data) {
      if (this.initialData) {
        this._removeAllData();

        newcount = data.length;
        this.initialData = data;
        this.count = newcount;
        this.numBufferPages = Math.round(this.count / opts.bufferPageSize) || 0;
        if (this.numBufferPages < 1) this.numBufferPages = 1;
        this.loader.setData(this.initialData);
      }
    }
  }, {
    key: "getStatus",
    value: function getStatus() {
      var numIdPages = Object.getOwnPropertyNames(this.buffer);
      var res = {
        numBufferedPages: numIdPages.length,
        bufferedPages: numIdPages,
        numPageStates: Object.getOwnPropertyNames(this.pageState).length,
        numRawLoad: this.numRawLoad,
        loading: this.loading > 0,
        lastError: this.lastError,
        lastMessage: this.lastMessage,
        loaderStatus: this.loader && this.loader.getStatus ? this.loader.getStatus() : {
          mesg: "no loader getStatus()"
        }
      };

      if (this.expirePages) {
        res.numReadPages = this.readPages.length;
        res.readPages = this.readPages;
        res.readPageQueueSize = this.expirePages;
        res.minPageDistance = this.opts.minPageDistance;
      }

      return res;
    }
  }, {
    key: "_cleanPage",
    value: function _cleanPage(nid) {
      if (this.buffer[nid]) delete this.buffer[nid];
      if (this.pageState[nid]) delete this.pageState[nid]; //this.buffer[nid] = [];
      //this.pageState[nid] = [];
    }
  }, {
    key: "_removeAllData",
    value: function _removeAllData() {
      var props = Object.getOwnPropertyNames(this.buffer);

      for (var i = 0; i < props.length; i++) {
        this._cleanPage(props[i]);
      }

      this.buffer = {};
      this.pageState = {};
      this.loading = 0;

      if (this.expirePages) {
        this.readPages = [];
      }

      console.log("[DataBuffer] removeAllData DONE");
    }
  }, {
    key: "_numPageId",
    value: function _numPageId(numPage) {
      if (numPage === null || numPage === undefined) return null;
      return "pg" + numPage;
    }
  }, {
    key: "reloadPage",
    value: function reloadPage(numPage) {
      this.assurePage(numPage, true);
    }
  }, {
    key: "_init",
    value: function _init() {
      var self = this;
      return new Promise(function (resolve, reject) {
        if (self.isInitialized()) {
          resolve(self.getCount());
          return;
        }

        self._startLoad();

        self.loader.init(self.sortBy, self.sortAsc, self.opts.sortComparator, self.initialData, function (res) {
          self._endLoad();

          if (res && res.count !== null && res.count !== undefined) {
            self.changeCount(res.count);
            self.initialized = true;
            console.debug("init ok");
            resolve(res.count);
          } else {
            console.debug("no init?!");
            self.initialized = true;
            resolve(0);
          }
        }, function (res) {
          self._endLoad();

          if (!res || res.error) {
            console.error("[DataBuffer] init error", res && res.error);
            reject(res.error);
          } else {
            reject("assureInit error");
          }
        });
      });
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      return this.initialized;
    }
  }, {
    key: "assurePage",
    value: function assurePage(numPage, force) {
      var _this = this;

      var self = this;
      if (!this.isInitialized()) return; // _.debounce(function () {
      // decide quali pagine cercare di caricare

      var pages = [];
      if (numPage > 0) pages.push(numPage - 1);
      pages.push(numPage);
      if (numPage < this.numBufferPages - 1) pages.push(numPage + 1); // filtro pagine da NON ricaricare...
      // console.debug("[DataBuffer] DEBUG - filter pages", pages.length, pages);

      pages = pages.filter(function (page) {
        var pid = self._numPageId(page);

        if (self.buffer[pid] === undefined || self.buffer[pid] === null) {
          console.log("page " + page + "/" + pid + " isn't into buffer, load it");
          return true;
        }

        var pgstate = this.pageState[pid];

        if (!pgstate) {
          pgstate = {
            lastError: null,
            loading: false
          };
          self.pageState[pid] = pgstate;
        }

        var mustLoad = !pgstate.loading && !!force; // console.debug("page " + page + "/" + pid + " loading?", pgstate.loading, " must load:", mustLoad, " force:", force);

        return mustLoad;
      }, self);

      if (pages.length === 0) {
        // console.log("[DataBuffer] nothing to load");
        return;
      } //_.debounce(function () {
      // console.log("[DataBuffer] DEBUG - ASSURE PAGE(s) LOAD", pages.length, pages);


      self.numRawLoad++; // pgstate to loading

      pages.forEach(function (numPage) {
        var pid = self._numPageId(numPage);

        var pgstate = self.pageState[pid];

        if (!pgstate) {
          pgstate = {
            lastError: null,
            loading: false
          };
          _this.pageState[pid] = pgstate;
        }

        pgstate.loading = true;
        pgstate.lastError = null;
        self.buffer[pid] = [];
      }, self);
      var from = pages[0] * this.opts.bufferPageSize;
      var to = (pages[pages.length - 1] + 1) * this.opts.bufferPageSize; // let size = to - from;

      console.debug("[DataBuffer] DEBUG - load from " + from + " to " + to, this.sortBy, this.sortAsc);

      self._startLoad();

      this.loader.load(from, to, this.sortBy, this.sortAsc, this.opts.sortComparator, // ok 
      function (res) {
        console.log("[DataBuffer] - assurePage - load result", res);
        pages.forEach(function (page, index) {
          var pid = self._numPageId(page);

          var pgstate = self.pageState[pid];

          if (!pgstate) {
            pgstate = {
              lastError: null,
              loading: false
            };
            self.pageState[pid] = pgstate;
          }

          pgstate.loading = false;
          pgstate.lastError = null;

          if (res && res.data) {
            var ff = index * self.opts.bufferPageSize;
            var tt = (index + 1) * self.opts.bufferPageSize;
            if (tt > res.data.length) tt = res.data.length;
            self.buffer[pid] = res.data.slice(ff, tt);
            self.handleReadedPages(page);
          } else {
            console.error("[DataBuffer] - assurePage - result from load not valid", res);
          }
        }, self); //  console.debug("[DataBuffer] - assurePage - end load + reload");

        self._endLoad();

        self.datagrid.reloadGrid();
        return "ok";
      }, // error
      function (err) {
        self._endLoad();

        self.lastError = err;
        pages.forEach(function (page, index) {
          var pid = self._numPageId(page);

          var pgstate = self.pageState[pid];

          if (!pgstate) {
            pgstate = {
              lastError: null,
              loading: false
            };
            self.pageState[pid] = pgstate;
          }

          pgstate.loading = false;
          pgstate.lastError = err;
        }, self);
        self.datagrid.reloadGrid();
        return "err";
      }); // end func debounced
      //}, 1000);

      /*, {
          leading: true,
          trailing: false
      });*/
    }
  }, {
    key: "getPage",
    value: function getPage(numPage) {
      var nid = this._numPageId(numPage);

      return this.buffer[nid] || [];
    }
  }, {
    key: "get",
    value: function get(index) {
      var self = this; // index = Math.abs(index);

      if (index < 0 || index >= self.getCount()) {
        return null;
      }

      var numPage = Math.floor(index / this.opts.bufferPageSize); // console.log("request element #"+index+" - found at page:"+numPage);

      var off = index % this.opts.bufferPageSize;
      if (off < 0) off = 0;
      if (numPage < 0) numPage = 0;

      if (numPage >= this.numBufferPages) {
        numPage = this.numBufferPages - 1;
      }

      self.assurePage(numPage);

      var nid = this._numPageId(numPage);

      var page = this.buffer[nid] || [];
      var pgstate = this.pageState[nid];

      if (off < 0 || page.length <= off) {
        if (!pgstate || pgstate.loading) {
          // still is not loaded
          return this.opts.loadingRow || {}; // null?
        }

        console.error("BigDataHandler - page.length: " + page.length + " - load page error (network?) or offset: calc (" + off + ")");
        return null;
      }

      return page[off];
    }
  }, {
    key: "handleReadedPages",
    value: function handleReadedPages(numPage) {
      if (!this.expirePages) {
        // console.debug("expire not active");
        return;
      }

      var lastPage = this.readPages[this.readPages.length - 1];

      if (lastPage === numPage) {
        // console.log("last page read is already " + numPage);
        return;
      }

      this.readPages.push(numPage);

      if (this.readPages.length <= this.expirePages) {
        // console.log("numer of read page <= " + this.expirePages);
        return;
      } // console.log("must delete a page because I right now read")
      // ok, apply remove oldest readed page not so much near current readed page


      var found = null;

      for (var i = 0; i < this.readPages.length - 1; i++) {
        var pg = this.readPages[i];

        if (Math.abs(pg - numPage) > this.opts.minPageDistance) {
          found = i;
          break;
        }
      }

      if (found !== null) {
        var _pg = this.readPages[found];

        var pgid = this._numPageId(_pg); // console.warn("FOUND readed page to delete:", found, pg, pgid);


        this.readPages.splice(found, 1);

        this._cleanPage(pgid);
      }
    }
  }]);

  return DataBuffer;
}();

var DEFAULT_PAGE_SIZE$1 = 40;
var DEFS$1 = {
  NO_ELEMS: null
};
var SCROLLBAR_WIDTH$1 = null;

function _getScrollbarWidth$1() {
  if (SCROLLBAR_WIDTH$1) return SCROLLBAR_WIDTH$1;
  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.height = "100px";
  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth; // force scrollbars

  outer.style.overflow = "scroll"; // add innerdiv

  var inner = document.createElement("div");
  inner.style.height = "200px";
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth; // remove divs

  outer.parentNode.removeChild(outer);
  SCROLLBAR_WIDTH$1 = widthNoScroll - widthWithScroll;
  return SCROLLBAR_WIDTH$1;
}
/**
 * CoolGrid - handle loading, view and pageing of an array of object data.
 * 
 * @author G. Annunziata
*/


var CoolGrid = /*#__PURE__*/function (_Component) {
  _inherits(CoolGrid, _Component);

  var _super = _createSuper(CoolGrid);

  function CoolGrid(props) {
    var _this;

    _classCallCheck(this, CoolGrid);

    _this = _super.call(this, props);
    _this.state = _this.initialState(props);
    _this.onPageChangeHandler = _this.onPageChangeHandler.bind(_assertThisInitialized(_this));
    _this.onChangeSort = _this.onChangeSort.bind(_assertThisInitialized(_this));
    _this.onChangeSortObj = _this.onChangeSortObj.bind(_assertThisInitialized(_this));
    _this.buildSort = _this.buildSort.bind(_assertThisInitialized(_this));
    _this.rowClickHandler = _this.rowClickHandler.bind(_assertThisInitialized(_this));
    _this.rowDblClickHandler = _this.rowDblClickHandler.bind(_assertThisInitialized(_this)); // this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

    _this._headerRenderer = _this._headerRenderer.bind(_assertThisInitialized(_this));
    _this._rowRenderer = _this._rowRenderer.bind(_assertThisInitialized(_this));
    _this.afterInit = _this.afterInit.bind(_assertThisInitialized(_this)); // this.loadBuffer = this.loadBuffer.bind(this);

    _this.setupRef = _this.setupRef.bind(_assertThisInitialized(_this));
    _this._patchScrollBar = _this._patchScrollBar.bind(_assertThisInitialized(_this));
    _this._applyScrollWidth = _this._applyScrollWidth.bind(_assertThisInitialized(_this));
    var usePage = (_this.props.pageSize === null || _this.props.pageSize === undefined || _this.props.pageSize > 0) && !!!_this.props.noPaginator;
    var opts = {
      initialData: _this.props.loader ? null : _this.props.data || [],
      loader: _this.props.loader || null,
      count: _this.props.count || null,
      pageSize: _this.props.pageSize,
      usePage: usePage
    };
    _this.dataBuffer = new DataBuffer(_assertThisInitialized(_this), opts);
    return _this;
  }

  _createClass(CoolGrid, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (this.props.loader || newProps.data === this.props.data) return;
      var usePage = (newProps.pageSize === null || newProps.pageSize === undefined || newProps.pageSize > 0) && !!!newProps.noPaginator;
      var opts = {
        initialData: newProps.loader ? null : newProps.data || [],
        loader: newProps.loader || null,
        pageSize: newProps.pageSize,
        usePage: usePage
      };
      this.dataBuffer = new DataBuffer(this, opts);
      this.initGrid();
    }
  }, {
    key: "initialState",
    value: function initialState(props) {
      return {
        id: this.props.id || Utils.Utils.uuid("cg"),
        data: [],
        page: 1,
        pageSize: props.pageSize !== undefined && props.pageSize !== null ? props.pageSize : DEFAULT_PAGE_SIZE$1,
        noPaginator: !!props.noPaginator,
        count: 0,
        pageCount: 1,
        currentPage: null,
        init_update: null,
        sort: null,
        useSortable: props.useSortable === undefined ? true : props.useSortable,
        DEBUG: false
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var self = this; // copy from current (initial) state

      self.initGrid();

      self._patchScrollBar();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._patchScrollBar();
    }
  }, {
    key: "reload",
    value: function reload() {
      this.initGrid();
    }
  }, {
    key: "initGrid",
    value: function initGrid() {
      var self = this;
      console.log("[CoolGrid] initGrid");
      self.dataBuffer.reinit().then(function () {
        // setTimeout(function() {
        self.afterInit(); // }, 10);

        return null;
      });
    }
  }, {
    key: "afterInit",
    value: function afterInit() {
      console.warn("afterinit");
      var self = this;
      var state = Object.assign({}, self.state);
      var props = self.props; //state.data = this.props.data;

      state.count = self.dataBuffer.getCount();
      state.pageSize = props.pageSize !== undefined && props.pageSize !== null ? props.pageSize : DEFAULT_PAGE_SIZE$1;
      state.page = props.page;
      state.noPaginator = !!props.noPaginator;
      state.sort = self.buildSort(self.props.def);
      state.init_update = Math.random(); // console.warn("afterinit - update state", state, " now reload grid");

      if (self.internUpdatePageOnState(state, true)) {
        self.setState(state);
      }

      self.reloadGrid();
    }
  }, {
    key: "_patchScrollBar",
    value: function _patchScrollBar() {
      var self = this;
      setTimeout(function () {
        self._applyScrollWidth(self); // jquery("#" + self.state.id + "__grid").on('scroll', _.debounce(function () {
        //     self._applyScrollWidth(self);
        // }, 1));


        jquery__default['default']("#" + self.state.id + "__grid").on('scroll', function () {
          self._applyScrollWidth(self);
        });
      }, 3);
    }
  }, {
    key: "_applyScrollWidth",
    value: function _applyScrollWidth(self) {
      var sl = jquery__default['default']("#" + self.state.id + "__grid").scrollLeft();
      var w = jquery__default['default']("#" + self.state.id + "__grid").width();
      var newWidth = w + sl;
      jquery__default['default']("#" + self.state.id + "__grid .ReactVirtualized__Table__Grid").width(newWidth); //console.debug("COOLGRID #"+self.state.id+" _applyScrollWidth", newWidth, sl);
    }
  }, {
    key: "buildSort",
    value: function buildSort(def) {
      var res = {
        activeSort: null,
        availSort: []
      };
      if (!this.state.useSortable) return res;

      for (var i = 0; i < def.length; i++) {
        var d = def[i];
        if (!d.sortable) continue;
        var sortdef = {};
        sortdef.name = d.name;
        sortdef.field = d; // "comparator è una stringa parametro => lato server!!!

        sortdef.comparator = "" + (d.comparator || "builtin"); // UiUtils.builtinComparator;

        sortdef.asc = d.activeSort === 'asc' ? true : false;
        res.availSort.push(sortdef);

        if (d.activeSort) {
          res.activeSort = ___default['default'].clone(sortdef);
          res.activeSort.asc = d.activeSort === 'asc' ? true : false;
        }
      }

      return res;
    }
  }, {
    key: "reloadData",
    value: function reloadData() {
      this.dataBuffer.cleanData();
      this.dataBuffer.init();
    }
  }, {
    key: "reloadGrid",
    value: function reloadGrid() {
      this.updateCurrentPage();
      var table = this.table;
      if (table) table.forceUpdateGrid();
      var self = this;
      self.forceUpdate();
    }
  }, {
    key: "onChangeSortObj",
    value: function onChangeSortObj(sortObj) {}
  }, {
    key: "onChangeSortObj_old",
    value: function onChangeSortObj_old(sortObj) {
      if (!this.state.useSortable) return;
      console.debug("[CoolGrid] onChangeSortObj", sortObj);
      var sort = this.state.sort;

      if (sort && this.changeSort(sortObj.sortBy, sort)) {
        sort = this.state.sort; // re-read

        if (sort && sort.activeSort) {
          //console.log("[CoolGrid] DO sort by name on DataBuffer:", sort.activeSort);
          if (this.dataBuffer.changeSort(sort.activeSort.name, sort.activeSort.asc)) {
            this.reloadGrid();
          }
        }
      }

      return true;
    }
  }, {
    key: "onChangeSort",
    value: function onChangeSort(name) {
      if (!this.state.useSortable) return; //console.log("[CoolGrid] sort by name:", sortObj);

      var sort = this.state.sort;

      if (sort && this.changeSort(name, sort)) {
        sort = this.state.sort; // re-read

        if (sort && sort.activeSort) {
          //console.log("[CoolGrid] DO sort by name on DataBuffer:", sort.activeSort);
          if (this.dataBuffer.changeSort(sort.activeSort.name, sort.activeSort.asc)) {
            this.reloadGrid();
          }
        }
      }

      return true;
    }
  }, {
    key: "changeSort",
    value: function changeSort(name, sort) {
      if (!this.state.useSortable) return;

      if (name === null || name === undefined) {
        //console.log("[CoolGrid] changeSort abort - name null");
        return false;
      } //console.log("[CoolGrid] change sort:", sort, " - name:", name);


      var newSort = null;

      for (var i = 0; i < sort.availSort.length; i++) {
        var asrt = sort.availSort[i];

        if (asrt.name === name) {
          // found
          newSort = asrt;
          break;
        }
      }

      if (newSort === null) {
        //console.log("change sort - not found on avail sort");
        return false;
      }

      if (sort.activeSort !== null && sort.activeSort.name === newSort.name) {
        sort.activeSort.asc = !sort.activeSort.asc; //console.log("change direction", sort.activeSort);
      } else {
        sort.activeSort = ___default['default'].clone(newSort); //e Object.assign({ asc: true }, newSort);
        //console.log("change activeSort", sort.activeSort);
      }

      this.setState({
        sort: sort,
        sortBy: "" + sort.activeSort.name,
        sortDirection: sort.activeSort.asc ? reactVirtualized.SortDirection.ASC : reactVirtualized.SortDirection.DESC
      });
      return true;
    }
  }, {
    key: "rowClickHandler",
    value: function rowClickHandler(_ref2) {
      _ref2.event;
          var index = _ref2.index,
          rowData = _ref2.rowData;

      //console.log("row clicked");
      if (this.props.onRowClick) {
        this.props.onRowClick(rowData, index);
      }
    }
  }, {
    key: "rowDblClickHandler",
    value: function rowDblClickHandler(_ref3) {
      _ref3.event;
          var index = _ref3.index,
          rowData = _ref3.rowData;

      //console.log("row clicked");
      if (this.props.onRowDoubleClick) {
        this.props.onRowDoubleClick(rowData, index);
      }
    }
  }, {
    key: "_getCol",
    value: function _getCol(dataKey) {
      for (var i = 0; i < this.props.def.length; i++) {
        var col = this.props.def[i];
        if (col.name === dataKey) return col;
      }

      return null;
    }
  }, {
    key: "_getFirstCol",
    value: function _getFirstCol() {
      if (!this.props.def || this.props.def.length === 0) return 0;
      return this.props.def[0];
    }
  }, {
    key: "sortIcon",
    value: function sortIcon(col) {
      if (!this.state.useSortable) return null;
      if (!col || !col.sortable) return null;
      if (this.state === null) return "text-danger fa fa-exclamation-triangle";
      if (this.state.sort === null || this.state.sort.activeSort === null) return "fa fa-sort text-default";
      if (this.state.sort.activeSort.name !== col.name) return "fa fa-sort text-default"; // equals

      if (this.state.sort.activeSort.asc) return "fa fa-sort-active fa-sort-asc";else return "fa fa-sort-active fa-sort-desc";
    }
  }, {
    key: "_headerRenderer",
    value: function _headerRenderer(_ref4) {
      var dataKey = _ref4.dataKey;
      var DEBUG = this.state.DEBUG;
      var self = this;

      var col = this._getCol(dataKey);
      var sortIcon = this.sortIcon(col);

      if (self.state.sort && self.state.sort.activeSort) {
        "" + this.state.sortBy;
        this.state.sortDirection;
      } // console.log("coolgrid header renderer ", col);


      return /*#__PURE__*/React__default['default'].createElement("div", {
        style: {
          textOverflow: "ellipsis"
        },
        className: col.thClassName ? col.thClassName : col.className ? col.className : '',
        title: DEBUG ? col.label + ' - DEBUG col width:' + col.width + ' wchar:' + col.widthChars + "  realWidth:" + col.realWidth : col.label,
        onClick: function onClick() {
          return self.onChangeSort(col.name);
        }
      }, col.label, sortIcon && ' ', sortIcon &&
      /*#__PURE__*/
      // <SortIndicator sortDirection={sortDirection} />
      React__default['default'].createElement("i", {
        className: sortIcon
      }));
    }
  }, {
    key: "_onScrollToRowChange",
    value: function _onScrollToRowChange(event) {
      var count = this.state.count;
      var scrollToIndex = Math.min(count - 1, parseInt(event.target.value, 10));

      if (isNaN(scrollToIndex)) {
        scrollToIndex = undefined;
      }

      this.setState({
        scrollToIndex: scrollToIndex
      });
    }
  }, {
    key: "_rowRenderer2",
    value: function _rowRenderer2(_ref5) {
      var className = _ref5.className,
          columns = _ref5.columns,
          index = _ref5.index,
          key = _ref5.key,
          onRowClick = _ref5.onRowClick,
          onRowDoubleClick = _ref5.onRowDoubleClick,
          onRowMouseOut = _ref5.onRowMouseOut,
          onRowMouseOver = _ref5.onRowMouseOver,
          onRowRightClick = _ref5.onRowRightClick,
          rowData = _ref5.rowData,
          style = _ref5.style;
      var a11yProps = {};

      if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
        a11yProps['aria-label'] = 'row';
        a11yProps.tabIndex = 0;

        if (onRowClick) {
          a11yProps.onClick = function (event) {
            return onRowClick({
              event: event,
              index: index,
              rowData: rowData
            });
          };
        }

        if (onRowDoubleClick) {
          a11yProps.onDoubleClick = function (event) {
            return onRowDoubleClick({
              event: event,
              index: index,
              rowData: rowData
            });
          };
        }

        if (onRowMouseOut) {
          a11yProps.onMouseOut = function (event) {
            return onRowMouseOut({
              event: event,
              index: index,
              rowData: rowData
            });
          };
        }

        if (onRowMouseOver) {
          a11yProps.onMouseOver = function (event) {
            return onRowMouseOver({
              event: event,
              index: index,
              rowData: rowData
            });
          };
        }

        if (onRowRightClick) {
          a11yProps.onContextMenu = function (event) {
            return onRowRightClick({
              event: event,
              index: index,
              rowData: rowData
            });
          };
        }
      }

      return /*#__PURE__*/React__default['default'].createElement("div", _extends({}, a11yProps, {
        className: className,
        key: key,
        role: "row",
        style: style
      }), columns);
    }
  }, {
    key: "_rowRenderer",
    value: function _rowRenderer(options) {
      var self = this; // console.debug("COOLGRID internal row render");

      var opts = options; //_.cloneDeep(options);
      // detail, need some changes

      var className = opts.className,
          columns = opts.columns,
          index = opts.index,
          key = opts.key,
          onRowClick = opts.onRowClick,
          onRowDoubleClick = opts.onRowDoubleClick,
          onRowMouseOut = opts.onRowMouseOut,
          onRowMouseOver = opts.onRowMouseOver,
          onRowRightClick = opts.onRowRightClick,
          rowData = opts.rowData,
          style = opts.style;
      var rowCssClass = index % 2 === 0 ? "even" : "odd";
      if (className) rowCssClass += " " + className;
      var calcRowCssClass = self.props.rowCssClassCalculate ? self.props.rowCssClassCalculate(item, index) : null;
      if (calcRowCssClass) rowCssClass += " " + calcRowCssClass;

      var col = self._getFirstCol();

      var a11yProps = {};
      a11yProps['data-toggle'] = col.openDetails ? 'collapse' : null;
      a11yProps['data-target'] = col.openDetails ? '#' + self.state.id + '_detail_' + index : '';
      a11yProps["aria-label"] = "row";
      a11yProps.tabIndex = index + columns.length + 1;

      if (onRowClick) {
        a11yProps.onClick = function (event) {
          return onRowClick({
            event: event,
            index: index,
            rowData: rowData
          });
        };
      }

      if (onRowDoubleClick) {
        a11yProps.onDoubleClick = function (event) {
          return onRowDoubleClick({
            event: event,
            index: index,
            rowData: rowData
          });
        };
      }

      if (onRowMouseOut) {
        a11yProps.onMouseOut = function (event) {
          return onRowMouseOut({
            event: event,
            index: index,
            rowData: rowData
          });
        };
      }

      if (onRowMouseOver) {
        a11yProps.onMouseOver = function (event) {
          return onRowMouseOver({
            event: event,
            index: index,
            rowData: rowData
          });
        };
      }

      if (onRowRightClick) {
        a11yProps.onContextMenu = function (event) {
          return onRowRightClick({
            event: event,
            index: index,
            rowData: rowData
          });
        };
      }

      a11yProps.className = rowCssClass;
      a11yProps.key = key;
      a11yProps.role = "row";
      a11yProps.style = style;
      var detRender = this.renderDetail(this.props.detailsRenderer, rowData, index);

      if (!detRender) {
        return /*#__PURE__*/React__default['default'].createElement("div", a11yProps, columns);
      }

      var detailClassName = (className ? className : "") + " hiddentablerow";
      rowCssClass = (rowCssClass ? rowCssClass : "") + " accordion-toggle";
      return [/*#__PURE__*/React__default['default'].createElement("div", a11yProps, columns), /*#__PURE__*/React__default['default'].createElement("div", {
        className: detailClassName
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        id: self.state.id + '_detail_' + index,
        className: "accordian-body collapse"
      }, detRender))];
    }
  }, {
    key: "renderDetail",
    value: function renderDetail(detailsRenderer, item, index) {
      if (detailsRenderer) {
        return detailsRenderer(item, index);
      } else {
        return null;
      }
    }
  }, {
    key: "onPageChangeHandler",
    value: function onPageChangeHandler(event) {
      var page = event.page; //console.debug("[CoolGrid] pageHandler event:", event, page);

      var oldPage = this.state.page;

      if (page !== oldPage) {
        // console.log("[CoolGrid] page changed.... create new state with page", page);
        var state = Object.assign({}, this.state);
        state.page = page; // check and update page

        if (this.internUpdatePageOnState(state, true)) {
          this.setState(state);
        }
      }
    }
  }, {
    key: "updateCurrentPage",
    value: function updateCurrentPage() {
      var state = Object.assign({}, this.state);
      var usePage = state.pageSize > 0 && !state.noPaginator;
      state.usePage = usePage; //console.log("updateCurrentPage paged:" + usePage);

      if (usePage) {
        var start = (state.page - 1) * this.props.pageSize;
        var end = Math.min(state.page * this.props.pageSize, state.count);
        var cp = [];

        for (var i = start; i < end; i++) {
          var elem = this.dataBuffer.get(i);
          cp.push(elem);
        }

        state.currentPage = cp;
      } else {
        // page used inside dataBuffer?!
        state.currentPage = null; //state.data;
      }

      this.setState(state);
    } // private 

  }, {
    key: "internUpdatePageOnState",
    value: function internUpdatePageOnState(state, toRecreate) {
      var someChanges = false;
      state.page;

      if (isNaN(state.pageSize) || this.props.pageSize < 0) {
        this.props.pageSize = DEFAULT_PAGE_SIZE$1;
        someChanges = true;
      }
      /*
      if (state.data === undefined || state.data === null) {
          state.data = [];
          state.count = 0;
          someChanges = true;
      }
      */


      state.count = this.dataBuffer.getCount(); // state.data.length;

      var usePage = state.pageSize > 0 && !state.noPaginator;
      state.usePage = usePage;

      if (usePage) {
        state.pageCount = Math.ceil(state.count / state.pageSize);

        if (state.pageCount < 1) {
          state.pageCount = 1;
          someChanges = true;
        }
      } else {
        state.pageCount = 1;
      }

      if (toRecreate) {
        if (state.sort && state.sort.activeSort && this.dataBuffer.changeSort(state.sort.activeSort.name, state.sort.activeSort.asc)) {
          //state.data = newdata;
          someChanges = true;
        }
      }

      var pageToRecreate = toRecreate;

      if (isNaN(state.page) || state.page < 1) {
        state.page = 1;
        pageToRecreate = true;
      }

      if (state.page > state.pageCount) {
        state.page = state.pageCount;
        pageToRecreate = true;
      }

      if (pageToRecreate || state.currentPage === null) {
        if (usePage) {
          var start = (state.page - 1) * this.props.pageSize;
          var end = Math.min(state.page * this.props.pageSize, state.count);
          var cp = [];

          for (var i = start; i < end; i++) {
            var elem = this.dataBuffer.get(i);
            cp.push(elem);
          }

          state.currentPage = cp;
        } else {
          state.currentPage = []; //state.data;
        }

        someChanges = true;
      } //console.log("aDataGrid.internUpdatePageOnState: something changes?", someChanges);


      return someChanges;
    }
  }, {
    key: "getVal",
    value: function getVal(col, item) {
      return Utils.Utils.getVal(col, item);
    }
  }, {
    key: "setupRef",
    value: function setupRef(elem) {
      this.table = elem;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var self = this;
      var DEBUG = this.state.DEBUG;
      this.props.gridComponent || aTable$1;
      var AItem = this.props.itemComponent || null;
      var APaginator = aPaginator$1; // console.log("[CoolGrid] render", this.state, ATable, AItem);

      var noElems = this.props.noItemsLabel || DEFS$1.NO_ELEMS;
      var className = self.props.className || "";
      var noDataComp = /*#__PURE__*/React__default['default'].createElement("div", {
        className: "cool-grid"
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "no-data"
      }, this.props.children || (noElems ? noElems : Utils.i18n("V2.AGUI.COOLGRID.NO_ELEM.NO", "Nessun") + ' ' + this.props.itemName + ' ' + Utils.i18n("V2.AGUI.COOLGRID.NO_ELEM.AVAIL", "presente"))));
      var rowClick = null;
      var rowDblClick = null;

      if (this.props.onRowClick || this.props.onRowDoubleClick) {
        className = Utils.Utils.union(className, ' ', "clickable-row");
      }

      if (this.props.onRowClick) {
        rowClick = this.rowClickHandler;
      }

      if (this.props.onRowDoubleClick) {
        rowDblClick = this.rowDblClickHandler;
      }

      var noPaginator = this.state.noPaginator;
      var usePage = this.state.pageSize > 0 && !noPaginator;
      var initializing = this.props.loading === true || !this.dataBuffer.isInitialized();
      var count = !initializing ? this.state.count : 0;

      if (count === 0) {
        //console.warn("COUNT == 0");
        if (!initializing && !this.props.showColumns) {
          return noDataComp;
        }
      } // TODO calc height
      // "65vh" === 65% of viewport


      var isIE = Utils.UiUtils.detectIE() > 0;
      var calcHeight = jquery__default['default'](window).height() * 0.65;

      if (this.props.height) {
        calcHeight = this.props.height;
      }
      var colDef = [];
      var def = this.props.def;
      jquery__default['default'](window).width();
      var lastVisibleColIndex = -1;
      def.forEach(function (col, colIndex) {
        if (col.visible === false) return;
        lastVisibleColIndex = colIndex;
      });
      var tableWidth = 0;
      def.forEach(function (col, colIndex) {
        // convert from def to
        // react-virtualized > Table > Column parameters
        var render = null;
        if (col.visible === false) return null;
        var ww;
        var wspace = 8 + 8 + 10; // paddingleft + paddingright + margin-right

        var fontsize = 12;
        var style = {};

        if (lastVisibleColIndex === colIndex) {
          // TODO add to wspace lo spazio della scrollbar
          // OPPURE come padding-right
          style.paddingRight = _getScrollbarWidth$1() + 8;
        }

        if (col.width) {
          ww = col.width + wspace;
        } else if (col.widthChars) {
          ww = col.widthChars * fontsize + wspace;
        } else {
          ww = 100; // (scrwidth / def.length);
        }

        col.realWidth = ww;
        tableWidth += col.realWidth;
        var rend = col.renderer;

        if (rend) {
          render = function render(info) {
            // console.log("render cell (renderer)", info);
            if (info === null || info === undefined) return /*#__PURE__*/React__default['default'].createElement("span", null, "(no info)");
            info.cellData;
                info.columnData;
                var columnIndex = info.columnIndex,
                dataKey = info.dataKey,
                isScrolling = info.isScrolling;
                info.parent;
                var rowData = info.rowData,
                rowIndex = info.rowIndex;
            if (rowData === null || rowData === undefined) return /*#__PURE__*/React__default['default'].createElement("span", null, "(no rowData)");

            var col = self._getCol(dataKey);

            if (col === null) return /*#__PURE__*/React__default['default'].createElement("span", null, "(no col '", dataKey, "')");
            var val = self.getVal(col.fieldPath, rowData);

            if (col.formatter) {
              val = col.formatter(val, col, rowData);
            }

            var tabIndex = undefined;

            if (self.props.useTabIndex) {
              var zeroFill = isIE ? 3 : 6;
              tabIndex = "" + (columnIndex + 1) + Utils.UiUtils.zeroFill(rowIndex, zeroFill);
            }

            var viewVal = rend(val, col, rowData, rowIndex, tabIndex, isScrolling) || ""; // style={{ minWidth: "" + col.realWidth + "px" }}

            return viewVal || "";
          };
        } else {
          render = undefined;

          render = function render(info) {
            //console.log("render cell (direct)", info);
            info.cellData;
                info.columnData;
                info.columnIndex;
                var dataKey = info.dataKey;
                info.isScrolling;
                info.parent;
                var rowData = info.rowData;
                info.rowIndex;
            if (rowData === null || rowData === undefined) return /*#__PURE__*/React__default['default'].createElement("span", null, "(no rowData - direct)");

            if (dataKey === null || dataKey === undefined) {
              return /*#__PURE__*/React__default['default'].createElement("span", null, "(no dataKey)");
            }

            var col = self._getCol(dataKey);

            if (col === null) return /*#__PURE__*/React__default['default'].createElement("span", null, "(no col '", dataKey, "')");
            var val = self.getVal(col.fieldPath, rowData);

            if (col.formatter) {
              val = col.formatter(val, col, rowData);
            } //  style={{ minWidth: "" + col.realWidth + "px" }}


            return val || "";
          };
        }

        var dcol = {
          id: col.name + "_id",
          dataKey: col.name,
          width: col.realWidth,
          label: col.label,
          disableSort: !col.sortable,
          className: col.className || null,
          _index: colIndex,
          style: style,
          headerRenderer: self._headerRenderer,
          cellDataGetter: function cellDataGetter(_ref) {
            //console.log("cellDataGetter:", _ref);
            if (!_ref) return null;
            if (_ref.index !== null && _ref.index !== undefined) return _ref.index;
            if (_ref.rowData) return _ref.rowData.index;
            return _ref.dataKey || null;
          },
          cellRenderer: render //flexGrow: 1

        };
        colDef.push(dcol);
      }, this);

      if (!self.dataBuffer) {
        return /*#__PURE__*/React__default['default'].createElement("div", null, "CARICAMENTO - COME E' POSSIBILE!?!?");
      }

      var rowCount = !usePage ? self.dataBuffer.getCount() : this.state.currentPage ? this.state.currentPage.length : 0;
      if (!rowCount) rowCount = 0; // style={{ minHeight: calcHeight }}

      var tableProps = {
        id: self.state.id + "__grid",
        className: className,
        itemComponent: AItem,
        detailsRenderer: self.props.detailsRenderer,
        data: self.state.currentPage,
        // sort: self.state.sort,
        sortBy: self.state.sortBy,
        sortDirection: self.state.sortDirection,
        scrollToIndex: self.state.scrollToIndex,
        onRowClick: rowClick,
        onRowDoubleClick: rowDblClick,
        sort: self.onChangeSortObj,
        height: calcHeight,
        rowHeight: self.props.rowHeight ? self.props.rowHeight : 40,
        headerHeight: 40,
        rowCount: rowCount,
        rowGetter: usePage ? function (dt) {
          //console.warn("row getter PAGED:", self.state.currentPage, dt, idx);
          var idx = dt.index; // % self.state.pageSize;

          return self.state.currentPage[idx]; //return self.dataBuffer.get(dt.index);
        } : function (dt) {
          //console.warn("row getter DIRECT:", dt, dt.index);
          return self.dataBuffer.get(dt.index);
        },
        rowRenderer: self._rowRenderer,
        overscanRowCount: 2,
        overscanColumnCount: 1,
        width: tableWidth,
        viewWidth: 1400,
        // jquery(window).width() - 400, // test
        scrollingResetTimeInterval: 500
      };
      var tableNoRowsProps = {};

      if (!initializing && count === 0 && this.props.showColumns === true) {
        tableNoRowsProps = ___default['default'].clone(tableProps);
        tableNoRowsProps.data = [];
        tableNoRowsProps.rowCount = 0;
      } // //width={adjustedWidth - 20 /*TODO =scrollbarSize() vedi dom-helper */}


      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: Utils.Utils.union("cool-grid", " ", this.props.gridClassName)
      }, this.props.loadingBg === true && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "loading-bg"
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        className: "fa fa-spinner fa-pulse text-primary"
      })), initializing && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "loading-box"
      }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("i", {
        className: "fa fa-spinner fa-pulse"
      }), " ", Utils.i18n("V2.AGUI-coolgrid.LOADING", "Caricamento"), "...")), !initializing && count === 0 && this.props.showColumns === true && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "cool-table-container"
      }, /*#__PURE__*/React__default['default'].createElement(reactVirtualized.Table, _extends({}, tableNoRowsProps, {
        ref: self.setupRef
      }), colDef.map(function (col, index) {
        // console.debug("col:", col);
        return /*#__PURE__*/React__default['default'].createElement(reactVirtualized.Column, _extends({
          key: "col_" + index
        }, col));
      }))), count > 0 && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "cool-table-container"
      }, DEBUG && /*#__PURE__*/React__default['default'].createElement("div", null, "TEST --- paged: ", "" + usePage, " - count:", count, " - rowCount:", rowCount), /*#__PURE__*/React__default['default'].createElement(reactVirtualized.Table, _extends({}, tableProps, {
        ref: self.setupRef
      }), colDef.map(function (col, index) {
        // console.debug("col:", col);
        return /*#__PURE__*/React__default['default'].createElement(reactVirtualized.Column, _extends({
          key: "col_" + index
        }, col));
      }))), !initializing && count === 0 && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "no-data"
      }, noDataComp), !noPaginator && /*#__PURE__*/React__default['default'].createElement(APaginator, {
        id: this.state.id + "__pg",
        itemName: this.props.itemName,
        itemsName: this.props.itemsName,
        count: this.state.count,
        pageSize: this.state.pageSize,
        pageCount: this.state.pageCount,
        page: this.state.page,
        className: this.props.pageClassName,
        onPageChange: function onPageChange(e) {
          return _this2.onPageChangeHandler(e);
        }
      }), DEBUG && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("hr", null), "DEBUG:", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("pre", null, JSON.stringify(this.state, null, 2), '\n '), /*#__PURE__*/React__default['default'].createElement("pre", null, JSON.stringify(this.dataBuffer.getStatus(), null, 2), '\n '), /*#__PURE__*/React__default['default'].createElement("hr", null)));
    }
  }]);

  return CoolGrid;
}(React$1.Component);

_defineProperty(CoolGrid, "propTypes", {
  id: t__default['default'].string,
  gridComponent: t__default['default'].node,
  itemComponent: t__default['default'].node,
  itemName: t__default['default'].string,
  itemsName: t__default['default'].string,
  def: t__default['default'].arrayOf(t__default['default'].object),
  data: t__default['default'].arrayOf(t__default['default'].object),
  loader: t__default['default'].object,
  loading: t__default['default'].bool,
  // se true visualizza un overlay di loading dati
  loadingBg: t__default['default'].bool,
  // se true visualizza un loading dati in alto a destra
  noPaginator: t__default['default'].bool,
  count: t__default['default'].number,
  pageSize: t__default['default'].number,
  page: t__default['default'].number,
  onRowClick: t__default['default'].func,
  onRowDoubleClick: t__default['default'].func,
  pageClassName: t__default['default'].string,
  showColumns: t__default['default'].bool,
  useSortable: t__default['default'].bool
});

_defineProperty(CoolGrid, "defaultProps", {
  gridComponent: null,
  itemComponent: null,
  itemName: Utils.i18n("V2.AGUI.ADATAGRID.ELEMENT", "elemento"),
  itemsName: Utils.i18n("V2.AGUI.ADATAGRID.ELEMENTS", "elementi"),
  count: null,
  pageSize: DEFAULT_PAGE_SIZE$1,
  onRowClick: null,
  onRowDoubleClick: null,
  pageClassName: null,
  showColumns: false,
  noPaginator: false,
  loader: null,
  loading: false,
  loadingBg: false,
  useSortable: true
});

function aCardDetailsHeader(props) {
  if (props.visible !== undefined && !!!props.visible) return null;
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'card-header text-left title element-list' + (props.className ? props.className : '') + (props.loading ? " loading-card-header" : "")
  }, props.loading && /*#__PURE__*/React$1.createElement("div", {
    className: "loading-header"
  }, /*#__PURE__*/React$1.createElement("i", {
    className: "fa fa-spinner fa-pulse"
  })), props.children, /*#__PURE__*/React$1.createElement("div", {
    className: "cardHeaderButton pull-right",
    onClick: props.onClick
  }, /*#__PURE__*/React$1.createElement("i", {
    className: "fa fa-bars",
    "aria-hidden": "true"
  })));
}

function aCardHeader(props) {
  if (props.visible !== undefined && !!!props.visible) return null;
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'card-header text-left title ' + (props.className ? props.className : '') + (props.loading ? " loading-card-header" : "")
  }, props.loading && /*#__PURE__*/React$1.createElement("div", {
    className: "loading-header"
  }, /*#__PURE__*/React$1.createElement("i", {
    className: "fa fa-spinner fa-pulse"
  })), props.children);
}

function aCardFilter(props) {
  if (props.visible !== undefined && !!!props.visible) return null;
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'card-filter ' + (props.className ? props.className : '') + (props.loading ? " loading-card-filter" : "")
  }, props.loading && /*#__PURE__*/React$1.createElement("div", {
    className: "loading-filter"
  }, /*#__PURE__*/React$1.createElement("i", {
    className: "fa fa-spinner fa-pulse"
  })), props.title && /*#__PURE__*/React$1.createElement("h3", {
    className: "card-filter-title"
  }, props.title), props.children);
}

function aCardBody(props) {
  if (props.visible !== undefined && !!!props.visible) return null;
  return /*#__PURE__*/React$1.createElement("div", {
    title: props.title,
    className: 'card-block ' + (props.className ? props.className : ''),
    style: props.style
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "loading-card",
    style: {
      display: props.loading ? 'block' : 'none'
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "spinner-balls"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "bounce1"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "bounce2"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "bounce3"
  }))), props.children, " ");
}

function aCardFooter(props) {
  if (props.visible !== undefined && !!!props.visible) return null;
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'card-footer ' + (props.className ? props.className : '') + (props.loading ? " loading-card-footer" : "")
  }, props.loading && /*#__PURE__*/React$1.createElement("div", {
    className: "loading-footer"
  }, /*#__PURE__*/React$1.createElement("i", {
    className: "fa fa-spinner fa-pulse"
  })), props.children);
}

var aCard = function aCard(props) {
  // constructor(props) {
  //     super(props);
  //     state = {
  //     }
  // }
  //console.log("aCard render");
  if (props.visible !== undefined && !!!props.visible) return null;
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'card ' + (props.className ? props.className : '')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "loading-card",
    style: {
      display: props.loading ? 'block' : 'none'
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "spinner-balls"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "bounce1"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "bounce2"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "bounce3"
  }))), props.children);
};

var AccordionHeader = function AccordionHeader(props) {
  var open = props.open,
      handleClick = props.handleClick,
      openIcon = props.openIcon,
      closeIcon = props.closeIcon,
      className = props.className,
      children = props.children;
  var openClassName = "arm-gui-accordion-header ";

  if (className) {
    openClassName = openClassName + className;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: openClassName,
    onClick: handleClick
  }, children, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "arm-gui-accordion-button"
  }, open ? /*#__PURE__*/React__default['default'].createElement("i", {
    className: closeIcon ? closeIcon : "arm-gui-accordion-button-close "
  }) : /*#__PURE__*/React__default['default'].createElement("i", {
    className: openIcon ? openIcon : "arm-gui-accordion-button-open "
  })));
};

AccordionHeader.propTypes = {
  openIcon: t.string,
  closeIcon: t.string,
  className: t.string,
  children: t.node
};
/**
 * Attention Accordion has to have Header!!!
 */

var Accordion = function Accordion(props) {
  var marginBottom = props.marginBottom,
      className = props.className,
      disabled = props.disabled,
      loading = props.loading,
      children = props.children;
  var accordionStyle = {};

  if (marginBottom) {
    accordionStyle["marginBottom"] = marginBottom;
  }

  var _useState = React$1.useState({
    open: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleClick = function handleClick() {
    if (disabled) {
      return;
    }

    if (state.open) {
      setState({
        open: false
      });
    } else {
      setState({
        open: true
      });
    }
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: 'arm-gui-accordion ' + (className ? className : '') + ' ' + (disabled ? "disabled" : ''),
    style: accordionStyle
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "loading-card",
    style: {
      display: loading ? 'block' : 'none'
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "spinner-balls"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "bounce1"
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "bounce2"
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "bounce3"
  }))), React__default['default'].Children.map(children, function (child, index) {
    if (child && child.type && child.type.toString() === AccordionHeader.toString()) {
      return /*#__PURE__*/React__default['default'].cloneElement(child, {
        open: state.open,
        handleClick: handleClick
      });
    } else if (state.open) {
      return child;
    } else {
      return null;
    }
  }));
};

var hasHeader = function hasHeader(propValue, key, componentName, location, propFullName) {
  if (!propValue || !Array.isArray(propValue)) {
    return new Error("To ".concat(componentName, " should be passed an array of Elements"));
  }

  var header = false;
  propValue.forEach(function (child) {
    if (child && child.type && child.type.toString() === AccordionHeader.toString()) {
      header = true;
    }
  });

  if (!header) {
    return new Error("".concat(componentName, " should have an Element ").concat(AccordionHeader.name, " to work"));
  }
};

Accordion.propTypes = {
  marginBottom: t.string,
  className: t.string,
  disabled: t.bool,
  loading: t.bool,
  children: t.arrayOf(hasHeader)
};

var AccordionBody = function AccordionBody(props) {
  var className = props.className,
      children = props.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "arm-gui-accordion-body " + (className ? className : "")
  }, children);
};

AccordionBody.propTypes = {
  className: t.string,
  children: t.node
};

var AccordionFooter = function AccordionFooter(props) {
  var className = props.className,
      children = props.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "arm-gui-accordion-footer " + (className ? className : "")
  }, children);
};

AccordionFooter.propTypes = {
  className: t.string,
  children: t.node
};
Accordion.Header = AccordionHeader;
Accordion.Body = AccordionBody;
Accordion.Footer = AccordionFooter;

function aCollapseItem(props) {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "card-header",
    id: props.title + '-' + props.id
  }, /*#__PURE__*/React$1.createElement("h3", null, /*#__PURE__*/React$1.createElement("a", {
    "data-toggle": "collapse",
    "data-target": "#" + props.id,
    "aria-expanded": props.active === true ? props.active : false,
    "aria-controls": props.id
  }, props.title, " ", /*#__PURE__*/React$1.createElement("span", {
    className: "pull-right"
  }, /*#__PURE__*/React$1.createElement("i", {
    className: "fa fa-chevron-down"
  }))))), /*#__PURE__*/React$1.createElement("div", {
    id: props.id,
    className: props.active === true ? "collapse show" : "collapse",
    "aria-labelledby": props.title + '-' + props.id,
    "data-parent": "#accordion"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "card-block"
  }, props.children)));
}

var aCollapse = function aCollapse(props) {
  // constructor(props) {
  //     super(props);
  //     state = {
  //     }
  // }
  //console.log("aCollapse render");
  return /*#__PURE__*/React$1.createElement("div", {
    id: "accordion"
  }, props.children);
};

function showFunc(props, nextProps) {
  if (props.show !== nextProps.show) return true;
  return props.show || false;
}

var PopupModal = function PopupModal(props) {
  // constructor(props) { 
  //     super(props);
  //     this.state = {
  //     }
  // }
  // shouldComponentUpdate(nextProps) {
  //     if (this.props.show !== nextProps.show)
  //         return true;
  //     return (this.props.show || false);
  // }
  // useEffect(function() {
  //     return true;
  //   }, [show]);
  if (!props.show) return null;
  console.log("PopupModal render " + props.show);
  return /*#__PURE__*/React$1.createElement("div", {
    className: "popup-dialog-container " + (props.className ? props.className : "")
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "popup-modal view",
    style: props.style
  }, props.children));
};

var PopupModal$1 = /*#__PURE__*/React$1.memo(PopupModal, showFunc);

function PopupHeader(props) {
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'popup-form-modal-header text-left title ' + (props.className ? props.className : '') + (props.loading ? " loading-popup-form-modal-header" : "")
  }, props.loading && /*#__PURE__*/React$1.createElement("div", {
    className: "loading-header"
  }, /*#__PURE__*/React$1.createElement("i", {
    className: "fa fa-spinner fa-pulse"
  })), props.children);
}

function PopupBody(props) {
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'popup-form-modal-body ' + (props.className ? props.className : ''),
    style: props.style
  }, props.children);
}

function PopupFooter(props) {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "popup-form-modal-footer element-list " + (props.className ? props.className : '')
  }, props.children);
}

var PopupFormModal = function PopupFormModal() {
  console.log("PopModule render new react");

  var props = ___default['default'].omit(props, "className", "title", "onClose", "popupFormStyle");

  props.className;
      var title = props.title,
      onClose = props.onClose;
  return /*#__PURE__*/React$1.createElement(PopupModal$1, props, /*#__PURE__*/React$1.createElement("div", {
    className: 'popup-form-modal ' + (props.className ? props.className : ''),
    style: props.popupFormStyle || {}
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "loading-popup-form-modal",
    style: {
      display: props.loading ? 'block' : 'none'
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "spinner-balls"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "bounce1"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "bounce2"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "bounce3"
  }))), title && /*#__PURE__*/React$1.createElement(PopupHeader, null, /*#__PURE__*/React$1.createElement("h3", null, title)), onClose && /*#__PURE__*/React$1.createElement("a", {
    className: "popup-close-btn btn btn-secondary btn-close",
    onClick: onClose,
    href: "javascript:;"
  }, "\xD7"), props.children));
};

var aPageTitleBar = function aPageTitleBar(props) {
  // constructor(props) {
  //     super(props);
  //     state = {
  //     }
  // }
  return /*#__PURE__*/React$1.createElement("div", {
    className: "profile-header"
  }, props.listCrumbs !== null && props.listCrumbs !== undefined ? /*#__PURE__*/React$1.createElement(aBreadCrumbs, {
    separator: props.separator,
    listCrumbs: props.listCrumbs
  }) : /*#__PURE__*/React$1.createElement("div", {
    className: "row mt-5"
  }, " "), /*#__PURE__*/React$1.createElement("div", {
    className: "col title"
  }, props.children));
};

var CoolInputContainer = function CoolInputContainer(props) {
  var labRef = {}; // constructor(props) {
  //     super(props);
  //     labRef = {};
  //     clearValue = clearValue.bind(this);
  // }
  // componentWillMount() {
  // }

  var refLabel = function refLabel() {
    return Utils.Utils.uuid("ci_lab");
  };

  var clickAddon = function clickAddon(e, ciLab, type) {
    console.log("click on addon/label " + ciLab); //$("#"+ciLab).click();

    if (props.onAddonClick) {
      props.onAddonClick(e);
      return;
    }

    if (type === "prefix") {
      if (props.onPrefixClick) {
        props.onPrefixClick(e);
        return;
      }
    }

    if (type === "suffix") {
      if (props.onSuffixClick) {
        props.onSuffixClick(e);
        return;
      }
    }

    var lar = labRef[ciLab]; ///

    if (lar) {
      //let els = $(labRef.el);
      //els.find("select,textarea,input").click();
      console.log("DO click on input");
      jquery__default['default'](lar).find("select,textarea,input").click();
    } ///

  };

  var clearValue = function clearValue() {
    console.log("clear value call");
    if (props.onClearValue) props.onClearValue();
  };

  var className = props.className;
      props.active; // FUTURE: gestire onBLUR / onFOCUS

  var reqMark = "";
  var requiredClass = props.required ? " required" : "";

  if (props.required) {
    reqMark = /*#__PURE__*/React__default['default'].createElement("span", {
      className: "text-danger",
      title: "campo richiesto",
      "aria-label": "campo richiesto"
    }, " *");
  }

  var ciLab = refLabel();
  var block = props.block || false;
  var children = props.children;
  var preicon = "";
  var posticon = "";
  var hasAddon = className + (block ? ' block' : '') + " ";

  if (props.disabled) {
    hasAddon += " is-disabled";
  }

  if (props.readOnly) {
    hasAddon += " is-readonly";
  }

  var help = props.help || null;
  var error = props.hasError || null;
  var warning = props.hasWarning;

  if (error || warning) {
    hasAddon += " has-error";

    if (!error && warning) {
      error = warning;
      hasAddon += " has-warning";
    }

    help = null;
  }

  if (help) {
    hasAddon += " has-help";
  }

  var clearBtn = null;

  if (Utils.UiUtils.detectIE() === 0 && props.noClearBtn === false && !props.readOnly) {
    hasAddon += " has-clearbtn ";

    if (props.hasValue && !props.disabled) {
      clearBtn = /*#__PURE__*/React__default['default'].createElement("a", {
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          clearValue();
        },
        className: "clearBtn"
      }, "x");
    }
  }

  if (props.preIcon || props.postIcon || props.prefix || props.suffix) {
    var cicon = "addon";

    if (props.useBlock) {
      cicon = "";
    }

    if (props.preIcon || props.prefix) {
      hasAddon += " has-addon-left";
      var withPrefix = props.prefix ? " withPrefix" : "";
      preicon = /*#__PURE__*/React__default['default'].createElement("span", {
        className: cicon + " pre-addon" + withPrefix,
        title: props.prefixTitle,
        onClick: function onClick(e) {
          return clickAddon(e, ciLab, "prefix");
        }
      }, props.preIcon && /*#__PURE__*/React__default['default'].createElement("i", {
        className: props.preIcon,
        "aria-hidden": "true"
      }), props.prefix && /*#__PURE__*/React__default['default'].createElement("span", {
        className: "prefix"
      }, props.prefix));
    }

    if (props.postIcon || props.suffix) {
      if (props.preIcon || props.prefix) hasAddon += "has-addon-both";else hasAddon += " has-addon-right";
      var withSuffix = props.suffix ? " withSuffix" : "";
      posticon = /*#__PURE__*/React__default['default'].createElement("span", {
        className: cicon + " post-addon" + withSuffix,
        title: props.suffixTitle,
        onClick: function onClick(e) {
          return clickAddon(e, ciLab, "suffix");
        }
      }, props.postIcon && /*#__PURE__*/React__default['default'].createElement("i", {
        className: props.postIcon,
        "aria-hidden": "true"
      }), props.suffix && /*#__PURE__*/React__default['default'].createElement("span", {
        className: "suffix"
      }, props.suffix));
    }
  }

  var lab = null;

  if (props.label) {
    if (props.useBlock) {
      var pri = preicon,
          poi = posticon;
      preicon = null;
      posticon = null;
      lab = /*#__PURE__*/React__default['default'].createElement("span", {
        className: "lab addon" + requiredClass
      }, pri, props.label, " ", reqMark, poi);
    } else {
      lab = /*#__PURE__*/React__default['default'].createElement("span", {
        className: "lab" + requiredClass,
        onClick: function onClick(e) {
          return clickAddon(e, ciLab);
        }
      }, props.label, " ", reqMark);
    }
  }

  if (className === "none") {
    return children;
  }

  if (props.minimal) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "cool-input cool-input-container-minimal"
    }, error && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "error-sign"
    }, ' '), help && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "help-mesg"
    }, help), error && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "error-mesg"
    }, error), children);
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "cool-input" + (props.compact ? " cool-input-container-compact " : " cool-input-container ") + hasAddon
  }, error && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "error-sign"
  }, ' '), help && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "help-mesg"
  }, help), error && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "error-mesg"
  }, error), preicon, /*#__PURE__*/React__default['default'].createElement("label", {
    id: ciLab,
    ref: function ref(label) {
      return labRef[ciLab] = label;
    }
  }, clearBtn, children, lab), posticon);
};

var CoolContainer = function CoolContainer(props) {
  console.log('[CoolContainer.jsx]: render');
  var inputId = props.inputId,
      className = props.className,
      label = props.label,
      preIcon = props.preIcon,
      postIcon = props.postIcon,
      suffix = props.suffix,
      prefix = props.prefix,
      hasWarning = props.hasWarning,
      hasError = props.hasError,
      help = props.help,
      validation = props.validation,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      minimal = props.minimal;
      props.compact;
      props.noClearBtn;
      props.onClearValue;
      var children = props.children;
  var containerHasError = hasError;

  if (validation) {
    containerHasError = validation.get ? validation.get(inputId) : validation[inputId];
  }

  var showWarning = !containerHasError && hasWarning;
  var showFocus = !containerHasError && !hasWarning && !readOnly;
  var clsReadOnly = readOnly ? 'readonly' : '';
  var clsErr = containerHasError ? 'error' : '';
  var clsWrn = showWarning ? 'warn' : '';
  var clsDisabled = disabled ? 'disabled' : '';

  var _useState = React$1.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      clsFocus = _useState2[0],
      setClsFocus = _useState2[1];

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "arm-gui-cool-container ".concat(className)
  }, !minimal && /*#__PURE__*/React__default['default'].createElement("label", {
    className: "arm-gui-cool-container-label"
  }, label, " ", required && /*#__PURE__*/React__default['default'].createElement("i", {
    className: "arm-gui-cool-container-required"
  }, "*")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "arm-gui-cool-container-input ".concat(clsWrn, " ").concat(clsErr, " ").concat(clsFocus, " ").concat(clsDisabled, " ").concat(clsReadOnly),
    onFocus: function onFocus() {
      return showFocus ? setClsFocus('focused') : null;
    },
    onBlur: function onBlur() {
      return showFocus ? setClsFocus('') : null;
    }
  }, preIcon && /*#__PURE__*/React__default['default'].createElement("i", {
    className: "arm-gui-cool-container-preicon ".concat(preIcon)
  }), prefix && /*#__PURE__*/React__default['default'].createElement("label", {
    className: "arm-gui-cool-container-prefix"
  }, prefix), children, postIcon && /*#__PURE__*/React__default['default'].createElement("i", {
    className: "arm-gui-cool-container-posticon ".concat(postIcon)
  }), suffix && /*#__PURE__*/React__default['default'].createElement("label", {
    className: "arm-gui-cool-container-suffix"
  }, suffix)), help && /*#__PURE__*/React__default['default'].createElement("span", {
    className: "arm-gui-cool-container-help"
  }, help, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "arm-gui-cool-container-help-ico fas fa-info-circle"
  })), showWarning && /*#__PURE__*/React__default['default'].createElement("span", {
    className: "arm-gui-cool-container-warn"
  }, hasWarning, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "arm-gui-cool-container-warn-ico fas fa-exclamation-triangle"
  })), containerHasError && /*#__PURE__*/React__default['default'].createElement("span", {
    className: "arm-gui-cool-container-error"
  }, containerHasError, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "arm-gui-cool-container-error-ico fas fa-exclamation-triangle"
  })));
};

CoolContainer.propTypes = {
  help: t.string,
  visible: t.bool,
  hasWarning: t.string,
  hasError: t.string,
  validation: t.shape({
    id: t.string
  }),
  preIcon: t.string,
  postIcon: t.string,
  suffix: t.string,
  prefix: t.string,
  label: t.string,
  className: t.string,
  block: t.bool,
  compact: t.bool,
  minimal: t.bool,
  noClearBtn: t.bool,
  required: t.bool
};

var CoolNumberInput = function CoolNumberInput(props) {

  var _useState = React$1.useState({
    focus: ""
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0];
      _useState2[1]; // constructor(props) {

  var onInputChange = function onInputChange(num, val) {
    // eventually change state
    // qui no perchè lo fa già il componente NumberInput
    // per ci-focus, ci-has-content
    if (props.onChange) props.onChange(num, val);
  };

  var clearValue = function clearValue() {
    if (props.onChange) props.onChange(null, "");
  }; // shouldComponentUpdate(nextProps, nextState) {
  //     if (props.value !== nextProps.value) {
  //         return true;
  //     }
  //     if (props.disabled !== nextProps.disabled) {
  //         return true;
  //     }
  //     if (props.readOnly !== nextProps.readOnly) {
  //         return true;
  //     }
  //     return false;
  // }


  var value = props.value,
      className = props.className,
      onBlur = props.onBlur,
      onFocus = props.onFocus; // FUTURE: gestire onBLUR / onFOCUS
  // input container

  props.help;
      var preIcon = props.preIcon,
      postIcon = props.postIcon,
      suffix = props.suffix,
      prefix = props.prefix,
      label = props.label,
      wrapClassName = props.wrapClassName; // FUTURE: gestire onBLUR / onFOCUS

  if (wrapClassName === null || wrapClassName === undefined) wrapClassName = "";
  if (wrapClassName !== "none") wrapClassName += " cool-number-input";
  if (className === null || className === undefined) className = "";

  if (state.focus) {
    className += " ci-focus";
  }

  var hasValue = false;

  if (!Utils.Utils.isNil(value) || props.readOnly) {
    className += " ci-has-content";
    hasValue = true;
  }

  var hasError = null;

  if (props.validation) {
    hasError = props.validation.get ? props.validation.get(props.id) : props.validation[props.id];
  } else if (props.hasError) {
    hasError = props.hasError;
  }

  if (hasError) {
    className += " has-error";
  }

  var inputProps = {
    id: props.id,
    className: className,
    placeholder: props.placeholder,
    onBlur: onBlur,
    // onClickOutside: onBlur,
    onFocus: onFocus,
    value: value,
    zeroValue: "",
    onChange: function onChange(num, val) {
      return onInputChange(num, val);
    },
    disabled: props.disabled,
    readOnly: props.readOnly,
    formatter: props.formatter,
    autoComplete: props.autoComplete
  };
  var containerProps = {
    preIcon: preIcon,
    postIcon: postIcon,
    suffix: suffix,
    prefix: prefix,
    label: label,
    required: props.required,
    className: wrapClassName,
    minimal: props.minimal,
    hasValue: hasValue,
    noClearBtn: props.noClearBtn,
    onClearValue: function onClearValue() {
      return clearValue();
    },
    block: props.block,
    disabled: props.disabled,
    readOnly: props.readOnly,
    hasError: hasError,
    hasWarning: props.hasWarning,
    help: props.help,
    compact: props.compact ? props.compact : false
  };
  var Container = props.container || CoolContainer;
  return /*#__PURE__*/React__default['default'].createElement(Container, containerProps, /*#__PURE__*/React__default['default'].createElement(NumberInput, inputProps));
};

var CoolTextInput = function CoolTextInput(props) {
  var type = props.type,
      id = props.id,
      className = props.className,
      placeholder = props.placeholder,
      onKeyUp = props.onKeyUp,
      value = props.value,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      disabled = props.disabled,
      readOnly = props.readOnly,
      autoComplete = props.autoComplete,
      container = props.container,
      help = props.help,
      visible = props.visible,
      hasWarning = props.hasWarning,
      hasError = props.hasError,
      validation = props.validation,
      preIcon = props.preIcon,
      postIcon = props.postIcon,
      suffix = props.suffix,
      prefix = props.prefix,
      label = props.label,
      wrapClassName = props.wrapClassName,
      block = props.block,
      compact = props.compact,
      minimal = props.minimal,
      noClearBtn = props.noClearBtn,
      required = props.required;

  var onInputChange = function onInputChange(value, id) {
    if (onChange) onChange(value, id);
  };

  var clearValue = function clearValue() {
    if (onChange) onChange(null, "");
  };

  if (visible !== undefined && visible !== null && visible === false) {
    return null;
  }

  var containerClassName = wrapClassName;

  if (wrapClassName === null || wrapClassName === undefined) {
    containerClassName = "";
  }

  if (wrapClassName !== "none") {
    containerClassName += " cool-text-input";
  }

  var hasValue = !Utils.Utils.isNil(value);
  var inputProps = {
    type: type ? type : "text",
    id: id,
    className: className ? className : "",
    placeholder: placeholder,
    onKeyUp: onKeyUp,
    value: value ? value : "",
    defaultValue: defaultValue,
    onChange: function onChange(e) {
      return onInputChange(e.target.value, e.target.id);
    },
    disabled: disabled,
    readOnly: readOnly,
    autoComplete: autoComplete
  };
  var containerProps = {
    inputId: id,
    preIcon: preIcon,
    postIcon: postIcon,
    suffix: suffix,
    prefix: prefix,
    label: label,
    required: required,
    minimal: minimal,
    className: containerClassName,
    validation: validation,
    block: block,
    disabled: disabled,
    noClearBtn: noClearBtn,
    onClearValue: function onClearValue() {
      return clearValue();
    },
    hasValue: hasValue,
    readOnly: readOnly,
    help: help,
    hasError: hasError,
    hasWarning: hasWarning,
    compact: compact ? compact : false
  };

  if (id) {
    console.debug("[CoolTextInput] render " + id + " with label: " + label);
  } else {
    console.debug("[CoolTextInput] render without id and  label: " + label);
  }

  var Container = container || CoolContainer;
  return /*#__PURE__*/React__default['default'].createElement(Container, containerProps, /*#__PURE__*/React__default['default'].createElement("input", inputProps));
};

CoolTextInput.propTypes = {
  id: t.string,
  className: t.string,
  placeholder: t.string,
  onKeyUp: t.func,
  value: t.string,
  defaultValue: t.string,
  onChange: t.func,
  disabled: t.bool,
  readOnly: t.bool,
  autoComplete: t.string,
  container: t.oneOf([CoolContainer.name, CoolInputContainer.name]),
  inputId: t.string,
  help: t.string,
  visible: t.bool,
  hasWarning: t.string,
  hasError: t.string,
  validation: t.shape({
    id: t.string
  }),
  preIcon: t.string,
  postIcon: t.string,
  suffix: t.string,
  prefix: t.string,
  label: t.string,
  wrapClassName: t.string,
  block: t.bool,
  compact: t.bool,
  minimal: t.bool,
  noClearBtn: t.bool,
  required: t.bool
};

var CoolTextArea = function CoolTextArea(props) {
  var _useState = React$1.useState({
    focus: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1]; // constructor(props) {
  //     super(props);
  //     state = {
  //         focus: false
  //     }
  //     handleOnFocus = handleOnFocus.bind(this);
  //     handleOnBlur = handleOnBlur.bind(this);
  // }
  // componentWillMount() {
  // }


  var onInputChange = function onInputChange(num, val, id) {
    // eventually change state
    // qui no perchè lo fa già il componente NumberInput
    // per ci-focus, ci-has-content
    if (props.onChange) props.onChange(num, val, id);
  };

  var handleOnBlur = function handleOnBlur(e) {
    setState({
      focus: false
    }, function () {
      if (props.onBlur) props.onBlur();
    });
  };

  var handleOnFocus = function handleOnFocus(e) {
    setState({
      focus: true
    }, function () {
      if (props.onFocus) props.onFocus();
    });
  };

  if (props.visible !== undefined && props.visible !== null && props.visible === false) {
    return null;
  }

  var value = props.value,
      defaultValue = props.defaultValue,
      className = props.className;
      props.onBlur;
      props.onFocus; // FUTURE: gestire onBLUR / onFOCUS
  // input container

  props.help;
      var preIcon = props.preIcon,
      postIcon = props.postIcon,
      suffix = props.suffix,
      prefix = props.prefix,
      label = props.label,
      wrapClassName = props.wrapClassName; // FUTURE: gestire onBLUR / onFOCUS

  if (wrapClassName === null || wrapClassName === undefined) wrapClassName = "";
  if (wrapClassName !== "none") wrapClassName += " cool-text-input";
  if (className === null || className === undefined) className = "";

  if (state.focus) {
    className += " ci-focus";
  }

  var hasError = null;

  if (props.validation) {
    hasError = props.validation.get(props.id);
  } else if (props.hasError) {
    hasError = props.hasError;
  }

  if (hasError) {
    className += " has-error";
  }

  if (!Utils.Utils.isNil(value) || props.readOnly) {
    className += " ci-hasContent";
  }

  var inputProps = {
    type: "text",
    id: props.id,
    className: className,
    onBlur: handleOnBlur,
    onFocus: handleOnFocus,
    // onClickOutside: onBlur,
    onKeyUp: props.onKeyUp,
    value: value ? value : '',
    defaultValue: defaultValue,
    onChange: function onChange(e) {
      return onInputChange(e.target.value, e.target.id);
    },
    disabled: props.disabled,
    readOnly: props.readOnly,
    rows: props.rows
  };
  var containerProps = {
    preIcon: preIcon,
    postIcon: postIcon,
    suffix: suffix,
    prefix: prefix,
    label: label,
    minimal: props.minimal,
    required: props.required,
    className: wrapClassName,
    block: props.block,
    disabled: props.disabled,
    readOnly: props.readOnly,
    hasError: hasError,
    hasWarning: props.hasWarning,
    help: props.help,
    compact: props.compact ? props.compact : false
  };
  return /*#__PURE__*/React__default['default'].createElement(CoolInputContainer, _extends({}, containerProps, {
    className: "textArea"
  }), /*#__PURE__*/React__default['default'].createElement("textarea", inputProps));
};

var CoolDateInput = function CoolDateInput(props) {
  var _useState = React$1.useState({
    focus: false,
    empty: Utils.Utils.isNil(props.value)
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0];
      _useState2[1];

  var onInputChange = function onInputChange(date, ts) {
    console.debug("[CoolDateInput.jsx]: onInputChange", {
      date: date,
      ts: ts
    });
    if (props.onChange) props.onChange(date, ts);
  };

  var onFocus = function onFocus(e) {
    console.debug("[CoolDateInput.jsx]: onFocus");
    if (props.onFocus) props.onFocus(e);
  };

  var onBlur = function onBlur(e) {
    console.debug("[CoolDateInput.jsx]: onBlur");
    if (props.onBlur) props.onBlur(e);
  };

  var clearValue = function clearValue() {
    if (props.onChange) props.onChange(null);
  };

  var value = props.value,
      className = props.className; // FUTURE: gestire onBLUR / onFOCUS

  value = Utils.DateFormatter.toDateNew(value);
  if (className === null || className === undefined) className = ""; // baco - con re-render del datetime non
  // viene visualizzato il calendar => 
  // la label verrà, in questo caso sempre piccola

  className += " arm-gui-cool-date-input ";

  if (!props.writeDate) {
    className += " arm-gui-cool-date-input-popup ci-focus ";
  } else {
    className += " ci-focus ";
  }

  if (state.focus) ;

  if (props.readOnly) {
    className += " date-readonly";
  }

  var hasValue = false;

  if (!Utils.Utils.isNil(value) || props.readOnly) {
    hasValue = true;
  } // input container


  props.help;
      var preIcon = props.preIcon,
      postIcon = props.postIcon,
      label = props.label,
      wrapClassName = props.wrapClassName; // FUTURE: gestire onBLUR / onFOCUS

  if (wrapClassName === null || wrapClassName === undefined) wrapClassName = "wrap-small";

  var hasError = null;

  if (props.validation) {
    // hasError = props.validation.get(props.id);
    hasError = props.validation.get ? props.validation.get(props.id) : props.validation[props.id];
  } else if (props.hasError) {
    hasError = props.hasError;
  }

  if (hasError) {
    className += " has-error";
  }

  var containerProps = {
    preIcon: !props.readOnly ? preIcon || "fa fa-calendar" : null,
    postIcon: postIcon,
    label: label,
    //  + " - open:" + open,
    required: props.required,
    minimal: props.minimal,
    className: wrapClassName,
    onClearValue: function onClearValue() {
      return clearValue();
    },
    hasValue: hasValue,
    block: props.block,
    noClearBtn: props.noClearBtn,
    disabled: props.disabled,
    readOnly: props.readOnly,
    hasError: hasError,
    hasWarning: props.hasWarning,
    help: props.help,
    compact: props.compact ? props.compact : false
  };
  var inputProps = {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus,
    onInputChange: onInputChange,
    value: value,
    disabled: props.disabled,
    readOnly: props.readOnly,
    locale: props.locale,
    inputClassName: "input-date-element",
    viewMode: props.viewMode,
    dateFormat: props.dateFormat,
    isValidDate: props.isValidDate,
    writeDate: props.writeDate,
    placeholder: props.placeholder
  };
  var Container = props.container || CoolContainer;
  return /*#__PURE__*/React__default['default'].createElement(Container, containerProps, /*#__PURE__*/React__default['default'].createElement(aDateInput, inputProps));
};

var CoolSelectOld = function CoolSelectOld(props) {
  var _containerProps;

  // constructor(props) {
  //     super(props);
  //     state = {
  //         focus: false,
  //         empty: Utils.isNil(props.value)
  //     }
  //     onFocus = debounce(onFocus, 450);
  //     onInputChange = onInputChange.bind(this);
  //     selectOnChange = selectOnChange.bind(this);
  // }
  // componentWillMount() {
  // }
  var _useState = React$1.useState({
    focus: false,
    empty: Utils.Utils.isNil(props.value)
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var onInputChange = function onInputChange(val) {
    // change state
    setState({
      empty: Utils.Utils.isNil(val)
    }, function () {
      if (props.onChange) props.onChange(val, props.id);
    });
  };

  var selectOnChange = function selectOnChange(item) {
    console.log("[CoolSelect]: selectOnChange item= " + item);
    var valKey = props.valueKey || "value";
    onInputChange(Utils.Utils.getVal(valKey, item));
  };

  if (props.visible !== undefined && props.visible !== null && props.visible === false) {
    return null;
  }

  if (props.id) {
    console.log("[CoolSelect] render " + props.id);
  } else {
    console.log("[CoolSelect] render " + props.id + " label: " + props.label);
  }

  var value = props.value,
      className = props.className,
      searchable = props.searchable; // FUTURE: gestire onBLUR / onFOCUS

  var inputControl = '';

  if (className === null || className === undefined) {
    className = "";
  }
  className += " cool-select"; // baco - con re-render del datetime non
  // viene visualizzato il calendar => 
  // la label verrà, in questo caso sempre piccola

  className += " ci-focus";

  if (state.focus) ;

  if (!Utils.Utils.isNil(props.dropUp) && props.dropUp) {
    className += " ci-select-drop-up";
  }

  if (!Utils.Utils.isNil(value) || props.readOnly) {
    className += " ci-has-content";
  }

  if (searchable === false || searchable === "false") {
    className += " searchable-sel";
  }

  var hasError = null;

  if (props.validation) {
    // hasError = props.validation.get(props.id);
    hasError = props.validation.get ? props.validation.get(props.id) : props.validation[props.id];
  } else if (props.hasError) {
    hasError = props.hasError;
  }

  if (hasError) {
    className += " has-error";
  } // input container


  props.help;
      var preIcon = props.preIcon;
      props.postIcon;
      var label = props.label,
      wrapClassName = props.wrapClassName; // FUTURE: gestire onBLUR / onFOCUS

  if (wrapClassName === null || wrapClassName === undefined) {
    wrapClassName = "";
  }

  if (wrapClassName !== "none") {
    wrapClassName += " cool-select";
  } else {
    inputControl = ' form-control ';
  }

  var containerProps = (_containerProps = {
    preIcon: preIcon,
    postIcon: null,
    // postIcon || "fa fa-chevron-down",
    label: label,
    //  + " - open:" + open,
    required: props.required,
    minimal: props.minimal,
    className: wrapClassName,
    hasError: hasError,
    hasWarning: props.hasWarning,
    block: props.block,
    disabled: props.disabled,
    readOnly: props.readOnly,
    help: props.help,
    noClearBtn: true
  }, _defineProperty(_containerProps, "postIcon", " "), _defineProperty(_containerProps, "compact", props.compact ? props.compact : false), _containerProps); // onFocus: (e) => { onFocus() },
  // open: open

  var items = props.items || [];
  var valueKey = props.valueKey || "value";
  var labelKey = props.labelKey || "label";

  if (items.length > 0 && props.itemConverter) {
    console.log("[CoolSelect] with itemConverter");
    var it = [];

    for (var i = 0; i < items.length; i++) {
      var item = props.itemConverter(items[i], i);
      if (!item) continue;
      it.push(item);
    }

    items = it;
  }

  if (items.length > 0 && typeof items[0] === "string") {
    console.log("[CoolSelect] type of string");
    var _it = [];

    for (var _i = 0; _i < items.length; _i++) {
      var _item = {};
      var v = items[_i];
      _item.label = v;
      _item.value = v;

      _it.push(_item);
    }

    items = _it;
    valueKey = "value";
    labelKey = "label";
  }

  if (props.required !== undefined && !!!props.required) {
    var _it2 = {};
    _it2[valueKey] = "";
    _it2[labelKey] = "--";
    _it2.id = {};
    items = update__default$1['default'](items, {
      $unshift: [_it2]
    }); // items.unshift(it);
  }

  if (!Utils.Utils.isNil(props.multiple)) {
    !!props.multiple;
  } // let self = this;


  if (props.disabled === true || props.readOnly === true && items) {
    var valueItem = items.find(function (item) {
      return item[valueKey] === value;
    });
    value = valueItem ? valueItem[labelKey] : null;
  }

  var inputProps = {
    type: "text",
    className: className + inputControl,
    // onBlur: handleOnBlur,
    // onFocus: handleOnFocus,
    value: value || "",
    disabled: props.disabled,
    readOnly: props.readOnly
  };
  var selectProps = {
    className: className,
    // onBlur: (e) => { onBlur() },
    // onFocus: (e) => { onFocus() },
    // onClickOutside: (e) => { onBlur() },
    //onChange: (item) => { onInputChange(item[valueKey]) },
    value: value,
    //multiple: multiple,
    size: 1,
    // options: options
    disabled: props.disabled,
    readOnly: props.readOnly,
    options: items,
    placeholder: "",
    valueKey: valueKey,
    labelKey: labelKey,
    optionClassName: "Select-option",
    noResultsText: props.noResultsText || "No item available",
    isLoading: props.isLoading,
    hideSelectedOptions: props.hideSelectedOptions,
    // clearable: !!!props.required,
    // clearable: true,
    clearable: props.clearable,
    searchable: props.searchable !== null && props.searchable !== undefined ? props.searchable : true,
    arrowRenderer: function arrowRenderer(status) {
      // title={"open:" + status.isOpen}
      return /*#__PURE__*/React__default['default'].createElement("i", {
        className: "arrow-sel-icon " + (props.backArrow ? "back-arrow " : "") + " fa " + (status.isOpen ? "fa-chevron-up" : "fa-chevron-down")
      });
    }
  };
  console.log("-==-==-==-==-==-==-==- RENDER coolselect ::: items", items);
  return /*#__PURE__*/React__default['default'].createElement(CoolInputContainer, containerProps, props.disabled || props.readOnly ? /*#__PURE__*/React__default['default'].createElement("input", _extends({
    style: {
      paddingTop: "10px"
    }
  }, inputProps)) : /*#__PURE__*/React__default['default'].createElement(Select2__default['default'], _extends({
    onChange: selectOnChange
  }, selectProps)));
};

var CoolSelect = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CoolSelect, _React$PureComponent);

  var _super = _createSuper(CoolSelect);

  function CoolSelect(props) {
    var _this;

    _classCallCheck(this, CoolSelect);

    _this = _super.call(this, props);
    _this.state = {
      focus: false,
      empty: Utils.Utils.isNil(props.value)
    }; // this.onFocus = debounce(this.onFocus, 450);

    _this.onInputChange = _this.onInputChange.bind(_assertThisInitialized(_this));
    _this.selectOnChange = _this.selectOnChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CoolSelect, [{
    key: "onInputChange",
    value: function onInputChange(val) {
      this.setState({
        empty: Utils.Utils.isNil(val)
      }, function () {
        if (this.props.onChange) this.props.onChange(val, this.props.id);
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      console.log("[CoolSelect]: onFocus");
      this.setState({
        focus: true
      });
      if (this.props.onFocus) this.props.onFocus();
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      console.log("[CoolSelect]: onBlur");
      this.setState({
        focus: false
      });
      if (this.props.onBlur) this.props.onBlur();
    }
  }, {
    key: "selectOnChange",
    value: function selectOnChange(item) {
      console.log("[CoolSelect]: selectOnChange item= " + item);
      var valKey = this.props.valueKey || "value";
      this.onInputChange(Utils.Utils.getVal(valKey, item));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.visible !== undefined && this.props.visible !== null && this.props.visible === false) {
        return null;
      }

      if (this.props.id) {
        console.log("[CoolSelect] render " + this.props.id);
      } else {
        console.log("[CoolSelect] render " + this.props.id + " label: " + this.props.label);
      }

      var _this$props = this.props,
          value = _this$props.value,
          className = _this$props.className,
          searchable = _this$props.searchable,
          wordWrap = _this$props.wordWrap; // FUTURE: gestire onBLUR / onFOCUS

      var inputControl = '';

      if (className === null || className === undefined) {
        className = "";
      }
      className += " cool-select";
      className += " ci-focus";

      if (this.state.focus) ;

      if (!Utils.Utils.isNil(this.props.dropUp) && this.props.dropUp) {
        className += " ci-select-drop-up";
      }

      if (!Utils.Utils.isNil(value) || this.props.readOnly) {
        className += " ci-has-content";
      }

      if (searchable === false || searchable === "false") {
        className += " searchable-sel";
      }

      var hasError = null;

      if (this.props.validation) {
        hasError = this.props.validation.get ? this.props.validation.get(this.props.id) : this.props.validation[this.props.id];
      } else if (this.props.hasError) {
        hasError = this.props.hasError;
      }

      if (hasError) {
        className += " has-error";
      }

      if (wordWrap) {
        className += "wordWrap";
      } // input container


      var _this$props2 = this.props;
          _this$props2.help;
          var preIcon = _this$props2.preIcon;
          _this$props2.postIcon;
          var label = _this$props2.label,
          wrapClassName = _this$props2.wrapClassName; // FUTURE: gestire onBLUR / onFOCUS

      if (wrapClassName === null || wrapClassName === undefined) {
        wrapClassName = "";
      }

      if (wrapClassName !== "none") {
        wrapClassName += " cool-select";
      } else {
        inputControl = ' form-control ';
      }

      var containerProps = {
        preIcon: preIcon,
        postIcon: null,
        // postIcon || "fa fa-chevron-down",
        label: label,
        required: this.props.required,
        minimal: this.props.minimal,
        className: wrapClassName,
        hasError: hasError,
        hasWarning: this.props.hasWarning,
        block: this.props.block,
        disabled: this.props.disabled,
        readOnly: this.props.readOnly,
        help: this.props.help,
        noClearBtn: true,
        compact: this.props.compact ? this.props.compact : false
      };
      var items = this.props.items || [];
      var valueKey = this.props.valueKey || "value";
      var labelKey = this.props.labelKey || "label";

      if (items.length > 0 && this.props.itemConverter) {
        console.log("[CoolSelect] with itemConverter");
        var it = [];

        for (var i = 0; i < items.length; i++) {
          var item = this.props.itemConverter(items[i], i);
          if (!item) continue;
          it.push(item);
        }

        items = it;
      }

      if (items.length > 0 && typeof items[0] === "string") {
        console.log("[CoolSelect] type of string");
        var _it = [];

        for (var _i = 0; _i < items.length; _i++) {
          var _item = {};
          var v = items[_i];
          _item.label = v;
          _item.value = v;

          _it.push(_item);
        }

        items = _it;
        valueKey = "value";
        labelKey = "label";
      }

      if (!Utils.Utils.isNil(this.props.multiple)) {
        !!this.props.multiple;
      }

      if (this.props.disabled === true || this.props.readOnly === true && items) {
        var valueItem = items.find(function (item) {
          return item[valueKey] === value;
        });
        value = valueItem ? valueItem[labelKey] : null;
      }

      var inputProps = {
        id: this.props.id,
        type: "text",
        className: className + inputControl,
        value: value || "",
        disabled: this.props.disabled,
        readOnly: this.props.readOnly
      };
      var selectProps = {
        id: this.props.id,
        className: this.props.className,
        items: items,
        value: value || "",
        placeholder: this.props.placeholder,
        disabled: this.props.disabled,
        readOnly: this.props.readOnly,
        wordWrap: this.props.wordWrap,
        searchable: this.props.searchable !== null && this.props.searchable !== undefined ? this.props.searchable : false,
        componentRenderer: this.props.componentRenderer,
        openIcon: this.props.openIcon || "",
        closeIcon: this.props.closeIcon || "",
        valueKey: this.props.valueKey || "value",
        labelKey: this.props.labelKey || "label",
        noResultsText: this.props.noResultsText || "No item available"
      };
      var Container = this.props.container || CoolInputContainer;
      return /*#__PURE__*/React$1.createElement(Container, containerProps, this.props.disabled || this.props.readOnly ? /*#__PURE__*/React$1.createElement("input", _extends({
        style: {
          paddingTop: "10px"
        }
      }, inputProps)) : /*#__PURE__*/React$1.createElement(Select, _extends({}, selectProps, {
        onChange: this.selectOnChange
      })));
    }
  }]);

  return CoolSelect;
}(React$1.PureComponent);

var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);

  var _super2 = _createSuper(Select);

  function Select(props) {
    var _this2;

    _classCallCheck(this, Select);

    _this2 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "selectItem", function (item) {
      _this2.setState({
        selectedItem: item,
        listOpen: false,
        cursor: -1
      }, _this2.props.onChange(item, _this2.props.id));
    });

    var id = _this2.props.id || Utils.Utils.uuid("select_input_coolselect");
    _this2.handleChange = _this2.handleChange.bind(_assertThisInitialized(_this2));
    _this2.handleOutsideClick = _this2.handleOutsideClick.bind(_assertThisInitialized(_this2));
    _this2.handleKeyDown = _this2.handleKeyDown.bind(_assertThisInitialized(_this2));
    _this2.closeList = _this2.closeList.bind(_assertThisInitialized(_this2));

    var selItem = _this2.checkSelectedItem(_this2.props);

    _this2.state = {
      id: id,
      selectedItem: selItem,
      listOpen: false,
      filteredItem: [],
      cursor: -1
    };
    return _this2;
  }

  _createClass(Select, [{
    key: "checkSelectedItem",
    value: function checkSelectedItem(props) {
      var _selItem;

      var selItem = (_selItem = {}, _defineProperty(_selItem, props.labelKey, ""), _defineProperty(_selItem, props.valueKey, ""), _selItem);

      for (var i = 0; i < props.items.length; i++) {
        if (props.items[i][props.valueKey] === props.value) {
          selItem = props.items[i];
        }
      }

      return selItem;
    }
  }, {
    key: "openList",
    value: function openList(e) {
      document.addEventListener('click', this.handleOutsideClick);
      console.log(e);
      this.setState({
        listOpen: true
      });
    }
  }, {
    key: "closeList",
    value: function closeList() {
      document.removeEventListener('click', this.handleOutsideClick);
      this.setState({
        listOpen: false
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var _this$state = this.state,
          cursor = _this$state.cursor,
          filteredItem = _this$state.filteredItem;
      var keyCode = e.keyCode;

      if (keyCode === 13 || keyCode === 9) {
        this.setState({
          listOpen: false
        });
      }

      if (keyCode === 40) {
        // this.refs.ulList && this.refs.ulList.focus();
        this.ulList.focus();
      }

      if (keyCode === 38 && cursor > 0) {
        var _selectedItem;

        this.setState({
          cursor: this.state.cursor - 1,
          selectedItem: (_selectedItem = {}, _defineProperty(_selectedItem, this.props.labelKey, filteredItem[cursor - 1][this.props.labelKey]), _defineProperty(_selectedItem, this.props.valueKey, filteredItem[cursor - 1][this.props.valueKey]), _selectedItem)
        });
      } else if (keyCode === 40 && cursor < filteredItem.length - 1) {
        var _selectedItem2;

        this.setState({
          cursor: this.state.cursor + 1,
          selectedItem: (_selectedItem2 = {}, _defineProperty(_selectedItem2, this.props.labelKey, filteredItem[cursor + 1][this.props.labelKey]), _defineProperty(_selectedItem2, this.props.valueKey, filteredItem[cursor + 1][this.props.valueKey]), _selectedItem2)
        });
      }
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(e) {
      var id = this.props.id || this.state.id; // // ignore clicks on the component itself

      if (e.target.id.indexOf(id) > -1 || e.target.parentNode.id.indexOf(id) > -1) {
        return;
      }

      this.closeList();
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var _item2;

      var that = this;
      var currentList = [];
      var newList = [];
      var resetFunc = "";

      if (e.target.value !== "") {
        currentList = this.props.items;
        var filter = e.target.value.toLowerCase(); // check to see if the list items includes the filter term
        // If it does, it will be added to newList

        newList = currentList.filter(function (item) {
          if (item[that.props.labelKey] && item[that.props.labelKey].toString().toLowerCase().includes(filter)) {
            return true;
          }
        });

        if (newList.length === 0) {
          var _addObject;

          var addObject = (_addObject = {}, _defineProperty(_addObject, this.props.labelKey, this.props.noResultsText), _defineProperty(_addObject, this.props.valueKey, this.props.noResultsText), _addObject);
          newList = update__default['default'](newList, {
            $push: [addObject]
          });
        }

        resetFunc = function resetFunc(item, id) {
          console.log("no reseting here" + id);
        };
      } else {
        // If input field is empty, set newList to original items list
        newList = this.props.items;
        resetFunc = this.props.onChange;
      }

      var item = (_item2 = {}, _defineProperty(_item2, this.props.labelKey, e.target.value), _defineProperty(_item2, this.props.valueKey, e.target.value), _item2);
      this.setState({
        filteredItem: newList,
        selectedItem: item,
        cursor: -1
      }, resetFunc(item, this.props.id));
    }
  }, {
    key: "elabItemRenderer",
    value: function elabItemRenderer(itemRenderer, item) {
      if (itemRenderer) {
        return itemRenderer(item);
      } else {
        return item[this.props.labelKey];
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var newState = update__default['default'](this.state, {
        filteredItem: {
          $set: this.props.items
        }
      });
      this.setState(newState);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var selItem = this.checkSelectedItem(nextProps);
      this.setState({
        selectedItem: selItem,
        filteredItem: nextProps.items
      });
    }
  }, {
    key: "renderSelectIcon",
    value: function renderSelectIcon() {
      var _this3 = this;

      var selectIcon = /*#__PURE__*/React$1.createElement("div", null);

      if (this.state.listOpen) {
        selectIcon = /*#__PURE__*/React$1.createElement("div", {
          className: "select-arrow-icon",
          onClick: this.closeList
        }, /*#__PURE__*/React$1.createElement("i", {
          className: this.props.closeIcon ? this.props.closeIcon : " closeIcon"
        }));
      } else {
        selectIcon = /*#__PURE__*/React$1.createElement("div", {
          className: "select-arrow-icon",
          style: {
            width: "100%",
            height: "100%",
            cursor: "pointer"
          },
          onClick: function onClick(event) {
            return _this3.openList(event);
          }
        }, /*#__PURE__*/React$1.createElement("i", {
          className: this.props.openIcon ? this.props.openIcon : " openIcon"
        }));
      }

      return selectIcon;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state2 = this.state,
          id = _this$state2.id,
          selectedItem = _this$state2.selectedItem,
          listOpen = _this$state2.listOpen,
          filteredItem = _this$state2.filteredItem,
          cursor = _this$state2.cursor; // let items = this.props.items || [];

      var labelKey = this.props.labelKey;
      return /*#__PURE__*/React$1.createElement("div", {
        className: "select-wrapper " + (this.props.className ? this.props.className : " ")
      }, /*#__PURE__*/React$1.createElement("div", {
        className: "select-holder "
      }, /*#__PURE__*/React$1.createElement("div", {
        className: "select-header"
      }, this.props.searchable ? /*#__PURE__*/React$1.createElement("input", {
        id: id,
        className: "select-value",
        placeholder: this.props.placeholder,
        onKeyDown: this.handleKeyDown,
        onMouseDown: function onMouseDown(event) {
          return _this4.openList(event);
        },
        onChange: function onChange(e) {
          return _this4.handleChange(e);
        },
        value: selectedItem[labelKey]
      }) : /*#__PURE__*/React$1.createElement("input", {
        id: id,
        className: "select-value",
        placeholder: this.props.placeholder,
        onKeyDown: this.handleKeyDown,
        onMouseDown: function onMouseDown(event) {
          return _this4.openList(event);
        },
        value: selectedItem[labelKey],
        readOnly: true
      })), /*#__PURE__*/React$1.createElement("div", {
        id: "select-arrow_" + id,
        className: "select-arrow"
      }, this.renderSelectIcon())), /*#__PURE__*/React$1.createElement("div", {
        className: "item-container" + (this.props.wordWrap ? " wordWrap " : "")
      }, listOpen && /*#__PURE__*/React$1.createElement("ul", {
        className: "select-list",
        ref: function ref(_ref) {
          _this4.ulList = _ref;
        },
        onKeyDown: this.handleKeyDown,
        tabIndex: "0"
      }, filteredItem.map(function (item, index) {
        return /*#__PURE__*/React$1.createElement("li", _defineProperty({
          className: "select-list-item",
          key: index,
          value: item[labelKey],
          id: id + " - " + index,
          onClick: function onClick() {
            return _this4.selectItem(item);
          }
        }, "className", selectedItem[_this4.props.labelKey] === item[_this4.props.labelKey] || selectedItem[_this4.props.valueKey] === item[_this4.props.valueKey] || cursor === index ? "selected active" : ""), item.itemRenderer ? _this4.elabItemRenderer(item.itemRenderer, item) : _this4.elabItemRenderer(_this4.props.componentRenderer, item));
      }))));
    }
  }]);

  return Select;
}(React$1.Component);

/**
 * @augments {Component<{width: string, height: string, animateBar: boolean}, State>}
 */

var ProgressBar = function ProgressBar(props) {
  // constructor(props) {
  //     super(props);
  //     state = {
  //     }
  // }
  var progresBarStyle = {};

  if (props.height) {
    progresBarStyle["height"] = props.height;
  }

  if (props.width) {
    progresBarStyle["width"] = props.width + "%";
  }

  var animateBar = props.animateBar;
  var showPercentage = props.showPercentage;
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "progress-container" + (props.className ? " " + props.className : "")
  }, /*#__PURE__*/React$1.createElement("span", {
    className: animateBar ? " animate " : " progressBar ",
    role: "progressbar",
    style: progresBarStyle
  }, showPercentage ? props.width + "%" : "")));
};

var InputRange = function InputRange(props) {
  //     super(props);
  //     componentName = "[InputRange.jsx] ";
  //     rispostaOnChange = rispostaOnChange.bind(this);
  // }

  var rispostaOnChange = function rispostaOnChange(event) {
    props.onChange(event);
  };

  var visualValue = props.visualValue ? props.visualValue : "";
  var positionValue = props.positionValue ? props.positionValue : "right";
  var widthValue = props.max.length * 13;
  var value = props.value || Math.floor(props.max / 2);
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      width: "100%"
    }
  }, visualValue === true && positionValue === "top" ? /*#__PURE__*/React$1.createElement("div", {
    className: "input-group custom-slider  " + props.className,
    style: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "d-flex range-slider-value-top mb-4" + props.className
  }, /*#__PURE__*/React$1.createElement("input", {
    style: {
      backgroundColor: "#2c3e50",
      textDecorationColor: "#FFFFFF",
      textAlign: "center",
      color: "#FFFFFF",
      width: widthValue + "px"
    },
    type: "number",
    key: "inputRangeMax",
    className: "form-control range-slider-range",
    id: props.id,
    disabled: props.disabled,
    name: props.name,
    value: value,
    onChange: rispostaOnChange
  }))) : null, /*#__PURE__*/React$1.createElement("div", {
    className: "input-group custom-slider  " + props.className
  }, visualValue === true && positionValue === "left" ? /*#__PURE__*/React$1.createElement("span", {
    className: "d-flex range-slider-value-left mr-4 mt-1 " + props.className
  }, /*#__PURE__*/React$1.createElement("input", {
    style: {
      backgroundColor: "#2c3e50",
      textDecorationColor: "#FFFFFF",
      textAlign: "center",
      color: "#FFFFFF",
      width: widthValue + "px"
    },
    type: "number",
    key: "inputRangeMax",
    className: "form-control range-slider-range",
    id: props.id,
    disabled: props.disabled,
    name: props.name,
    value: value,
    onChange: rispostaOnChange
  })) : null, /*#__PURE__*/React$1.createElement("input", {
    type: "range",
    style: {
      outlineColor: "white"
    },
    className: "form-control range-slider-range",
    id: props.id,
    required: props.required,
    disabled: props.disabled,
    name: props.name,
    value: value,
    min: props.min,
    max: props.max,
    step: props.step,
    onChange: rispostaOnChange
  }), visualValue === true && positionValue === "right" ? /*#__PURE__*/React$1.createElement("span", {
    className: "d-flex range-slider-value-right ml-4 mt-1 " + props.className
  }, /*#__PURE__*/React$1.createElement("input", {
    style: {
      backgroundColor: "#2c3e50",
      textDecorationColor: "#FFFFFF",
      textAlign: "center",
      color: "#FFFFFF",
      width: widthValue + "px"
    },
    type: "number",
    key: "inputRangeMax ",
    className: "form-control range-slider-range",
    id: props.id,
    disabled: props.disabled,
    name: props.name,
    value: value,
    onChange: rispostaOnChange
  })) : null), visualValue === true && positionValue === "bottom" ? /*#__PURE__*/React$1.createElement("div", {
    className: "input-group custom-slider  " + props.className,
    style: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "d-flex range-slider-value-bottom mt-4" + props.className
  }, /*#__PURE__*/React$1.createElement("input", {
    style: {
      backgroundColor: "#2c3e50",
      textDecorationColor: "#FFFFFF",
      textAlign: "center",
      color: "#FFFFFF",
      width: widthValue + "px"
    },
    type: "number",
    key: "inputRangeMax ",
    className: "form-control range-slider-range",
    id: props.id,
    disabled: props.disabled,
    name: props.name,
    value: value,
    onChange: rispostaOnChange
  }))) : null);
};

var aToggle = function aToggle(props) {
  // constructor(props) {
  //     super(props);
  //     onChange = onChange.bind(this);
  // }
  var onChangeHandler = function onChangeHandler(e) {
    if (props.onChange) props.onChange(e, props.value);
  };

  var children = props.children,
      label = props.label,
      checked = props.checked;
      props.onChange;
      var id = props.id,
      disabled = props.disabled,
      radio = props.radio,
      name = props.name,
      value = props.value,
      type = props.type;
  if (children && !label) label = children;
  var inputType = "radio";

  if (radio) {
    inputType = "radio";
  } else {
    inputType = "checkbox";
  }

  if (type && type === "radio") {
    inputType = "radio";
  } else if (type && type === "checkbox") {
    inputType = "checkbox";
  }

  return /*#__PURE__*/React__default['default'].createElement("label", {
    className: "aToggle custom-toggle " + (radio || type === "radio" ? 'custom-radio' : 'custom-checkbox') + (props.className ? " " + props.className : "")
  }, /*#__PURE__*/React__default['default'].createElement("input", {
    type: inputType,
    name: radio ? name : 'false',
    className: "toggle-input",
    checked: checked ? true : false,
    onChange: onChangeHandler,
    id: id,
    value: value ? value : "",
    disabled: disabled
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    style: disabled ? {
      "backgroundColor": "LightGray",
      'cursor': 'not-allowed'
    } : null,
    className: "toggle-indicator"
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "toggle-label"
  }, label));
};

var aSwitch = function aSwitch(props) {
  // constructor(props) {
  //     super(props);
  //     let id = props.id;
  //     if (!id) {
  //         id = Utils.uuid();
  //     }
  //     state = {
  //         id: id,
  //     }
  // }
  var id = props.id;

  if (!id) {
    id = Utils.Utils.uuid();
  }

  var _useState = React$1.useState({
    id: id
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0];
      _useState2[1];

  var onChangeHandler = function onChangeHandler(ev) {
    if (props.onChange) {
      return props.onChange(ev);
    }
  };

  var label = props.label,
      checked = props.checked;
      props.onChange;
      var disabled = props.disabled,
      name = props.name,
      value = props.value,
      className = props.className,
      offLabel = props.offLabel,
      onLabel = props.onLabel;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "onoffswitch pull-right" + (className ? " " + className : "")
  }, /*#__PURE__*/React__default['default'].createElement("input", {
    type: "checkbox",
    name: name,
    className: "onoffswitch-checkbox",
    id: state.id,
    checked: checked,
    onChange: onChangeHandler,
    disabled: disabled,
    value: value ? value : ""
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "onoffswitch-label",
    htmlFor: state.id
  }, label, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "on-label"
  }, onLabel), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "off-label"
  }, offLabel)));
};

/** 
 * panel component
 * proprerties supported:
 * 
*/

var aFieldset = function aFieldset(props) {
  // static propTypes = {
  //   disabled: t.bool,
  //   loading: t.bool,
  //   title: t.string,
  //   icon: t.string
  // }
  // static defaultProps = {
  //   disabled: false,
  //   loading: false
  // }
  var _props = props,
      children = _props.children,
      title = _props.title,
      disabled = _props.disabled,
      icon = _props.icon,
      loading = _props.loading;
      _props.type;
      var className = _props.className;
  props = props;

  if (loading) {
    disabled = true;
  }

  var htitle = null;
  var ticon = "";

  if (title) {
    htitle = title;

    if (icon) {
      ticon = /*#__PURE__*/React__default['default'].createElement("i", {
        className: icon
      });
    }
  }

  return /*#__PURE__*/React__default['default'].createElement("fieldset", {
    disabled: disabled,
    className: " form-group " + (className ? className : " ")
  }, htitle !== null && /*#__PURE__*/React__default['default'].createElement("legend", {
    className: "fieldset-title"
  }, ticon, " ", htitle, " "), children ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "fieldset-content"
  }, children) : null);
};

var CoolCheckBox = function CoolCheckBox(props) {
  // constructor(props) {
  //     super(props);
  //     onChange = onChange.bind(this);
  // }
  var onChangeHandler = function onChangeHandler(e) {
    if (props.onChange) props.onChange(e, props.value);
  };

  var children = props.children,
      label = props.label,
      checked = props.checked;
      props.onChange;
      var id = props.id,
      disabled = props.disabled;
      props.value;
      var topLabel = props.topLabel,
      bottomLabel = props.bottomLabel,
      formatter = props.formatter,
      color = props.color,
      showProgressBar = props.showProgressBar;
  if (children && !label) label = children;
  var toggleIndicatorClass = !checked ? " toggle-indicator" : " toggle-indicator toggle-indicator-checked";
  var progressBar = false;
  var areNumbers = !isNaN(parseFloat(label)) && !isNaN(parseFloat(bottomLabel));

  if (showProgressBar) {
    if (areNumbers) {
      progressBar = {};
      progressBar.height = props.height || "10px";
      progressBar.width = parseFloat(label) / parseFloat(bottomLabel) * 100 + "%";
    } else {
      console.warn("[CoolCheckBox]: the property label and bottom label must be numbers or progress bar will not able to show.");
    }
  }

  if (areNumbers && formatter) {
    label = formatter(label);
    bottomLabel = formatter(bottomLabel);
  }

  var fatherClassName = disabled ? "checkbox-disabled" : "checkbox";
  var toggleColor = null;
  var checkboxLabelStyle = null;

  if (color) {
    fatherClassName += " colored";
    if (progressBar) progressBar.backgroundColor = color;

    if (checked) {
      toggleColor = {
        backgroundColor: color
      };
      checkboxLabelStyle = {
        color: color
      };
    }
  }

  if (disabled) {
    checkboxLabelStyle = null;
    toggleColor = {
      backgroundColor: "LightGray",
      cursor: "not-allowed"
    };
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    className: props.className ? fatherClassName + " " + props.className : fatherClassName
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "checkbox-topLabel"
  }, topLabel), /*#__PURE__*/React__default['default'].createElement("div", {
    className: checked ? "checked-checkbox" : "unchecked-checkbox",
    onClick: onChangeHandler
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "coolCheckBox custom-toggle custom-checkbox"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: toggleColor,
    className: disabled ? " " : toggleIndicatorClass
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    style: checkboxLabelStyle,
    className: checked ? "checkbox-label" : "dark-label"
  }, disabled && !checked ? "-" : label)), progressBar ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "coolProgress-container"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "progressBar",
    role: "progressbar",
    style: progressBar
  })) : null), /*#__PURE__*/React__default['default'].createElement("span", {
    className: checked ? "checkbox-bottomLabel" : "dark-bottomLabel"
  }, " ", bottomLabel));
};

var CoolProgressBar = function CoolProgressBar(props) {
  var actualValue = props.actualValue,
      maxValue = props.maxValue,
      leftLabel = props.leftLabel,
      rightLabel = props.rightLabel,
      formatter = props.formatter;
  var progresBarStyle = {};
  progresBarStyle["height"] = props.height || "5px";
  progresBarStyle["width"] = actualValue / maxValue * 100 + "%";

  if (formatter) {
    actualValue = formatter(actualValue);
    maxValue = formatter(maxValue);
  }

  return /*#__PURE__*/React$1.createElement("div", {
    className: props.className ? " " + props.className : "",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "coolProgressBar-title"
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "progress-leftTitle"
  }, leftLabel), /*#__PURE__*/React$1.createElement("span", {
    className: "progress-rightTitle"
  }, rightLabel)), /*#__PURE__*/React$1.createElement("div", {
    className: "coolProgressBar-values"
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "progress-leftLabel"
  }, actualValue), /*#__PURE__*/React$1.createElement("span", {
    className: "progress-rightLabel"
  }, maxValue)), /*#__PURE__*/React$1.createElement("div", {
    className: "coolProgress-container"
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "progressBar",
    role: "progressbar",
    style: progresBarStyle
  })));
};

var CoolGroupSelector = function CoolGroupSelector(props) {
  var idKey = props.id || Utils.Utils.uuid("coolgroupselector");
  var valueKey = props.valueKey || "value";
  var labelKey = props.labelKey || "label";

  var _useState = React$1.useState({
    idKey: idKey,
    valueKey: valueKey,
    labelKey: labelKey,
    items: props.items
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0];
      _useState2[1]; // constructor(props) {
  //     super(props);
  //     let idKey = props.id || Utils.uuid("coolgroupselector");
  //     let valueKey = props.valueKey || "value";
  //     let labelKey = props.labelKey || "label";
  //     state = {
  //         idKey: idKey,
  //         valueKey: valueKey,
  //         labelKey: labelKey,
  //         items: props.items,
  //     }
  // }


  var itemRenderer = function itemRenderer(_itemRenderer, item) {
    var labelKey = state.labelKey;

    if (_itemRenderer) {
      return _itemRenderer(item);
    } else {
      return getItemValue(item, labelKey);
    }
  };

  var unSelectItem = function unSelectItem(index, item) {
    props.unSelectItem(index, item);
  };

  var selectItem = function selectItem(item) {
    props.selectItem(item);
  };

  var getItemValue = function getItemValue(item, key) {
    var arrKey = key.split(".");
    var value = item;

    if (arrKey.length > 1) {
      for (var i = 0; i < arrKey.length; i++) {
        value = value[arrKey[i]];
      }
    } else {
      value = value[key];
    }

    return value;
  };

  var items = state.items;
  var leftLabel = props.leftLabel,
      rightLabel = props.rightLabel,
      title = props.title,
      className = props.className,
      disabled = props.disabled; // let { idKey, valueKey, labelKey } = state;

  var selectedItems = props.selectedItems;
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "groupselector-title"
  }, title), /*#__PURE__*/React__default['default'].createElement("div", {
    className: " groupselector-wrapper " + (className ? className : " ")
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "groupselector-label"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "progress-leftLabel"
  }, leftLabel), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "progress-rightLabel"
  }, rightLabel)), /*#__PURE__*/React__default['default'].createElement("ul", {
    key: idKey,
    className: "groupselector-items"
  }, items.map(function (item, index) {
    var foundIndex = selectedItems.findIndex(function (el1) {
      return getItemValue(el1, valueKey) === getItemValue(item, valueKey);
    });

    if (selectedItems && foundIndex !== -1) {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        className: "select-item selected " + (disabled ? "is-disabled " : ""),
        key: idKey + "_" + index,
        value: getItemValue(item, valueKey),
        onClick: function onClick() {
          return unSelectItem(foundIndex, item);
        }
      }, item.itemRenderer ? itemRenderer(item.itemRenderer, item) : itemRenderer(props.componentRenderer, item));
    } else {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        className: "select-item " + (disabled ? "is-disabled " : ""),
        key: idKey + "_" + index,
        value: getItemValue(item, valueKey),
        onClick: function onClick() {
          return selectItem(item);
        }
      }, item.itemRenderer ? itemRenderer(item.itemRenderer, item) : itemRenderer(props.componentRenderer, item));
    }
  }))));
};

var std = {
  _libraryName: "standard",
  "markNegativeValue": function markNegativeValue(val, col, item, index, colInfo) {
    if (Utils__default['default'].isNil(val)) return "";
    if (isNaN(val)) return val;
    var styleOnSegno = "";

    if (val < 0) {
      styleOnSegno = "text-danger";
    }

    return /*#__PURE__*/React.createElement("span", {
      className: styleOnSegno
    }, val);
  }
};

var libs = [std // ADD HERE other internal renderer libraries object
];
var LOG_NAME = "[LibraryRenderer] ";

var LibraryRenderer = /*#__PURE__*/function () {
  function LibraryRenderer() {
    _classCallCheck(this, LibraryRenderer);

    this.library = {};
    this.libImported = {};

    this._init();
  }

  _createClass(LibraryRenderer, [{
    key: "_init",
    value: function _init() {
      var self = this;
      libs.forEach(function (lib, index) {
        self._addLibrary(lib, true);
      });
    }
  }, {
    key: "addLibrary",
    value: function addLibrary(lib) {
      this._addLibrary(lib, true);
    }
  }, {
    key: "cleanup",
    value: function cleanup(lib) {
      if (!lib) {
        lib = {};
      }

      var clib = {};
      var rends = Object.keys(lib);
      rends.forEach(function (rend) {
        if (rend === "_libraryName") return;

        if (rend === "") {
          return;
        }

        var funcRenderer = lib[rend];

        if (funcRenderer && typeof funcRenderer !== 'function') {
          console.warn("library ", lib, " with field '" + rend + "' that isn't a renderer but is this:", funcRenderer);
          return;
        }

        clib[rend] = funcRenderer;
      });
      return clib;
    }
  }, {
    key: "_addLibrary",
    value: function _addLibrary(lib, checkDup) {
      var self = this;
      var currLibName = lib._libraryName || "++unnamed library++";

      if (checkDup) {
        if (!lib._libraryName) {
          console.error(LOG_NAME + "try to adds a library without _libraryName", lib);
          return;
        }

        if (self.libImported[lib._libraryName]) {
          console.error(LOG_NAME + "try to adds library '" + currLibName + "' but already imported", lib);
          return;
        }
      } else {
        if (lib._libraryName && self.libImported[lib._libraryName]) {
          console.warn(LOG_NAME + "library '" + currLibName + "' already imported");
        }
      }

      var rends = Object.keys(lib);
      rends.forEach(function (rend) {
        if (rend === "_libraryName") return;
        var funcRenderer = lib[rend];

        if (funcRenderer && typeof funcRenderer !== 'function') {
          console.warn(LOG_NAME + "In library '" + currLibName + "' the field '" + rend + "' isn't a renderer");
          return;
        }

        if (self.library[rend]) {
          console.debug(LOG_NAME + "" + currLibName + " overwrite previous renderer " + rend);
        }

        self.library[rend] = funcRenderer;
      });
      if (lib._libraryName) self.libImported[lib._libraryName] = true;
    }
  }, {
    key: "getRenderer",
    value: function getRenderer(name) {
      var self = this;
      var rend = name;
      var func = self.library[rend];

      if (!func) {
        return null;
      }

      return func;
    }
  }]);

  return LibraryRenderer;
}();

var _libStdRenderer = new LibraryRenderer();

_libStdRenderer.setup = function (library) {
  var lib = _libStdRenderer.cleanup(library);

  lib.getRenderer = function (rendName) {
    var func = this[rendName];

    if (!func) {
      func = _libStdRenderer.getRenderer(rendName);

      if (!func) {
        console.warn(LOG_NAME + "renderer '" + rendName + "' doesn't exists");
      }
    }

    return func;
  };

  lib.extraLibrary = lib;
  lib.getRenderer = lib.getRenderer.bind(lib);
  return lib;
};

/**
 * CoolGrid con loader semplificato.
 * 
 * property gestite:
 * - columnInfos: informazioni sulle colonne
 * - count: numero di righe
 * - loadPage: funzione con due indici (from, to) come parametro che carica e restituisce un segmento from-to di righe (tramite promise)
 * - itemsName: nome (label) di più elementi che rappresentano una riga
 * - itemName: nome (label) di un elemento che rappresentano una riga
 * - noItemsLabel
 * - inputRef
 * - onRowClick
 * 
 * @author G. Annunziata
 */

var CoolGridServerPaged = /*#__PURE__*/function (_PureComponent) {
  _inherits(CoolGridServerPaged, _PureComponent);

  var _super = _createSuper(CoolGridServerPaged);

  function CoolGridServerPaged(props) {
    var _this;

    _classCallCheck(this, CoolGridServerPaged);

    _this = _super.call(this, props);
    _this.state = _this.getInitialState();
    _this.libRenderer = _libStdRenderer.setup(props.libRenderer);
    _this.getLoaderRest = _this.getLoaderRest.bind(_assertThisInitialized(_this));
    _this.getTableColumnsDef = _this.getTableColumnsDef.bind(_assertThisInitialized(_this));
    _this.reload = _this.reload.bind(_assertThisInitialized(_this));
    _this.refTable = _this.refTable.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CoolGridServerPaged, [{
    key: "getInitialState",
    value: function getInitialState() {
      return {
        id: this.props.id || Utils.Utils.uuid("cgsp")
      };
    }
  }, {
    key: "reload",
    value: function reload() {
      this.table.initGrid();
    }
  }, {
    key: "getLoaderRest",
    value: function getLoaderRest() {
      var self = this;
      var loader = {};

      loader.init = function (sortBy, sortAsc, sortCmp, initData, callOk, callErr) {
        console.debug("INIT COOL GRID");
        var cnt = self.props.count; //self.setState({ count: cnt }, () => {

        if (self.props.init) {
          self.props.init(sortBy, sortAsc, sortCmp, initData);
        }

        callOk({
          count: cnt,
          error: null
        }); //});
      };

      loader.load = function (from, to, sortBy, sortAsc, sortComparator, callOk, callErr) {
        if (!self.props.loadPage) {
          throw new Error("CoolGridServerPaged: loadPage property required!!");
        }

        console.debug("call loadPage...", from, to, sortBy, sortAsc);
        self.props.loadPage(from, to, sortBy, sortAsc).then(function (res) {
          if (res.rows && res.rows !== "") console.debug("loadPage - ok load", res);else {
            console.debug("loadPage noRows?");
            return callOk({
              data: [],
              count: 0,
              error: res.error || null
            });
          } // Devo decodificare i dati che arrivano a forma di stringa unica

          var colInfos = self.props.columnInfos;
          var rowSeparator = "%&&%";
          var columnSeparator = "#**#";

          if (colInfos && !Array.isArray(colInfos)) {
            rowSeparator = colInfos.rowSeparator || rowSeparator;
            columnSeparator = colInfos.columnSeparator || columnSeparator;
          }

          var rows = res.rows ? res.rows.split(rowSeparator) : [];
          var objectRows = [];
          rows.map(function (item) {
            if (!item || item === "") return;
            var columns = item.split(columnSeparator);
            columns.pop(); // Elimino l'ultimo elemento che non è valido

            var rowObject = [];
            columns.forEach(function (colValue, index) {
              // let columnInfo = colInfos.columnInfos[index];
              rowObject[index] = colValue;
            });
            objectRows.push(rowObject);
          });
          return callOk({
            data: objectRows,
            count: objectRows.length,
            error: null
          });
        }, function (err) {
          console.error("loader rest load error", err, from, to, sortBy, sortAsc);
        });
      };

      loader.setCount = function (newCount) {
        return;
      };

      loader.init = loader.init.bind(loader);
      loader.load = loader.load.bind(loader);
      loader.setCount = loader.setCount.bind(loader);
      return loader;
    }
  }, {
    key: "getTableColumnsDef",
    value: function getTableColumnsDef() {
      console.debug("CoolGridServerPaged.getTableColumnsDef");
      var self = this;
      var defCols = [];
      var columnScale = 1;

      if (self.props.columnScale) {
        columnScale = self.props.columnScale;
      }

      if (this.props.menuCols) {
        defCols.push(this.props.menuCols);
      }

      if (!this.props.columnInfos) return this._extraCols(defCols);
      var columnInfos = this.props.columnInfos;

      if (!Array.isArray(columnInfos)) {
        // LLInfos
        columnInfos = columnInfos.columnInfos;
      }

      if (!columnInfos) return this._extraCols(defCols);
      columnInfos.forEach(function (columnInfo, index) {
        var columnDefinition = {
          visible: columnInfo.visibile,
          name: columnInfo.posizione,
          label: columnInfo.caption ? columnInfo.caption : columnInfo.nome,
          fieldPath: index,
          styleFuncs: [],
          renderer: function renderer(val, col, item, index) {
            if (!val) return null;

            if (columnInfo.formatoNumberExcel) {
              val = Utils.NumberFormatter.formatFromJavaPattern(val, columnInfo.formatoNumberExcel);
            }

            if (col.styleFuncs && col.styleFuncs.length > 0) {
              col.styleFuncs.forEach(function (fun, idx) {
                val = fun(val, col, item, index, columnInfo);
              });
            }

            if (!columnInfo.visibile) {
              return null;
            }

            return /*#__PURE__*/React__default['default'].createElement("div", {
              title: "[#" + index + "] " + val,
              className: "cgsp-item"
            }, val);
          }
        };

        if (columnInfo.align !== 'left') {
          columnDefinition.className = columnInfo.align;
        }

        if (columnInfo.width) {
          var newWidth = columnInfo.width * columnScale;
          columnDefinition.width = newWidth;
        } // if (columnInfo.sort) {


        if (self.props.useSortable === undefined || self.props.useSortable) columnDefinition.sortable = true; // }

        if (columnInfo.styleFunction) {
          var func = columnInfo.styleFunction;
          var funcs = func;

          if (!Array.isArray(func)) {
            funcs = [];
            funcs.push(func);
          }

          funcs.forEach(function (styleFunc) {
            var renderer = self.libRenderer.getRenderer(styleFunc);
            if (renderer) columnDefinition.styleFuncs.push(renderer);
          });
        }

        defCols.push(columnDefinition);
      }, this);

      var cols = this._extraCols(defCols);

      return cols;
    }
  }, {
    key: "_extraCols",
    value: function _extraCols(defCols) {
      if (this.props.preDef) {
        var pd = this.props.preDef;
        pd.forEach(function (col) {
          defCols.unshift(col);
        });
      }

      if (this.props.postDef) {
        var _pd = this.props.postDef;

        _pd.forEach(function (col) {
          defCols.push(col);
        });
      }

      return defCols;
    }
  }, {
    key: "refTable",
    value: function refTable(table) {
      this.table = table;
    }
  }, {
    key: "render",
    value: function render() {
      var defCols = this.getTableColumnsDef();
      var loader = this.getLoaderRest();
      console.debug("CoolGridServerPaged render", defCols);
      return /*#__PURE__*/React__default['default'].createElement(CoolGrid, {
        id: this.state.id,
        ref: this.props.inputRef || this.refTable,
        pageClassName: "justify-content-center",
        def: defCols,
        count: this.props.count,
        pageSize: 0,
        loader: loader,
        onRowClick: this.props.onRowClick,
        onRowDoubleClick: this.props.onRowDoubleClick,
        autoSizer: false,
        noItemsLabel: this.props.noItemsLabel,
        itemName: this.props.itemName,
        itemsName: this.props.itemsName,
        loading: this.props.loading,
        showColumns: this.props.showColumns,
        useSortable: this.props.useSortable === undefined ? true : this.props.useSortable,
        useTabIndex: this.props.useTabIndex
      }, this.props.children);
    }
  }]);

  return CoolGridServerPaged;
}(React$1.PureComponent);

var PopupMenu = function PopupMenu(props) {
  var sc = {};
  var def = props.def || props.items || null;
  var primaryMenu = props.primaryMenu || null;

  if (def) {
    for (var i = 0; i < def.length; i++) {
      var key = "sc_" + i;
      sc[key] = false;
    }
  }

  if (primaryMenu) {
    for (var _i = 0; _i < primaryMenu.length; _i++) {
      var _key = "sc-" + _i;

      sc[_key] = false;
    }
  }

  var _useState = React$1.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = React$1.useState(sc),
      _useState4 = _slicedToArray(_useState3, 2),
      showConfirm = _useState4[0],
      setShowConfirm = _useState4[1];

  var onShowConfirm = function onShowConfirm(key) {
    console.debug("show confirm", key);
    setShowConfirm(_defineProperty({}, key, true));
  };

  var _onConfirm = function onConfirm(key, onOk) {
    setShowConfirm(_defineProperty({}, key, false));

    if (onOk) {
      onOk();
    } // if (!props.primaryMenu) {
    //     togglePopupMenu();
    // }

  };

  var onCancelConfirm = function onCancelConfirm(key) {
    setShowConfirm(_defineProperty({}, key, false)); // if (!props.primaryMenu) {
    //     togglePopupMenu();
    // }
  };

  React$1.useEffect(function () {
    var showCONFIRM = false;

    for (var _key2 in showConfirm) {
      if (Object.hasOwnProperty.call(showConfirm, _key2)) {
        var element = showConfirm[_key2];

        if (element) {
          showCONFIRM = true;
        }
      }
    }

    if (showCONFIRM) {
      document.removeEventListener('click', handleOutsideClick, false);
    } else {
      document.addEventListener('click', handleOutsideClick, false);
    }

    return function () {
      document.removeEventListener('click', handleOutsideClick, false);
    };
  }, [show, showConfirm]);

  var handleOutsideClick = function handleOutsideClick(e) {
    var id = props.id || "popupmenu";

    if (!show) {
      return;
    } // // ignore clicks on the component itself


    if (e.target.id.indexOf(id) > -1 || e.target.parentNode.id.indexOf(id) > -1) {
      return;
    }

    setShow(false);
  };

  var togglePopupMenu = function togglePopupMenu() {
    setShow(true);
  };

  console.debug("Rendering PopupMenu (showPopupMenu=" + show + ")");
  var popupIcon = props.popupIcon || "fa fa-ellipsis-v";
  var id = props.id || Utils.Utils.uuid("popupmenu"); // let def = props.def || props.items;
  // let primaryMenu = props.primaryMenu || null;

  if (!def || def.length === 0) {
    console.error("PopupMenu without menu item defiition (property def or items)");
    return null;
  } // valori possibili: down-right (default), up-right, down-left, up-left


  var pos = props.pos || "down-right";
  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: 'popup-menu-view ' + (props.className ? props.className : '')
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: primaryMenu ? "primary-menu" : ""
  }, primaryMenu && primaryMenu.map(function (item, index) {
    var css = "";

    if (item.className) {
      css += " " + item.className + " ";
    }

    var onClick;

    if (item.link) {
      onClick = function onClick() {
        if (item.onClick) item.onClick();
        document.location.href = item.link;
      };
    } else {
      onClick = function onClick() {
        if (item.onClick) item.onClick();
      };
    }

    var disabled = item.disabled;

    if (disabled) {
      onClick = null;
      css += " disabled";
    }

    var askConfirm = null;

    if (!disabled && item.askConfirm) {
      var onOk = onClick;

      var _key3 = "sc-" + index;

      askConfirm = /*#__PURE__*/React__default['default'].createElement(AskConfirm, {
        show: showConfirm[_key3],
        options: item.askConfirm,
        onConfirm: function onConfirm() {
          return _onConfirm(_key3, onOk);
        },
        onCancel: function onCancel() {
          return onCancelConfirm(_key3);
        }
      });

      onClick = function onClick() {
        return onShowConfirm(_key3);
      };
    }

    var primaryMenuItem = /*#__PURE__*/React__default['default'].createElement("div", {
      className: "primary-menu-item" + css,
      key: id + "-" + index
    }, /*#__PURE__*/React__default['default'].createElement("a", {
      id: id + "-" + index,
      title: item.title,
      onClick: onClick
    }, item.icon && /*#__PURE__*/React__default['default'].createElement("i", {
      className: item.icon
    }), item.textLabel || item.label));

    if (!askConfirm) {
      return primaryMenuItem;
    }

    return /*#__PURE__*/React__default['default'].createElement("div", {
      key: id + "-" + index
    }, askConfirm, primaryMenuItem);
  }, this)), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "popup-menu-btn " + (def ? "" : " disabled"),
    onClick: def ? function (e) {
      return togglePopupMenu();
    } : null
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: popupIcon
  }), props.label), show && def && /*#__PURE__*/React__default['default'].createElement("div", {
    className: primaryMenu ? "popup-primary-menu pos-" + pos : "popup-menu pos-" + pos
  }, def.map(function (row, index) {
    var css = "";

    if (row.className) {
      css += " " + row.className + " ";
    }

    var onClick;

    if (row.link) {
      onClick = function onClick() {
        if (row.onClick) row.onClick();
        togglePopupMenu();
        document.location.href = row.link;
      };
    } else {
      onClick = function onClick() {
        if (row.onClick) row.onClick();
        togglePopupMenu();
      };
    }

    var disabled = row.disabled;

    if (disabled) {
      onClick = null;
      css += " disabled";
    }

    var askConfirm = null;

    if (!disabled && row.askConfirm) {
      var onOk = onClick;

      var _key4 = "sc_" + index;

      askConfirm = /*#__PURE__*/React__default['default'].createElement(AskConfirm, {
        show: showConfirm[_key4],
        options: row.askConfirm,
        onConfirm: function onConfirm() {
          return _onConfirm(_key4, onOk);
        },
        onCancel: function onCancel() {
          return onCancelConfirm(_key4);
        }
      });

      onClick = function onClick() {
        return onShowConfirm(_key4);
      };
    }

    var menuItem = /*#__PURE__*/React__default['default'].createElement("div", {
      className: "popup-menu-item" + css,
      key: id + "-" + index
    }, /*#__PURE__*/React__default['default'].createElement("a", {
      id: id + "-" + index,
      title: row.title,
      onClick: onClick
    }, row.icon && /*#__PURE__*/React__default['default'].createElement("i", {
      className: row.icon
    }), row.textLabel || row.label));

    if (!askConfirm) {
      return menuItem;
    }

    return /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        display: "inline"
      },
      key: id + "-" + index
    }, askConfirm, menuItem);
  }, this))));
};

var MenuItem = function MenuItem(props) {
  if (props.visible === false) return null; //console.debug("RENDER MenuItem", props);

  var eventParam = props.eventParam;
  var href = props.href;
  var nomepagina = props.nomepagina;
  var icon = props.icon;
  var label = props.children;
  var imgIcon = props.imgIcon;
  var currPath = props.currentPath;
  var className = props.className ? " " + props.className : "";
  if (!icon) icon = "fa fa-square text-mute";

  if (!imgIcon) {
    if (icon.indexOf("fa fa-") === -1) icon = "fa fa-" + icon.trim();
  }

  var onClick = props.onClick;

  if (onClick || !href) {
    href = "javascript:;";
  }

  if (onClick && eventParam) {
    var _onc = onClick;

    onClick = function onClick(e) {
      _onc(e, eventParam);
    };
  }

  var h = nomepagina ? nomepagina : href;
  if (h === undefined) h = null;
  if (h !== null && h.startsWith("#")) h = h.substring(1);
  var active = currPath && currPath.indexOf(h) >= 0;
  return /*#__PURE__*/React__default['default'].createElement("li", {
    key: props.key,
    className: "menu-item" + className + (active ? ' active' : '')
  }, props.compact ? /*#__PURE__*/React__default['default'].createElement("a", {
    className: 'list-group-item',
    "data-toggle": "offcanvas",
    onClick: onClick //eventParam = {eventParam}
    ,
    href: href,
    title: label
  }, /*#__PURE__*/React__default['default'].createElement("span", null), " ", /*#__PURE__*/React__default['default'].createElement("i", {
    className: "menu-icon " + icon
  }), " ") : /*#__PURE__*/React__default['default'].createElement("a", {
    className: 'list-group-item',
    "data-toggle": "offcanvas",
    onClick: onClick //eventParam = {eventParam}
    ,
    href: href
  }, /*#__PURE__*/React__default['default'].createElement("span", null), " ", /*#__PURE__*/React__default['default'].createElement("i", {
    className: "menu-icon " + icon
  }), ' ', label));
};

var MainMenu = function MainMenu(props) {
  var _useState = React$1.useState({
    viewSearchResults: false
  }),
      _useState2 = _slicedToArray(_useState, 2);
      _useState2[0];
      _useState2[1]; // constructor(props) {
  //     super(props);
  //     state = {
  //         viewSearchResults: false
  //     };
  // }


  var items = []; // TODO RECUPERARE tramite tag/componenti

  var headers = [];
  var footers = [];
  if (props.header) headers.push(props.header);
  if (props.footer) footers.push(props.footer);
  var onHead = true;
  React__default['default'].Children.forEach(props.children, function (item, index) {
    // TODO if (item === MenuItem)
    if (!item) return;

    if (item.type && item.type === MenuItem) {
      onHead = false;
      var it = /*#__PURE__*/React__default['default'].cloneElement(item, {
        currentPath: props.currentPath,
        key: 'mainmenu_item_' + index,
        compact: props.compact
      });
      items.push(it);
    } else {
      if (onHead) {
        headers.push( /*#__PURE__*/React__default['default'].cloneElement(item, {
          currentPath: props.currentPath,
          key: 'mainmenu_header_' + index,
          compact: props.compact
        }));
      } else {
        footer.push( /*#__PURE__*/React__default['default'].cloneElement(item, {
          currentPath: props.currentPath,
          key: 'mainmenu_footer_' + index,
          compact: props.compact
        }));
      }
    }
  });
  var header = null;
  var footer = null;

  if (headers.length > 0) {
    header = headers;
  }

  if (footers.length > 0) {
    footer = footers;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: (props.compact ? "main-menu menu-compact" : "main-menu") + (props.noSide ? "" : " side") + (props.className ? " " + props.className : "")
  }, header && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "menu-header"
  }, header), /*#__PURE__*/React__default['default'].createElement("ul", {
    role: "navigation",
    className: "menu-items"
  }, items.map(function (item, index) {
    return item;
  })), footer && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "menu-footer"
  }, footer));
};

var ExcelExportButton = function ExcelExportButton() {
  // constructor(props) {
  //     super(props);
  //     exportExcel = exportExcel.bind(this);
  // }
  var exportExcel = function exportExcel() {
    var baseUrl = props.baseUrl,
        codList = props.codList,
        bean = props.bean,
        conversationId = props.conversationId,
        jsessionId = props.jsessionId;

    if (!baseUrl) {
      var location = document.location;
      var full = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
      baseUrl = full + "/"; // if (!baseUrl.endsWith("/"))
      //     baseUrl += "/";

      baseUrl += "arm_am/seam/resource/rest/";
    } //
    // http://localhost:8080/arm_am/seam/resource/rest/
    // export/excel;jsessionid=<session_id>?bean=<nome_bean>&codList=<codice_lista>&conversationId=<conversation_id>
    //


    var url = baseUrl + "export/excel;jsessionid=" + jsessionId + "?bean=" + bean;
    if (codList) url += "&codList=" + codList;
    url += "&conversationId=" + conversationId;
    window.open(url, "_download_excel");
  };

  var props = ___default['default'].omit(props, "bs", "icon", "label", "onClick", "baseUrl", "codList", "bean", "conversationId", "jsessionId", className);

  var BTN = aButton;
  var label = props.label,
      icon = props.icon,
      bs = props.bs,
      className = props.className;
  if (!bs) bs = "secondary";
  props.bs = bs;
  if (className) className += " btn-export-excel";else className = "btn-export-excel";
  props.className = className;
  if (!icon) icon = "fa fa-file-excel-o";
  props.icon = icon;
  if (!label) label = Utils.i18n("V2.AGUI.EXPORT_EXCEL", "Esporta in Excel");
  return /*#__PURE__*/React__default['default'].createElement(BTN, _extends({}, props, {
    onClick: exportExcel
  }), label);
};

var aCardTopBar = function aCardTopBar(props) {
  // let props = _.omit(props, "className", "children");
  var className = props.className || "";
  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: "element-list bar right " + className
  }, props), props.children);
};

var aCardDetail = function aCardDetail(props) {
  var _useState = React$1.useState({
    open: props.defaultOpen || false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1]; // constructor(props) {
  //     super(props);
  //     state = {
  //         open: props.defaultOpen || false
  //     };
  //     toggle = toggle.bind(this);
  // }


  var toggle = function toggle() {
    setState({
      open: !state.open
    });
  }; // const toggle =()=> {
  //     setState(
  //         Object.assign(state, 
  //             { open: !state.open }));
  // }


  var open = state.open;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "acard-detail"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    onClick: toggle,
    className: "acard-detail-title"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "arrow fa fa-caret-down" + (open ? " open" : "")
  }), props.title || "Dettagli", " ..."), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "acard-detail-body " + (open ? "open" : "close")
  }, props.children));
};

var SidebarItem = function SidebarItem(props) {
  if (props.visible === false) return null; //console.debug("RENDER SidebarItem", props);

  var href = props.href;
  var icon = props.icon;
  var label = props.children;
  var currPath = props.currentPath;
  var className = props.className ? " " + props.className : "";
  var dataToggle = null;
  var dataTarget = null;

  if (props.deviceSize === "EXTRA_SMALL") {
    dataToggle = "collapse";
    dataTarget = "#bd-docs-nav";
  }

  if (!icon) icon = "fa fa-square text-mute";
  if (icon.indexOf("fa fa-") === -1) icon = "fa fa-" + icon.trim();
  var onClick = props.onClick; // if (onClick || !href) {
  //     href = "javascript:;";
  // }

  var h = href;
  if (h === undefined) h = null;
  if (h !== null && h.startsWith("#")) h = h.substring(1);
  var active = currPath && currPath.indexOf(h) >= 0;
  return /*#__PURE__*/React__default['default'].createElement("li", {
    key: props.key,
    className: "menu-item" + className + (active ? ' active' : '')
  }, props.compact ? /*#__PURE__*/React__default['default'].createElement("a", {
    "data-toggle": dataToggle,
    "data-target": dataTarget,
    className: 'list-group-item',
    onClick: onClick,
    href: href,
    title: label
  }, /*#__PURE__*/React__default['default'].createElement("span", null), " ", /*#__PURE__*/React__default['default'].createElement("i", {
    className: "menu-icon " + icon
  })) : /*#__PURE__*/React__default['default'].createElement("a", {
    "data-toggle": dataToggle,
    "data-target": dataTarget,
    className: 'list-group-item',
    onClick: onClick,
    href: href
  }, /*#__PURE__*/React__default['default'].createElement("span", null), " ", /*#__PURE__*/React__default['default'].createElement("i", {
    className: "menu-icon " + icon
  }), /*#__PURE__*/React__default['default'].createElement("b", null, ' ', label)));
};

var Sidebar = function Sidebar(props) {
  var _useState = React$1.useState({
    viewSearchResults: false
  }),
      _useState2 = _slicedToArray(_useState, 2);
      _useState2[0];
      _useState2[1]; // constructor(props) {
  //     super(props);
  //     state = {
  //         viewSearchResults: false
  //     };
  // }


  var items = []; // TODO RECUPERARE tramite tag/componenti
  React__default['default'].Children.forEach(props.children, function (item, index) {
    // TODO if (item === SidebarItem)
    if (!item) return;

    if (item.type && item.type === SidebarItem) {
      var it = /*#__PURE__*/React__default['default'].cloneElement(item, {
        currentPath: props.currentPath,
        key: 'sidebar_item_' + index
      });
      items.push(it);
    }
  }); // console.debug("RENDER Sidebar", items, header, footer);

  return /*#__PURE__*/React__default['default'].createElement("nav", {
    className: "collapse bd-links",
    id: "bd-docs-nav"
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "nav bd-sidenav"
  }, items.map(function (item, index) {
    return item;
  })));
};

var CoolDateTimeInput = function CoolDateTimeInput(props) {

  var onChangeOra = function onChangeOra(val) {
    if (props.value) {
      var nuovaData = moment__default['default'](props.value);
      nuovaData.hours(val);
      props.onChange(nuovaData.toDate());
    }
  };

  var onChangeMinuti = function onChangeMinuti(val) {
    if (props.value) {
      var nuovaData = moment__default['default'](props.value);
      nuovaData.minutes(val);
      props.onChange(nuovaData.toDate());
    }
  }; // per generare ore(0-23) e minuti(0-59) per i select


  var generateOptions = function generateOptions(optionsNo) {
    var options = [];

    for (var i = 0; i < optionsNo; i++) {
      var option = new Object();
      option.value = i;

      if (i < 10) {
        option.label = "0" + i;
      } else {
        option.label = i.toString();
      }

      options[i] = option;
    }

    return options;
  };

  var label = props.label,
      value = props.value,
      onChange = props.onChange,
      id = props.id,
      validation = props.validation;
  var partial = "";
  var ore = generateOptions(24);
  var minuti = generateOptions(60);
  var selectValidation = new Map();

  if (validation.has(id)) {
    //selectValidation = validation;
    selectValidation.set(id + "_ore", " ");
    selectValidation.set(id + "_minuti", " ");
    partial = "";
  }

  console.log('[CoolDateTimeInput.JSX]: render');
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("form", {
    className: "form-inline"
  }, /*#__PURE__*/React$1.createElement(CoolDateInput, {
    id: id,
    label: label,
    value: value,
    onChange: onChange,
    wrapClassName: "mr-2",
    validation: validation
  }), /*#__PURE__*/React$1.createElement(CoolSelect, {
    label: "Ore",
    value: moment__default['default'](value).hours(),
    items: ore,
    id: id + "_ore",
    onChange: onChangeOra,
    wrapClassName: "mr-2 cool-select-sm",
    validation: selectValidation
  }), /*#__PURE__*/React$1.createElement(CoolSelect, {
    label: "Minuti",
    value: moment__default['default'](value).minutes(),
    items: minuti,
    id: id + "_minuti",
    onChange: onChangeMinuti,
    wrapClassName: "mr-2 cool-select-sm",
    validation: selectValidation
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "err-msg"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "col md-12"
  }, partial, " "))));
};

var anchor = function anchor(props) {
  return /*#__PURE__*/React__default['default'].createElement("span", {
    className: props.className,
    id: props.scrollId
  });
};

var Contents = function Contents(props) {
  // let refs = [{}];
  // refs[0].selected = true;
  var _useState = React$1.useState({
    refs: []
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1]; // constructor(props) {
  //     super(props);
  //     checkChildren = checkChildren.bind(this);
  //     scrollTo = scrollTo.bind(this);
  //     animateScroll = animateScroll.bind(this);
  //     checkPage = checkPage.bind(this);
  //     let refs = [];
  //     checkChildren(props.children, refs);
  //     refs[0].selected = true;
  //     state = {
  //         refs: refs,
  //     }
  // }
  // componentDidMount() {
  //     window.addEventListener('scroll', checkPage);
  // }
  // componentWillUnmount() {
  //     window.removeEventListener('scroll', checkPage);
  // }


  var checkChildren = function checkChildren(child, refs) {
    if (!child) {
      return;
    }

    var props = child.props;
    var newRef = {
      scrollId: '',
      scrollName: ''
    };

    if (!(child instanceof Array)) {
      newRef = {
        scrollId: props && props['scrollId'] || '',
        scrollName: props && props['scrollName'] || 'No scrollName defined'
      };
    } else if (child instanceof Array) {
      for (var i = 0; i < child.length; i++) {
        checkChildren(child[i], refs);
      }
    }

    if (newRef && newRef.scrollId !== '') {
      refs.push(newRef);
    }

    if (props) {
      checkChildren(props.children, refs);
    } else {
      return;
    }
  };

  var checkPage = function checkPage() {
    var refs = state.refs;
    var newState = state;
    var found = false;

    for (var i = 0; i < refs.length; i++) {
      var ref = refs[i];
      var refYOffset = getElementYOffset(ref.scrollId);

      if (refYOffset - window.pageYOffset > 0 && !found) {
        newState = update__default$1['default'](newState, {
          refs: _defineProperty({}, i, {
            selected: {
              $set: true
            }
          })
        });
        found = true;
      } else {
        newState = update__default$1['default'](newState, {
          refs: _defineProperty({}, i, {
            selected: {
              $set: false
            }
          })
        });
      }
    }

    setState(newState);
  };

  var getElementYOffset = function getElementYOffset(scrollId) {
    return document.getElementById(scrollId).offsetTop;
  };

  var easeInOutQuad = function easeInOutQuad(current_time, start, change, duration) {
    current_time /= duration / 2;
    if (current_time < 1) return change / 2 * current_time * current_time + start;
    current_time--;
    return -change / 2 * (current_time * (current_time - 2) - 1) + start;
  };

  var animateScroll = function animateScroll(start, change, currentTime, increment, duration) {
    currentTime += increment;
    var val = easeInOutQuad(currentTime, start, change, duration);
    window.scrollTo(0, val);

    if (currentTime < duration) {
      setTimeout(animateScroll, increment, start, change, currentTime, increment, duration);
    } else {
      window.addEventListener('scroll', checkPage);
    }
  };

  var scrollTo = function scrollTo(start, to) {
    var change = to - start;
    var currentTime = 0;
    var increment = 10;
    var duration = props.scrollDuration || 1000;
    animateScroll(start, change, currentTime, increment, duration);
  };

  var onScrollTo = function onScrollTo(ref) {
    window.removeEventListener('scroll', checkPage);
    var elementYOffset = getElementYOffset(ref.scrollId);
    var refs = state.refs;
    var newState = state;

    for (var i = 0; i < refs.length; i++) {
      if (refs[i].scrollId === ref.scrollId) {
        newState = update__default$1['default'](newState, {
          refs: _defineProperty({}, i, {
            selected: {
              $set: true
            }
          })
        });
      } else {
        newState = update__default$1['default'](newState, {
          refs: _defineProperty({}, i, {
            selected: {
              $set: false
            }
          })
        });
      }
    }

    scrollTo(window.pageYOffset, elementYOffset);
    setState(newState);
  }; // useEffect(function () {
  //     let elementYOffset = getElementYOffset(ref.scrollId);
  //     scrollTo(window.pageYOffset, elementYOffset);
  // }, [state.refs]);


  React$1.useEffect(function () {
    var refs = state.refs;
    checkChildren(props.children, refs);
    window.addEventListener('scroll', checkPage);
    var newState = update__default$1['default'](state, {
      refs: {
        $set: refs
      }
    });
    setState(newState); // returned function will be called on component unmount 

    return function () {
      window.removeEventListener('scroll', checkPage);
    };
  }, []);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "contentsMain"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "contentsChildren"
  }, props.children), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "contentsBar",
    id: props.id
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "contentsLinks",
    style: {
      position: 'fixed'
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", null, state.refs.map(function (ref) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      key: 'content' + ref.scrollId,
      className: ref.selected ? 'contentSelected' : '',
      onClick: function onClick() {
        return onScrollTo(ref);
      }
    }, /*#__PURE__*/React__default['default'].createElement("span", null), /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("a", {
      id: ref.scrollId
    }, ref.scrollName)));
  })))));
};

Contents.Anchor = anchor;

/**
 * Inserisce ogni figlio in un div sotto il componente LineBar.
 * 
 * @param {*} props contenitore delle successive properties
 * @param {boolean} right se true, posiziona gli elementi sulla destra, false, li posiziona alla sinistra
 * @param {string} margin valore css dell'attributo marginRight (caso right = false) o marginLeft (caso right = true)
 * @param {Array} children React children
 */

var LineBarGroup = function LineBarGroup(props) {
  var _useState = React$1.useState({
    id: Utils.Utils.uuid('line-item-')
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0];
      _useState2[1]; // constructor(props) {
  //     super(props);
  //     this.consoleLog = (text) => console.log('[LineBar]: ' + text);
  //     this.state = { id: Utils.uuid('line-item-') };
  // }
  // consoleLog("render");


  var vertical = props.vertical,
      right = props.right,
      margin = props.margin;
  var children = props.children;
  var id = state.id;
  var childrenLength = React__default['default'].Children.count(children);

  if (childrenLength === 1) {
    children = [children];
  }

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, children.map(function (child, index) {
    if (!child) return null;
    if (child.props && child.props.visible !== undefined && !child.props.visible) return null;
    var style = null;
    var marginAttr = vertical ? "marginBottom" : "marginRight";

    if (!right) {
      /** Rendering elements WITHOUT 'right' prop (starts from left side) **/
      style = _defineProperty({}, marginAttr, margin || '1rem'); //common style of elements on left side
      //the last element will not have margin

      if (index === childrenLength - 1) style = {};
      return /*#__PURE__*/React__default['default'].createElement("div", {
        key: "".concat(id, "-").concat(index),
        className: "line-item-left-".concat(index),
        style: style
      }, child);
    }

    marginAttr = vertical ? "marginTop" : "marginLeft";
    /** Rendering elements with 'right' prop **/

    style = _defineProperty({}, marginAttr, margin || '1rem'); //common style of children
    //the first element needs to have marginLeft set to auto to align all futher contents on right

    if (index === 0) style[marginAttr] = 'auto';
    return /*#__PURE__*/React__default['default'].createElement("div", {
      key: "".concat(id, "-").concat(index),
      className: "line-item-right-".concat(index),
      style: style
    }, child);
  }));
};
/**
 * Crea una flex box che dispone gli elementi in linea o in colonna, in base ai parametri passati.
 * 
 * @param {*} props oggetto contenitore dei sottostanti parametri
 * @param {boolean} visible se true o undefined, visualizza il componente, se false, non viene visualizzato
 * @param {string} height altezza del contenitore (se vertical = true default: "100vh")
 * @param {string} width larghezza del contenitore (se vertical = false default: "100%")
 * @param {boolean} vertical se true, dispone la barra in colonna
 * @param {boolean} noWrap se true, gli elementi flex non vanno a capo, se false, una volta raggiunta la larghezza massima, gli elementi si dispongono nella riga successiva
 * @param {string} id id del contenitore
 * @param {string} className selettore del contenitore
 * @param {Array} children react children
 */


var LineBar = function LineBar(props) {
  // constructor(props) {
  //     super(props);
  //     this.consoleLog = (text) => console.log('[LineBar]: ' + text);
  //     this.state = { id: this.props.id || Utils.uuid('line-bar-') };
  // }
  var _useState3 = React$1.useState({
    id: props.id || Utils.Utils.uuid('line-bar-')
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0];
      _useState4[1]; // consoleLog("render");


  var visible = props.visible,
      height = props.height,
      width = props.width,
      alignItems = props.alignItems,
      vertical = props.vertical,
      noWrap = props.noWrap,
      className = props.className,
      children = props.children;
  var id = state.id;
  if (visible !== undefined && !visible) return null;
  var barStyle = {
    display: 'flex',
    alignItems: alignItems || 'flex-end',
    height: height || '100vh',
    width: width || '100%',
    flexWrap: noWrap ? 'nowrap' : 'wrap'
  };

  if (vertical) {
    //if vertical all the line should be show like a column
    barStyle.flexDirection = 'column';
    if (!width) delete barStyle.width; //the default value should be remove only if width is not setted
  } else {
    //display as row
    barStyle.flexDirection = 'row';
    if (!height) delete barStyle.height; //the default value should be remove only if height is not setted
  }

  var ochildren = children;

  if (React__default['default'].Children.count(children) === 2) {
    //if the children are 2 (the component have LineBarGroup and LineBarGroup right={true})
    ochildren = _toConsumableArray(children);
    ochildren.sort(function (a, b) {
      return a.props && b.props && !a.props.right ? -1 : 1;
    }); //if the elem of child haven't the prop right, it will positioned as a first element
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    style: barStyle,
    className: className ? 'line-bar ' + className : 'line-bar'
  }, ochildren);
};

Utils.Utils.uuid('cellify-');
/**
 * Passando i numeri, si assegnano in corrispondenza della stringa
 * 
 * @param {number} lg - schermi grandi (desktop)
 * @param {number} md - schermi medi (tablet)
 * @param {number} sm - schermi piccoli (smartphone)
 * 
 * @returns stringa es 'col-lg-2 col-md-2 col-sm-6 col-6';
 */

var colWidthResponsive = function colWidthResponsive(lg, md, sm) {
  return " col-lg-".concat(lg, " col-md-").concat(md, " col-sm-").concat(sm, " col-").concat(sm, " ");
};
/**
 * Crea una stringa contenete il class di bootstrap
 * per i 3 tipi di grandezze delle schermo, partendo da quello
 * più grande (pattern di default se viene passato colWidth alla prop dell'elemento)
 * @param {number} bootstrapColLG dimensione più grande
 * 
 * @returns stringa es input '2': 'col-lg-2 col-md-2 col-sm-6 col-6';
 */


function _setBootstrapClassCol(bootstrapColLG) {
  if (typeof bootstrapColLG === 'string') bootstrapColLG = parseInt(bootstrapColLG);

  switch (bootstrapColLG) {
    case 12:
      return ' col-12 ';

    case 11:
      return colWidthResponsive(11, 12, 12);

    case 10:
      return colWidthResponsive(10, 10, 12);

    case 9:
      return colWidthResponsive(9, 8, 12);
    //se md diminuisco la grandezza perchè aumento quella di quelli più piccoli

    case 8:
      return colWidthResponsive(8, 8, 12);

    case 7:
      return colWidthResponsive(7, 6, 12);

    case 6:
      return colWidthResponsive(6, 6, 12);

    case 5:
      return colWidthResponsive(5, 4, 12);

    case 4:
      return colWidthResponsive(4, 4, 12);

    case 3:
      return colWidthResponsive(3, 4, 6);

    case 2:
      return colWidthResponsive(2, 2, 6);

    case 1:
      return colWidthResponsive(1, 2, 6);

    default:
      return '';
  }
}
/**
 * _NEEDS TO REFACTOR: Staccare il componente dalla logica Bootstrap_
 * 
 * Inserisce i figli (react children) all'interno di un div con className='col-lg-X col-md-X col-sm-X col-X',
 * dove le X sono il risultato di colWidthResponsive ottenuto partendo da un numero
 * appartenente alla prop colWidth (se non lo possiede, di default viene applicato 12) contenuta nei vari React.Children.
 * (vedi metodo _setBootstrapClassCol)
 * 
 * Questi div html vengono inseriti dentro un div con className='row' (appartenente al framework Bootstrap).
 * E' possibile passare ai children la prop cellifyWidth, che, se presente, sovrascrive il className del div cella.
 * 
 * @param {*} props oggetto contenitore dei sottostanti parametri
 * @param {boolean} noMargin se true, rimuove il marginBottom che spazia le righe, se no viene applicato un mb-3
 * @param {string} className selettore del contenitore
 * @param {Array} children react children
 */


var Cellify = function Cellify(props) {
  var consoleLog = function consoleLog(text) {
    return console.log('[Cellify]: ' + text);
  };

  var _useState = React$1.useState({
    id: props.id || Utils.Utils.uuid('cellify-')
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0];
      _useState2[1]; // constructor(props) {
  //     super(props);
  //     consoleLog = (text) => console.log('[Cellify]: ' + text);
  //     state = { id: props.id || Utils.uuid('cellify-') };
  // }


  var _renderChildren = function _renderChildren(children) {
    var noMargin = props.noMargin;
    var id = state.id;
    return children.map(function (elem, index) {
      if (elem === null || elem.props && elem.props.visible === false || elem.length === 0) {
        //controllo null o visible dell'elemento
        return null;
      }

      if (elem.length > 0) {
        return _renderChildren(elem);
      }

      var bootstrapCol = _setBootstrapClassCol(12); //se non passassi alcun colWidth, lo setto al massimo


      var childClassName = elem.props.className || '';

      if (elem.props && elem.props.cellifyWidth) {
        bootstrapCol = elem.props.cellifyWidth; //applico il className definito nella prop

        var _elem$props = elem.props;
            _elem$props.cellifyWidth;
            _elem$props.colWidth;
            _elem$props.className;
            var childProps = _objectWithoutProperties(_elem$props, ["cellifyWidth", "colWidth", "className"]); //rimuovo la prop per evitare errori


        elem = /*#__PURE__*/React__default['default'].createElement(elem.type, childProps);
      } else if (elem.props && elem.props.colWidth) {
        bootstrapCol = _setBootstrapClassCol(elem.props.colWidth); //applico il colSize predefinito

        var _elem$props2 = elem.props;
            _elem$props2.colWidth;
            _elem$props2.cellifyWidth;
            _elem$props2.className;
            var _childProps = _objectWithoutProperties(_elem$props2, ["colWidth", "cellifyWidth", "className"]); //rimuovo la prop per evitare errori


        elem = /*#__PURE__*/React__default['default'].createElement(elem.type, _childProps);
      }

      var childrenLength = children.length || React__default['default'].Children.count(children);
      var margin = !noMargin && childrenLength - 1 !== index ? ' mb-3 ' : ''; //margin-bottom Bootstrap

      return /*#__PURE__*/React__default['default'].createElement("div", {
        id: id + '-child-' + index,
        key: id + '-child-' + index,
        className: margin + bootstrapCol + childClassName
      }, elem);
    });
  };

  consoleLog("render");
  var className = props.className,
      children = props.children;
  var id = state.id;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    className: className ? 'row cellify ' + className : 'row cellify'
  }, _renderChildren(children));
};

Cellify.colWidthResponsive = colWidthResponsive;

/**
 * @augments {Component<{show: boolean, width:string, marginRight: string, marginLeft:string, marginBottom: string, marginTop: string}, State>}
 */

var ConfirmModalOkCancelV4 = /*#__PURE__*/function (_Component) {
  _inherits(ConfirmModalOkCancelV4, _Component);

  var _super = _createSuper(ConfirmModalOkCancelV4);

  function ConfirmModalOkCancelV4(props) {
    _classCallCheck(this, ConfirmModalOkCancelV4);

    return _super.call(this, props);
  }

  _createClass(ConfirmModalOkCancelV4, [{
    key: "render",
    value: function render() {
      if (!this.props.show) return null;
      return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal d-block",
        id: this.props.id
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-dialog " + (this.props.className ? " " + this.props.className : "")
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-content"
      }, this.props.children))), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-backdrop show"
      }));
    }
  }]);

  return ConfirmModalOkCancelV4;
}(React$1.Component);
/**
 * @augments {Component<{onClose: function}, State>}
 */


var Header$1 = /*#__PURE__*/function (_Component2) {
  _inherits(Header, _Component2);

  var _super2 = _createSuper(Header);

  function Header() {
    _classCallCheck(this, Header);

    return _super2.apply(this, arguments);
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-header  bg-light" + (this.props.className ? this.props.className : "")
      }, this.props.children, /*#__PURE__*/React__default['default'].createElement("p", {
        className: "modal-title font-weight-bold" + (this.props.classNameTitle ? " " + this.props.classNameTitle : "")
      }, this.props.testoTitle !== undefined && this.props.testoTitle !== null ? this.props.testoTitle : "Conferma"), /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        onClick: this.props.onClose
      }, /*#__PURE__*/React__default['default'].createElement("span", null, "\xD7")));
    }
  }]);

  return Header;
}(React$1.Component);
/**
 * @augments {Component<{maxHeight: string}, State>}
 */


var Body$1 = /*#__PURE__*/function (_Component3) {
  _inherits(Body, _Component3);

  var _super3 = _createSuper(Body);

  function Body() {
    _classCallCheck(this, Body);

    return _super3.apply(this, arguments);
  }

  _createClass(Body, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-body" + (this.props.className ? " " + this.props.className : "")
      }, this.props.children, /*#__PURE__*/React__default['default'].createElement("p", {
        className: "modal-title font-weight-normal" + (this.props.classNameTesto ? " " + this.props.classNameTesto : "")
      }, this.props.testoBody !== undefined && this.props.testoBody !== null ? this.props.testoBody : "Confermi di voler procedere?"));
    }
  }]);

  return Body;
}(React$1.Component);
/**
 * @augments {Component<{}, State>}
 */


var Footer$1 = /*#__PURE__*/function (_Component4) {
  _inherits(Footer, _Component4);

  var _super4 = _createSuper(Footer);

  function Footer() {
    _classCallCheck(this, Footer);

    return _super4.apply(this, arguments);
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-footer bg-light d-flex justify-content-between" + (this.props.className ? " " + this.props.className : "")
      }, /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        id: this.props.IdConfirm,
        className: " " + (this.props.classNameTestoButtonConfirm ? " " + this.props.classNameTestoButtonConfirm : "btn btn-primary"),
        onClick: this.props.confirmOnClick
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        className: this.props.classNameIconConfirm ? this.props.classNameIconConfirm : "fas fa-save "
      }), " ", this.props.testoButtonConfirm !== undefined ? " " + this.props.testoButtonConfirm : " Conferma"), this.props.children, /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        id: this.props.IdCancel,
        className: " " + (this.props.classNameTestoButtonCancel ? this.props.classNameTestoButtonConfirm : "btn btn-secondary"),
        "data-dismiss": "modal",
        onClick: this.props.onClose
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        className: this.props.classNameIconCancel ? this.props.classNameIconCancel : "far fa-times-circle "
      }), " ", this.props.testoButtonCancel !== undefined ? " " + this.props.testoButtonCancel : " Annulla"));
    }
  }]);

  return Footer;
}(React$1.Component);

ConfirmModalOkCancelV4.Header = Header$1;
ConfirmModalOkCancelV4.Body = Body$1;
ConfirmModalOkCancelV4.Footer = Footer$1;

/**
 * @augments {Component<{show: boolean, width:string, marginRight: string, marginLeft:string, marginBottom: string, marginTop: string}, State>}
 */

var Modalv4 = /*#__PURE__*/function (_Component) {
  _inherits(Modalv4, _Component);

  var _super = _createSuper(Modalv4);

  function Modalv4(props) {
    _classCallCheck(this, Modalv4);

    return _super.call(this, props);
  }

  _createClass(Modalv4, [{
    key: "render",
    value: function render() {
      if (!this.props.show) return null;
      return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal d-block"
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-dialog " + (this.props.className ? " " + this.props.className : "")
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-content"
      }, this.props.children))), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-backdrop show"
      }));
    }
  }]);

  return Modalv4;
}(React$1.Component);
/**
 * @augments {Component<{onClose: function}, State>}
 */


var Header$2 = /*#__PURE__*/function (_Component2) {
  _inherits(Header, _Component2);

  var _super2 = _createSuper(Header);

  function Header() {
    _classCallCheck(this, Header);

    return _super2.apply(this, arguments);
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-header " + (this.props.className ? this.props.className : "")
      }, this.props.children, /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        className: "close",
        id: this.props.id,
        onClick: this.props.onClose
      }, /*#__PURE__*/React__default['default'].createElement("span", null, "\xD7")));
    }
  }]);

  return Header;
}(React$1.Component);
/**
 * @augments {Component<{maxHeight: string}, State>}
 */


var Body$2 = /*#__PURE__*/function (_Component3) {
  _inherits(Body, _Component3);

  var _super3 = _createSuper(Body);

  function Body() {
    _classCallCheck(this, Body);

    return _super3.apply(this, arguments);
  }

  _createClass(Body, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-body" + (this.props.className ? " " + this.props.className : "")
      }, this.props.children);
    }
  }]);

  return Body;
}(React$1.Component);
/**
 * @augments {Component<{}, State>}
 */


var Footer$2 = /*#__PURE__*/function (_Component4) {
  _inherits(Footer, _Component4);

  var _super4 = _createSuper(Footer);

  function Footer() {
    _classCallCheck(this, Footer);

    return _super4.apply(this, arguments);
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-footer" + (this.props.className ? " " + this.props.className : "")
      }, this.props.children);
    }
  }]);

  return Footer;
}(React$1.Component);

Modalv4.Header = Header$2;
Modalv4.Body = Body$2;
Modalv4.Footer = Footer$2;

var ATextInputV4 = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ATextInputV4, _React$PureComponent);

  var _super = _createSuper(ATextInputV4);

  // mixins: [PureRenderMixin],
  function ATextInputV4(props) {
    var _this;

    _classCallCheck(this, ATextInputV4);

    _this = _super.call(this, props);
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.state = {
      maxlength: 100,
      errorMessage: null
    };
    _this.componentName = "[aTextInputV4.jsx] ";
    return _this;
  }

  _createClass(ATextInputV4, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextprops) {
      if (nextprops.maxlength !== undefined && nextprops.maxlength !== null) {
        this.setState({
          maxlength: nextprops.maxlength
        });
      }
    }
  }, {
    key: "capitalizeFirstLetter",
    value: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }, {
    key: "onChange",
    value: function onChange(event) {
      if (event.target.value !== null && '' + this.state.maxlength === '' + event.target.value.length) {
        this.setState({
          errorMessage: 'Lunghezza massima raggiunta: ' + this.state.maxlength + ' caratteri'
        });
      } else if (event.target.value !== null && '' + this.props.minValueAllowed !== null && '' + parseInt(event.target.value) < parseInt(this.props.minValueAllowed)) {
        this.setState({
          errorMessage: 'Valore minore dal minimum permesso: ' + this.props.minValueAllowed
        });
      } else if (event.target.value !== null && event.target.value !== '' && this.props.myPattern !== null) {
        var checkPattern = new RegExp(this.props.myPattern);

        if (!checkPattern.test(event.target.value)) {
          this.setState({
            errorMessage: 'Formato diverso dal formato richesto'
          });
        } else {
          this.setState({
            errorMessage: null
          });
        }
      } else {
        this.setState({
          errorMessage: null
        });
      }

      if (this.props.onChange !== undefined && this.props.onChange !== null) {
        console.log(this.componentName + 'onChange');

        if (this.props.eventParam) {
          console.log(this.componentName + 'eventParam');
          this.props.onChange(event, this.props.eventParam);
        } else {
          this.props.onChange(event);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      console.log(this.componentName + 'render: ' + this.props.id);
      var myPattern = "";

      if (this.props.myPattern) {
        myPattern = this.props.myPattern;
      }

      var maxlength = 100;

      if (this.props.maxlength) {
        maxlength = this.props.maxlength * 1;
      }

      var formClass = 'form-group ';

      if (this.props.componentClass === null || this.props.componentClass === undefined) ; else {
        formClass = formClass + this.props.componentClass;
      } // console.log("this.props.componentClass: " + this.props.componentClass);
      // console.log("formClass: " + formClass);


      var name = null;

      if (this.props.name === undefined) {
        name = this.props.id;
      } else {
        name = this.props.name;
      }

      var isDisabled;

      if (this.props.disabled === undefined || this.props.disabled === null || this.props.disabled !== true) {
        isDisabled = false;
      } else {
        isDisabled = true;
      }

      var label = null;

      if (this.props.label === undefined) {
        label = this.capitalizeFirstLetter(name);
      } else {
        label = this.props.label;
      } //console.log("required: " + this.props.required);


      if (this.props.required === true && isDisabled === false) {
        //  console.log("is required: ");
        //console.log(label.indexOf('*'));
        if (label.indexOf('*') === -1) {
          label = label + '*';
        }
      }

      var messaggioDiErrore = null;
      var spanDiErrore = null;
      var className = "";

      if (this.props.validation !== undefined) {
        //for (var [key, value] of this.props.validation) {
        //  console.log(key + ' = ' + value);
        //}
        //cerco un eventuale messaggio di errore per il mio componente
        var errore = this.props.validation.get(this.props.id); //console.log('Errore: ' + errore);

        if (errore !== undefined) {
          formClass += ' has-error has-feedback'; // spanClass = 'glyphicon glyphicon-remove form-control-feedback';

          className = "is-invalid";
          messaggioDiErrore = /*#__PURE__*/React$1.createElement("small", {
            className: "invalid-feedback d-block"
          }, /*#__PURE__*/React$1.createElement("i", {
            "aria-hidden": "true",
            className: "fa fa-times"
          }), " ", ' ', errore);

          spanDiErrore = /*#__PURE__*/React$1.createElement("span", {
            className: "glyphicon glyphicon-remove form-control-feedback",
            "aria-hidden": "true"
          });
        }
      }

      if (this.state.errorMessage !== null) {
        formClass += ' has-error has-feedback'; // spanClass = 'glyphicon glyphicon-remove form-control-feedback';

        messaggioDiErrore = /*#__PURE__*/React$1.createElement("span", {
          className: "text-danger small"
        }, this.state.errorMessage);
        spanDiErrore = /*#__PURE__*/React$1.createElement("span", {
          className: "glyphicon glyphicon-remove form-control-feedback",
          "aria-hidden": "true"
        });
      }

      var myValue;

      if (this.props.value === undefined || this.props.value === null) {
        myValue = '';
      } else {
        myValue = this.props.value;
      }

      var myType;

      if (this.props.type === undefined || this.props.type === null) {
        myType = 'text';
      } else {
        myType = this.props.type;
      } //let myLabelClass = "control-label ";


      var myLabelClass = "";

      if (this.props.labelClass !== undefined && this.props.labelClass !== null) {
        myLabelClass = this.props.labelClass;
      }

      var confProps = {};

      if (myPattern) {
        confProps.myPattern = myPattern;
      } //console.log('\tthis.props.value: ' + this.props.value);
      //console.log('\tmyValue: ' + myValue);


      return /*#__PURE__*/React$1.createElement("div", {
        className: formClass
      }, /*#__PURE__*/React$1.createElement("label", {
        className: myLabelClass,
        htmlFor: this.props.id
      }, label, " ", this.props.info ? /*#__PURE__*/React$1.createElement("i", {
        title: this.props.info,
        className: "fas fa-info-circle"
      }) : null, " "), /*#__PURE__*/React$1.createElement("input", _extends({
        id: this.props.id,
        name: name,
        type: myType,
        value: myValue,
        className: "form-control " + className,
        maxLength: maxlength,
        placeholder: this.props.placeholder,
        onChange: this.onChange,
        disabled: isDisabled,
        min: this.props.minValueAllowed
      }, confProps)), spanDiErrore, messaggioDiErrore);
    }
  }]);

  return ATextInputV4;
}(React$1.PureComponent);

var ACoolTextInputV4 = /*#__PURE__*/function (_React$Component) {
  _inherits(ACoolTextInputV4, _React$Component);

  var _super = _createSuper(ACoolTextInputV4);

  function ACoolTextInputV4(props) {
    var _this;

    _classCallCheck(this, ACoolTextInputV4);

    _this = _super.call(this, props);
    _this.componentName = "[aCoolTextInputV4.jsx] ";
    return _this;
  }

  _createClass(ACoolTextInputV4, [{
    key: "render",
    value: function render() {
      console.log(this.componentName + 'render');
      return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(ATextInputV4, _extends({
        componentClass: "coolComponet",
        labelClass: "coolLabel"
      }, this.props)));
    }
  }]);

  return ACoolTextInputV4;
}(React$1.Component);

var ASelectV4 = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ASelectV4, _React$PureComponent);

  var _super = _createSuper(ASelectV4);

  function ASelectV4(props) {
    var _this;

    _classCallCheck(this, ASelectV4);

    _this = _super.call(this, props);
    _this.selectOnChange = _this.selectOnChange.bind(_assertThisInitialized(_this));
    _this.componentName = "[aSelectV4.jsx]";
    _this.state = {
      errorMessage: null
    };
    return _this;
  }

  _createClass(ASelectV4, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextprops) {
      if (nextprops.maxlength !== undefined && nextprops.maxlength !== null) {
        this.setState({
          errorMessage: nextprops.errorMessage
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(event) {
      this.setState({
        errorMessage: null
      });
    }
  }, {
    key: "selectOnChange",
    value: function selectOnChange(item) {
      console.log(this.componentName + "selectOnChange item= " + item);
      this.props.valueKey || "value";
      this.setState({
        errorMessage: null
      });

      if (this.props.onChange) {
        this.props.onChange(item);
      } // this.onInputChange(Utils.getVal(valKey, item));

    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var messaggioDiErrore = null;
      var spanDiErrore = null;
      var classNameComponent = 'form-group ' + (this.props.classNameComponent === undefined ? "" : this.props.classNameComponent);
      console.log(this.componentName + "classNameComponent [" + classNameComponent + "]");
      var classNameLabel = "" + (this.props.classNameLabel === undefined ? "" : this.props.classNameLabel);
      var classNameSelect = "form-control " + (this.props.classNameSelect === undefined ? "" : this.props.classNameSelect);
      this.props.value;

      var items = this.props.items || [];
      var valueKey = this.props.valueKey || "value";
      var labelKey = this.props.labelKey || "label";
      var label = this.props.label;

      if (this.props.required !== undefined && this.props.required) {
        console.log(this.componentName + "required is true");

        if (label.indexOf('*') === -1) {
          label = label + '*';
        }
      }

      var isDisabled;

      if (this.props.disabled === undefined || this.props.disabled === null || this.props.disabled !== true) {
        isDisabled = false;
      } else {
        isDisabled = true;
      }

      if (this.props.validation !== undefined) {
        //for (var [key, value] of this.props.validation) {
        //  console.log(key + ' = ' + value);
        //}
        //cerco un eventuale messaggio di errore per il mio componente
        var errore = this.props.validation.get(this.props.id); //console.log('Errore: ' + errore);

        if (errore !== undefined) {
          // messaggioDiErrore = <span className="text-danger small">{errore}</span>;

          classNameSelect += " is-invalid";
          messaggioDiErrore = /*#__PURE__*/React__default['default'].createElement("small", {
            className: "invalid-feedback d-block"
          }, /*#__PURE__*/React__default['default'].createElement("i", {
            "aria-hidden": "true",
            className: "fa fa-times"
          }), " ", ' ', errore);
          spanDiErrore = /*#__PURE__*/React__default['default'].createElement("span", {
            className: "glyphicon glyphicon-remove form-control-feedback",
            "aria-hidden": "true"
          });
        }
      }

      if (this.state.errorMessage !== null) {

        messaggioDiErrore = /*#__PURE__*/React__default['default'].createElement("span", {
          className: "text-danger small"
        }, this.state.errorMessage);
        spanDiErrore = /*#__PURE__*/React__default['default'].createElement("span", {
          className: "glyphicon glyphicon-remove form-control-feedback",
          "aria-hidden": "true"
        });
      }

      if (this.props.addEmptyOption === undefined || this.props.addEmptyOption) {
        console.log(this.componentName + "addEmptyOption is true");
        var it = {};
        it[valueKey] = "";
        it[labelKey] = " ";
        it.id = {};
        items = update__default$1['default'](items, {
          $unshift: [it]
        }); // items.unshift(it);
      }

      console.log(this.componentName + 'render [id] ' + this.props.id, items); //console.log("option key [" + item[valueKey] + "] - label [" + item[labelKey] + "]");

      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: classNameComponent
      }, /*#__PURE__*/React__default['default'].createElement("label", {
        className: classNameLabel,
        htmlFor: this.props.id
      }, label), /*#__PURE__*/React__default['default'].createElement("select", {
        className: classNameSelect,
        onChange: this.selectOnChange,
        id: this.props.id,
        name: this.props.name,
        disabled: isDisabled
      }, items === null ? null : items.map(function (item, index) {
        return /*#__PURE__*/React__default['default'].createElement("option", {
          selected: _this2.props.value === item[valueKey],
          key: index,
          value: item[valueKey]
        }, item[labelKey]);
      })), spanDiErrore, messaggioDiErrore);
    }
  }]);

  return ASelectV4;
}(React__default['default'].PureComponent);

var ConfirmModalSaveV4 = /*#__PURE__*/function (_React$Component) {
  _inherits(ConfirmModalSaveV4, _React$Component);

  var _super = _createSuper(ConfirmModalSaveV4);

  function ConfirmModalSaveV4(props) {
    var _this;

    _classCallCheck(this, ConfirmModalSaveV4);

    _this = _super.call(this, props);
    _this.componentName = '[ConfirmModalSaveV4.jsx] ';
    _this.state = {};
    return _this;
  }

  _createClass(ConfirmModalSaveV4, [{
    key: "render",
    value: function render() {
      console.log(this.componentName + "render");
      return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(ConfirmModalOkCancelV4, {
        id: "close",
        show: this.props.show,
        className: 'modal-dialog-centered'
      }, /*#__PURE__*/React$1.createElement(ConfirmModalOkCancelV4.Header, {
        className: this.props.classNameHeader,
        classNameTitle: this.props.classNameTitle,
        testoTitle: this.props.testoTitle !== undefined && this.props.testoTitle !== null ? this.props.testoTitle : "Salva",
        id: this.props.id,
        onClose: this.props.onClose
      }), /*#__PURE__*/React$1.createElement(ConfirmModalOkCancelV4.Body, {
        className: this.props.classNameBody,
        classNameTesto: this.props.classNameTesto,
        testoBody: this.props.testoBody !== undefined && this.props.testoBody !== null ? this.props.testoBody : "Confermi di voler salvare?"
      }), /*#__PURE__*/React$1.createElement(ConfirmModalOkCancelV4.Footer, {
        className: this.props.classNameFooter,
        IdConfirm: this.props.IdConfirm,
        classNameTestoButtonConfirm: "btn btn-success",
        classNameIconConfirm: this.props.classNameIconConfirm,
        testoButtonConfirm: "Salva",
        IdCancel: this.props.IdCancel,
        classNameTestoButtonCancel: this.props.classNameTestoButtonCancel,
        classNameIconCancel: this.props.classNameIconCancel,
        testoButtonCancel: this.props.testoButtonCancel,
        confirmOnClick: this.props.saveOnClick,
        onClose: this.props.onClose
      })));
    }
  }]);

  return ConfirmModalSaveV4;
}(React$1.Component);

var ConfirmModalV4 = /*#__PURE__*/function (_React$Component) {
  _inherits(ConfirmModalV4, _React$Component);

  var _super = _createSuper(ConfirmModalV4);

  function ConfirmModalV4(props) {
    var _this;

    _classCallCheck(this, ConfirmModalV4);

    _this = _super.call(this, props);
    _this.okFunction = _this.okFunction.bind(_assertThisInitialized(_this));
    _this.koFunction = _this.koFunction.bind(_assertThisInitialized(_this));
    _this.state = {
      pulsanteOK: "SI",
      pulsanteKO: "NO"
    };
    return _this;
  }

  _createClass(ConfirmModalV4, [{
    key: "okFunction",
    value: function okFunction() {
      console.log('[ConfirmModal]: okFunction: ');

      if (typeof this.props.okFunction === 'function') {
        this.props.okFunction();
      }
    }
  }, {
    key: "koFunction",
    value: function koFunction() {
      console.log('[ConfirmModal]: koFunction: ');

      if (typeof this.props.koFunction === 'function') {
        this.props.koFunction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React$1.createElement("div", {
        id: this.props.id,
        className: "modal",
        tabIndex: "-1",
        role: "dialog",
        "aria-labelledby": "myModalLabel",
        "aria-hidden": "true"
      }, /*#__PURE__*/React$1.createElement("div", {
        className: "modal-dialog",
        role: "document"
      }, /*#__PURE__*/React$1.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React$1.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React$1.createElement("h4", {
        className: "modal-title",
        id: "myModalLabel"
      }, this.props.titolo), /*#__PURE__*/React$1.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal",
        "aria-label": "Close"
      }, /*#__PURE__*/React$1.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React$1.createElement("div", {
        className: "modal-body"
      }, this.props.testo !== null && this.props.testo !== undefined ? /*#__PURE__*/React$1.createElement("h4", null, this.props.testo) : null, this.props.content !== null && this.props.content !== undefined ? /*#__PURE__*/React$1.createElement("div", null, this.props.content) : null), /*#__PURE__*/React$1.createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/React$1.createElement("div", {
        className: "float-left"
      }, /*#__PURE__*/React$1.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        "data-dismiss": "modal",
        style: {
          marginRight: 350
        },
        onClick: this.okFunction
      }, this.props.pulsanteOK ? this.props.pulsanteOK : "SI")), /*#__PURE__*/React$1.createElement("button", {
        type: "button",
        className: "btn btn-secondary",
        "data-dismiss": "modal",
        onClick: this.koFunction
      }, this.props.pulsanteKO ? this.props.pulsanteKO : "NO")))));
    }
  }]);

  return ConfirmModalV4;
}(React$1.Component);

/**
 * @augments {Component<{show: boolean, width:string, marginRight: string, marginLeft:string, marginBottom: string, marginTop: string}, State>}
 */

var ModalOkCancelV4 = /*#__PURE__*/function (_Component) {
  _inherits(ModalOkCancelV4, _Component);

  var _super = _createSuper(ModalOkCancelV4);

  function ModalOkCancelV4(props) {
    _classCallCheck(this, ModalOkCancelV4);

    return _super.call(this, props);
  }

  _createClass(ModalOkCancelV4, [{
    key: "render",
    value: function render() {
      if (!this.props.show) return null;
      return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal d-block"
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-dialog " + (this.props.className ? " " + this.props.className : "")
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-content"
      }, this.props.children))), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-backdrop show"
      }));
    }
  }]);

  return ModalOkCancelV4;
}(React$1.Component);
/**
 * @augments {Component<{onClose: function}, State>}
 */


var Header$3 = /*#__PURE__*/function (_Component2) {
  _inherits(Header, _Component2);

  var _super2 = _createSuper(Header);

  function Header() {
    _classCallCheck(this, Header);

    return _super2.apply(this, arguments);
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-header " + (this.props.className ? this.props.className : "")
      }, this.props.children, /*#__PURE__*/React__default['default'].createElement("h5", {
        className: "modal-title" + (this.props.classNameTitle ? " " + this.props.classNameTitle : "")
      }, this.props.testoTitle !== undefined && this.props.testoTitle !== null ? this.props.testoTitle : "Conferma"), /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        className: "close",
        id: this.props.id,
        onClick: this.props.onClose
      }, /*#__PURE__*/React__default['default'].createElement("span", null, "\xD7")));
    }
  }]);

  return Header;
}(React$1.Component);
/**
 * @augments {Component<{maxHeight: string}, State>}
 */


var Body$3 = /*#__PURE__*/function (_Component3) {
  _inherits(Body, _Component3);

  var _super3 = _createSuper(Body);

  function Body() {
    _classCallCheck(this, Body);

    return _super3.apply(this, arguments);
  }

  _createClass(Body, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-body" + (this.props.className ? " " + this.props.className : "")
      }, this.props.children, /*#__PURE__*/React__default['default'].createElement("h5", {
        className: "modal-title" + (this.props.classNameTesto ? " " + this.props.classNameTesto : "")
      }, this.props.testoBody !== undefined && this.props.testoBody !== null ? this.props.testoBody : "Confermi di voler procedere ?"));
    }
  }]);

  return Body;
}(React$1.Component);
/**
 * @augments {Component<{}, State>}
 */


var Footer$3 = /*#__PURE__*/function (_Component4) {
  _inherits(Footer, _Component4);

  var _super4 = _createSuper(Footer);

  function Footer() {
    _classCallCheck(this, Footer);

    return _super4.apply(this, arguments);
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _React$createElement;
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "modal-footer d-flex justify-content-between" + (this.props.className ? " " + this.props.className : "")
      }, /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        id: this.props.IdConfirm,
        className: "btn btn-primary" + (this.props.classNameTestoButtonConfirm ? " " + this.props.classNameTestoButtonConfirm : ""),
        onClick: this.props.confirmOnClick
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        className: this.props.classNameIconConfirm ? this.props.classNameIconConfirm : "fas fa-save "
      }), " ", this.props.testoButtonConfirm !== undefined ? " " + this.props.testoButtonConfirm : " Conferma"), this.props.children, /*#__PURE__*/React__default['default'].createElement("button", (_React$createElement = {
        type: "button",
        id: this.props.IdCancel,
        className: "btn btn-secondary" + (this.props.classNameTestoButtonCancel ? " " + this.props.classNameTestoButtonConfirm : ""),
        "data-dismiss": "modal"
      }, _defineProperty(_React$createElement, "id", "close"), _defineProperty(_React$createElement, "onClick", this.props.onClose), _React$createElement), /*#__PURE__*/React__default['default'].createElement("i", {
        className: this.props.classNameIconCancel ? this.props.classNameIconCancel : "far fa-times-circle "
      }), " ", this.props.testoButtonCancel !== undefined ? " " + this.props.testoButtonCancel : " Annulla"));
    }
  }]);

  return Footer;
}(React$1.Component);

ModalOkCancelV4.Header = Header$3;
ModalOkCancelV4.Body = Body$3;
ModalOkCancelV4.Footer = Footer$3;

var aToggleV4 = function aToggleV4(props) {
  // constructor(props) {
  //     super(props);
  //     onChange = onChange.bind(this);
  // }
  var onChangeHandler = function onChangeHandler(e) {
    if (props.onChange) props.onChange(e, props.value);
  };

  var children = props.children,
      id = props.id,
      label = props.label,
      checked = props.checked;
      props.onChange;
      var disabled = props.disabled,
      name = props.name,
      type = props.type,
      value = props.value,
      statusIcon = props.statusIcon;
  if (children && !label) label = children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "custom-control custom-" + (type === "radio" ? "radio" : "checkbox")
  }, /*#__PURE__*/React__default['default'].createElement("input", {
    type: type === "radio" ? "radio" : "checkbox",
    onChange: onChangeHandler,
    id: id,
    checked: checked ? true : false,
    className: "custom-control-input",
    disabled: disabled,
    name: name,
    value: value ? value : ""
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    htmlFor: id,
    className: "custom-control-label"
  }, statusIcon ? /*#__PURE__*/React__default['default'].createElement("i", {
    className: "status-icon fa fa-circle text-" + statusIcon
  }) : null, label ? label : ""));
};

function aCardV4Header(props) {
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'card-header text-left title ' + (props.className ? props.className : '') + (props.loading ? " loading-card-header" : "")
  }, props.loading && /*#__PURE__*/React$1.createElement("div", {
    className: "loading-header"
  }, /*#__PURE__*/React$1.createElement("i", {
    className: "fa fa-spinner fa-pulse"
  })), props.children);
}

function aCardV4Filter(props) {
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'card-filter ' + (props.className ? props.className : '') + (props.loading ? " loading-card-filter" : "")
  }, props.loading && /*#__PURE__*/React$1.createElement("div", {
    className: "loading-filter"
  }, /*#__PURE__*/React$1.createElement("i", {
    className: "fa fa-spinner fa-pulse"
  })), props.title && /*#__PURE__*/React$1.createElement("h3", {
    className: "card-filter-title"
  }, props.title), props.children);
}

function aCardV4Body(props) {
  return /*#__PURE__*/React$1.createElement("div", {
    title: props.title,
    className: 'card-body ' + (props.className ? props.className : ''),
    style: props.style
  }, props.children, " ");
}

function aCardV4Footer(props) {
  return /*#__PURE__*/React$1.createElement("div", {
    className: "card-footer"
  }, props.children);
}

var aCardV4 = function aCardV4(props) {
  // constructor(props) {
  //     super(props);
  //     state = {
  //     }
  // }
  //console.log("aCardV4 render");
  return /*#__PURE__*/React$1.createElement("div", {
    className: 'card ' + (props.className ? props.className : '')
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "loading-card",
    style: {
      display: props.loading ? 'block' : 'none'
    }
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "spinner-balls"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "bounce1"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "bounce2"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "bounce3"
  }))), props.children);
};

/** 
 * panel component
 * proprerties supported:
 * 
*/

var aToolbarV4 = function aToolbarV4() {
  // static propTypes = {
  //     id: t.string,
  //     children: t.node
  // }
  // static defaultProps = {
  // }
  // static Left = function (props) {
  //     return (<span />);
  // }
  // static Right = function (props) {
  //     return (<span />);
  // }
  // static Brand = function (props) {
  //     return (<span />);
  // }
  // static Search = function (props) {
  //     return (<span />);
  // }
  console.log("[aToolbarV4] render");
  var _props2 = props,
      id = _props2.id,
      className = _props2.className,
      children = _props2.children,
      sub = _props2.sub;
      _props2.eventParam;
      _props2.onClick;

  var _props = ___default['default'].omit(props, 'id', 'className', 'eventParam', 'onClick', "children", "sub");

  id = id || Utils.Utils.uuid("tb");
  var toLeft = [];
  var toRight = [];
  var toBrand = null;
  var toSearch = null;
  var others = [];
  React__default['default'].Children.forEach(children, function (child) {
    if (!child || child.props.visible === false) {
      console.log(" child.props.visible === false");
      return;
    }

    if (child.type === aToolbarV4.Left) {
      var l = {};
      l.key = "left_" + (toLeft.length + 1);
      l.onClick = child.props.onClick;
      l.noLink = !child.props.onClick || child.props.noLink;
      l.className = child.props.className;
      l.eventParam = child.props.eventParam;
      l.disabled = child.props.disabled;
      l.children = child.props.children;

      if (l.eventParam && l.onClick) {
        var _onc = l.onClick;

        l.onClick = function (e) {
          _onc(e, l.eventParam);
        };
      }

      toLeft.push(l);
    } else if (child.type === aToolbarV4.Right) {
      var r = {};
      r.key = "right_" + (toRight.length + 1);
      r.onClick = child.props.onClick;
      r.noLink = !child.props.onClick || child.props.noLink;
      r.className = child.props.className;
      r.eventParam = child.props.eventParam;
      r.disabled = child.props.disabled;
      r.children = child.props.children;

      if (r.eventParam && r.onClick) {
        var _onc2 = r.onClick;

        r.onClick = function (e) {
          _onc2(e, r.eventParam);
        };
      }

      toRight.push(r);
    } else if (child.type === aToolbarV4.Brand) {
      var b = {};
      b.onClick = child.props.onClick;
      b.noLink = !child.props.onClick || child.props.noLink;
      b.className = child.props.className;
      b.eventParam = child.props.eventParam;
      b.children = child.props.children;

      if (b.eventParam && b.onClick) {
        var _onc3 = b.onClick;

        b.onClick = function (e) {
          _onc3(e, b.eventParam);
        };
      }

      toBrand = b;
    } else if (child.type === aToolbarV4.Search) {
      var s = {};
      s.className = child.props.className;
      s.children = child.props.children;
      toSearch = s;
    } else {
      child.key = "ot_" + (others.length + 1);
      others.push(child);
    }
  });

  if (toLeft.length === 0) {
    toLeft = null;
  }

  if (toRight.length === 0) {
    toRight = null;
  }

  if (others.length === 0) {
    others = null;
  }

  var hasNb = toLeft || toRight || toSearch || others;
  var idnb = '' + id + '__nb'; // TODO label in i18n

  var subelements = [];

  if (hasNb) {
    subelements.push( /*#__PURE__*/React__default['default'].createElement("button", {
      key: subelements.length,
      className: "navbar-toggler navbar-toggler-right",
      type: "button",
      "data-toggle": "collapse",
      "data-target": '#' + idnb,
      "aria-controls": idnb,
      "aria-expanded": "false",
      "aria-label": "Apri/chiudi elementi navigazione"
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      className: "navbar-toggler-icon"
    })));
  }

  if (toBrand) {
    subelements.push( /*#__PURE__*/React__default['default'].createElement("a", {
      key: subelements.length,
      className: Utils.Utils.union('navbar-brand', ' ', toBrand.className),
      onClick: toBrand.onClick,
      href: "javascript:;"
    }, toBrand.children));
  }

  if (hasNb) {
    subelements.push( /*#__PURE__*/React__default['default'].createElement("div", {
      key: subelements.length,
      className: "collapse navbar-collapse",
      id: idnb
    }, toLeft && /*#__PURE__*/React__default['default'].createElement("ul", {
      className: "navbar-nav mr-auto lefts"
    }, toLeft.map(function (item, index) {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: index,
        className: "nav-item"
      }, item.noLink && /*#__PURE__*/React__default['default'].createElement("span", {
        className: Utils.Utils.union('nav-no-link', ' ', item.className)
      }, item.children), !item.noLink && /*#__PURE__*/React__default['default'].createElement("a", {
        "data-text": item.children,
        className: Utils.Utils.union('nav-link', ' ', item.className),
        onClick: item.onClick,
        disabled: item.disabled,
        href: item.path ? item.path : 'javascript:;'
      }, item.children));
    })), others && others.map(function (child) {
      return {
        child: child
      };
    }), (toSearch || toRight) && /*#__PURE__*/React__default['default'].createElement("form", {
      className: "form-inline my-2 my-lg-0",
      autoComplete: "off",
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }, /*#__PURE__*/React__default['default'].createElement("ul", {
      className: "navbar-nav mr-auto"
    }, toRight && toRight.map(function (item) {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: item.key,
        className: "nav-item"
      }, item.noLink && /*#__PURE__*/React__default['default'].createElement("span", {
        className: Utils.Utils.union('nav-no-link', ' ', item.className)
      }, item.children), !item.noLink && /*#__PURE__*/React__default['default'].createElement("a", {
        className: Utils.Utils.union('nav-link', ' ', item.className),
        onClick: item.onClick,
        disabled: item.disabled,
        href: "javascript:;"
      }, item.children));
    }), toSearch && /*#__PURE__*/React__default['default'].createElement("li", {
      className: "nav-item search-form"
    }, toSearch.children)))));
  }

  var ss;

  if (sub) {
    ss = /*#__PURE__*/React__default['default'].createElement("div", {
      className: sub
    }, subelements);
  } else {
    ss = subelements;
  }

  var navbar;
  navbar = /*#__PURE__*/React__default['default'].createElement("nav", _extends({
    id: id,
    className: Utils.Utils.union("aNavbar navbar navbar-expand-lg navbar-light bg-light", " ", className)
  }, _props), ss);
  return navbar;
}; // end class


var Left$1 = function Left() {
  return;
};

var Right$1 = function Right() {
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("span", null));
};

var Brand$1 = function Brand() {
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("span", null));
};

var Search$1 = function Search() {
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("span", null));
};

aToolbarV4.Left = Left$1;
aToolbarV4.Right = Right$1;
aToolbarV4.Brand = Brand$1;
aToolbarV4.Search = Search$1;

var agui = {
  version: pckg.version,
  aButton: aButton,
  aFieldset: aFieldset,
  aTextInput: aTextInput,
  NumberInput: NumberInput,
  aDateInput: aDateInput,
  aDiv: aDiv,
  aBreadCrumbs: aBreadCrumbs,
  aToolbar: aToolbar,
  aFooter: aFooter,
  aStoreInfo: aStoreInfo,
  aSelect: aSelect,
  aSelectV2: aSelectV2,
  aCard: aCard,
  aCardHeader: aCardHeader,
  aCardDetailsHeader: aCardDetailsHeader,
  aCardFilter: aCardFilter,
  aCardBody: aCardBody,
  aCardFooter: aCardFooter,
  ConfirmModalOkCancelV4: ConfirmModalOkCancelV4,
  Modalv4: Modalv4,
  ACoolTextInputV4: ACoolTextInputV4,
  ASelectV4: ASelectV4,
  ATextInputV4: ATextInputV4,
  ConfirmModalSaveV4: ConfirmModalSaveV4,
  ConfirmModalV4: ConfirmModalV4,
  ModalOkCancelV4: ModalOkCancelV4,
  aToolbarV4: aToolbarV4,
  aCardV4: aCardV4,
  aCardV4Header: aCardV4Header,
  aCardV4Body: aCardV4Body,
  aCardV4Footer: aCardV4Footer,
  aCardV4Filter: aCardV4Filter,
  aToggleV4: aToggleV4,
  aCollapse: aCollapse,
  aCollapseItem: aCollapseItem,
  CoolNumberInput: CoolNumberInput,
  CoolTextInput: CoolTextInput,
  CoolTextArea: CoolTextArea,
  CoolDateInput: CoolDateInput,
  CoolSelectOld: CoolSelectOld,
  CoolSelect: CoolSelect,
  CoolInputContainer: CoolInputContainer,
  CoolDateTimeInput: CoolDateTimeInput,
  PopupFormModal: PopupFormModal,
  PopupBody: PopupBody,
  PopupFooter: PopupFooter,
  PopupHeader: PopupHeader,
  PopupDialog: PopupDialog,
  PopupModal: PopupModal$1,
  PopupMenu: PopupMenu,
  PopupResponsive: PopupResponsive,
  CoolGrid: CoolGrid,
  aDataGrid: aDataGrid,
  aTable: aTable,
  aPaginator: aPaginator,
  CoolGridServerPaged: CoolGridServerPaged,
  aPageTitleBar: aPageTitleBar,
  aIcon: aIcon,
  MainMenu: MainMenu,
  MenuItem: MenuItem,
  ExcelExportButton: ExcelExportButton,
  aCardTopBar: aCardTopBar,
  aCardDetail: aCardDetail,
  AskConfirm: AskConfirm,
  Sidebar: Sidebar,
  SidebarItem: SidebarItem,
  ProgressBar: ProgressBar,
  InputRange: InputRange,
  ContentsBar: Contents,
  aToggle: aToggle,
  aSwitch: aSwitch,
  CoolCheckBox: CoolCheckBox,
  CoolProgressBar: CoolProgressBar,
  Accordion: Accordion,
  AccordionFooter: AccordionFooter,
  AccordionHeader: AccordionHeader,
  AccordionBody: AccordionBody,
  CoolGroupSelector: CoolGroupSelector,
  LineBar: LineBar,
  LineBarGroup: LineBarGroup,
  Cellify: Cellify
};

exports.ACoolTextInputV4 = ACoolTextInputV4;
exports.ASelectV4 = ASelectV4;
exports.ATextInputV4 = ATextInputV4;
exports.Accordion = Accordion;
exports.AccordionBody = AccordionBody;
exports.AccordionFooter = AccordionFooter;
exports.AccordionHeader = AccordionHeader;
exports.AskConfirm = AskConfirm;
exports.Cellify = Cellify;
exports.ConfirmModalOkCancelV4 = ConfirmModalOkCancelV4;
exports.ConfirmModalSaveV4 = ConfirmModalSaveV4;
exports.ConfirmModalV4 = ConfirmModalV4;
exports.ContentsBar = Contents;
exports.CoolCheckBox = CoolCheckBox;
exports.CoolDateInput = CoolDateInput;
exports.CoolDateTimeInput = CoolDateTimeInput;
exports.CoolGrid = CoolGrid;
exports.CoolGridServerPaged = CoolGridServerPaged;
exports.CoolGroupSelector = CoolGroupSelector;
exports.CoolInputContainer = CoolInputContainer;
exports.CoolNumberInput = CoolNumberInput;
exports.CoolProgressBar = CoolProgressBar;
exports.CoolSelect = CoolSelect;
exports.CoolSelectOld = CoolSelectOld;
exports.CoolTextArea = CoolTextArea;
exports.CoolTextInput = CoolTextInput;
exports.ExcelExportButton = ExcelExportButton;
exports.InputRange = InputRange;
exports.LineBar = LineBar;
exports.LineBarGroup = LineBarGroup;
exports.MainMenu = MainMenu;
exports.MenuItem = MenuItem;
exports.ModalOkCancelV4 = ModalOkCancelV4;
exports.Modalv4 = Modalv4;
exports.NumberInput = NumberInput;
exports.PopupBody = PopupBody;
exports.PopupDialog = PopupDialog;
exports.PopupFooter = PopupFooter;
exports.PopupFormModal = PopupFormModal;
exports.PopupHeader = PopupHeader;
exports.PopupMenu = PopupMenu;
exports.PopupModal = PopupModal$1;
exports.PopupResponsive = PopupResponsive;
exports.ProgressBar = ProgressBar;
exports.Sidebar = Sidebar;
exports.SidebarItem = SidebarItem;
exports.aBreadCrumbs = aBreadCrumbs;
exports.aButton = aButton;
exports.aCard = aCard;
exports.aCardBody = aCardBody;
exports.aCardDetail = aCardDetail;
exports.aCardDetailsHeader = aCardDetailsHeader;
exports.aCardFilter = aCardFilter;
exports.aCardFooter = aCardFooter;
exports.aCardHeader = aCardHeader;
exports.aCardTopBar = aCardTopBar;
exports.aCardV4 = aCardV4;
exports.aCardV4Body = aCardV4Body;
exports.aCardV4Filter = aCardV4Filter;
exports.aCardV4Footer = aCardV4Footer;
exports.aCardV4Header = aCardV4Header;
exports.aCollapse = aCollapse;
exports.aCollapseItem = aCollapseItem;
exports.aDataGrid = aDataGrid;
exports.aDateInput = aDateInput;
exports.aDiv = aDiv;
exports.aFieldset = aFieldset;
exports.aFooter = aFooter;
exports.aIcon = aIcon;
exports.aPageTitleBar = aPageTitleBar;
exports.aPaginator = aPaginator;
exports.aSelect = aSelect;
exports.aSelectV2 = aSelectV2;
exports.aStoreInfo = aStoreInfo;
exports.aSwitch = aSwitch;
exports.aTable = aTable;
exports.aTextInput = aTextInput;
exports.aToggle = aToggle;
exports.aToggleV4 = aToggleV4;
exports.aToolbar = aToolbar;
exports.aToolbarV4 = aToolbarV4;
exports.default = agui;
//# sourceMappingURL=index.js.map
